<template style="font-family: IRANSans">
  <div class="wrapper">
    <!-- data Table -->
    <div v-if="showPage">
      <CRow>
        <CCol col="12" xl="12">
          <CCard class="p-0">
            <CCardHeader
              class="d-flex justify-content-between align-items-center bg-secondary"
            >
              <h5 class="text-light m-0 p-0">دستگاه‌ها</h5>
              <!-- <CRow class="col-sm-7 col-md-5 col-lg-3"> -->
              <CButton
                color="light"
                @click="
                  addModal = true;
                  modalTitle = 'افزودن دستگاه';
                  modalButtonSubmit = 'ثبت';
                  //GetOrganizationalStructureTree();
                  restoreDefault();
                  showMap();
                "
                class="mr-1"
              >
                <CIcon name="cil-plus" /> افزودن
              </CButton>
              <!-- <CButton
                  color="warning"
                  @click="reportPage('deviceList')"
                  class="mr-1 col"
                >
                  <CIcon name="cil-print" /> گزارش
                </CButton> -->
              <!-- </CRow> -->
            </CCardHeader>
            <CCardBody class="m-0 p-0">
              <CCard>
                <CButton
                  block
                  class="text-right shadow-none bg-warning card-header"
                  @click="showFilter = showFilter === 6 ? false : 6"
                >
                  <h5 class="text-primary">
                    <CIcon
                      :name="
                        showFilter == 0
                          ? 'cil-chevron-bottom'
                          : 'cil-chevron-top'
                      "
                    />
                    فیلتر
                  </h5>
                </CButton>
                <CCollapse :show="showFilter === 6">
                  <CCardBody>
                    <CRow>
                      <v-jstree
                        class="my-2"
                        :data="structureListFillter"
                        show-checkbox
                        allow-batch
                        whole-row
                        noDots
                        allow-empty
                        @item-click="setFillter"
                      ></v-jstree>
                    </CRow>
                    <!-- <CRow>
                      <CButton
                        @click="getAlarms()"
                        class="
                          mt-4
                          mb-3
                          btn-success
                          col-12
                        "
                        ><CIcon
                          name="cil-check-circle"
                          class="text-light align-self-center"
                      /></CButton>
                    </CRow> -->
                  </CCardBody>
                </CCollapse>
              </CCard>
              <div id="app">
                <!--dir="ltr" class="text-left" -->
                <!-- <link
                  href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
                  rel="stylesheet"
                  integrity="sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN"
                  crossorigin="anonymous"
                /> -->
                <main>
                  <data-table
                    v-bind="parametersTable"
                    @actionTriggered="handleAction"
                  />
                </main>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>

    <!----------------------------------------------------------------------- create and edit device modal -->
    <CModal
      :title="modalTitle"
      :show.sync="addModal"
      size="xl"
      :close-on-backdrop="false"
    >
      <CForm class="needs-validation" novalidate>
        <CAlert color="warning" closeButton :show.sync="alert">
          {{ alertText }}
        </CAlert>
        <h5 class="text-primary mb-3">اطلاعات عمومی</h5>
        <hr />
        <CRow>
          <CCol>
            <CRow>
              <CInput
                class="col-sm-12 col-lg-6 text-right"
                label="نام"
                v-model="info.name"
                required
                :value="info.name"
                dir="ltr"
              />
              <div class="col-sm-12 col-lg-6">
                <label class="typo__label">مدل</label>
                <multiselect
                  class="needs-validation"
                  v-model="info.ModelValue"
                  :options="ModelList"
                  :searchable="true"
                  :allow-empty="false"
                  :close-on-select="true"
                  :show-labels="false"
                  placeholder="انتخاب..."
                  label="label"
                  track-by="value"
                  :disabled="disableMultiselect"
                ></multiselect>
              </div>

              <div class="col-sm-12 col-lg-6">
                <label class="typo__label">نوع دستگاه</label>
                <multiselect
                  class="needs-validation"
                  v-model="info.deviceType"
                  :options="deviceTypeList"
                  :searchable="true"
                  :allow-empty="false"
                  :close-on-select="true"
                  :show-labels="false"
                  placeholder="انتخاب..."
                  label="label"
                  track-by="value"
                  :disabled="disableMultiselect"
                ></multiselect>
              </div>

              <div class="col-sm-12 col-lg-6">
                <label class="typo__label">ارسال گزارش روزانه</label>
                <multiselect
                  class="needs-validation"
                  v-model="info.dailyReportSend"
                  :options="dailyReportSendList"
                  :searchable="true"
                  :allow-empty="false"
                  :close-on-select="true"
                  :show-labels="false"
                  placeholder="انتخاب..."
                  label="label"
                  track-by="value"
                  :disabled="disableMultiselect"
                ></multiselect>
              </div>

              <div class="col-sm-12 col-lg-6 form-group">
                <label class="typo__label">وضعیت</label>
                <multiselect
                  class="needs-validation"
                  v-model="info.status"
                  :options="StatusList"
                  :allow-empty="false"
                  :searchable="true"
                  :close-on-select="true"
                  :show-labels="false"
                  placeholder="انتخاب..."
                  label="label"
                  track-by="value"
                  :disabled="disableMultiselect"
                ></multiselect>
              </div>

              <div class="col-sm-12 col-lg-6 form-group">
                <label class="typo__label">دوره بروزرسانی</label>
                <multiselect
                  class="needs-validation"
                  v-model="info.periodicUpdateTimeValue"
                  :options="periodicUpdateTime"
                  :allow-empty="false"
                  :searchable="true"
                  :close-on-select="true"
                  :show-labels="false"
                  placeholder="انتخاب..."
                  label="label"
                  track-by="value"
                  :disabled="disableMultiselect"
                ></multiselect>
              </div>

              <CInput
                class="col-sm-12 col-lg-6"
                label="شماره سیم کارت"
                v-model="info.simcardNum"
                :value="info.simcardNum"
                placeholder="نمونه (4565***0912)"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                type="number"
                maxlength="11"
              />

              <CInput
                class="col-sm-12 col-lg-6"
                label="گیرنده اول"
                v-model="smsReception.first"
                :value="smsReception.first"
                placeholder="نمونه (4565***0912)"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                type="number"
                maxlength="11"
              />

              <CInput
                class="col-sm-12 col-lg-6"
                label="گیرنده دوم"
                v-model="smsReception.second"
                :value="smsReception.second"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                type="number"
                maxlength="11"
              />

              <CInput
                class="col-sm-12 col-lg-6"
                label="گیرنده سوم"
                v-model="smsReception.third"
                :value="smsReception.third"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                type="number"
                maxlength="11"
              />

              <CInput
                class="col-sm-12 col-lg-6"
                label="گیرنده چهارم"
                v-model="smsReception.forth"
                :value="smsReception.forth"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                type="number"
                maxlength="11"
              />

              <CInput
                class="col-sm-12 col-lg-6"
                label="گیرنده پنجم"
                v-model="smsReception.fifth"
                :value="smsReception.fifth"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                type="number"
                maxlength="11"
              />

              <CInput
                class="col-sm-12 col-lg-6"
                label="گیرنده ششم"
                v-model="smsReception.sixth"
                :value="smsReception.sixth"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                type="number"
                maxlength="11"
              />

              <div class="col-sm-12 col-lg-6 form-group">
                <CButton
                  color="info"
                  class="col-12 rounded d-flex justify-content-between"
                  @click="show_icon = !show_icon"
                >
                  آیکن <i :class="selectedIcon" aria-hidden="true"></i
                ></CButton>
              </div>

              <CRow v-if="show_icon">
                <CInput
                  class="col-12 m-2"
                  placeholder="جستجو..."
                  required
                  v-model="searchIconValue"
                  :value="searchIconValue"
                  @input="searchIcon(searchIconValue)"
                />
                <i
                  v-for="(item, i) in is_search_icon
                    ? filteredListIcon
                    : iconList"
                  :key="i"
                  :class="'fa ' + item.value"
                  class="col-1 m-2"
                  aria-hidden="true"
                  @click="
                    show_icon = !show_icon;
                    selectedIcon = item.value;
                    setIcon(item);
                  "
                ></i>
              </CRow>
            </CRow>

            <CRow
              v-if="
                info.ModelValue.value == 'Navgan' ||
                info.ModelValue.value == 'Navgan2' ||
                info.ModelValue.value == 'Navgan3' ||
                info.ModelValue.value == 'Tracking'
              "
            >
              <CInput
                class="col-sm-12 col-lg-6"
                label="کیلومتر جاری"
                v-model="info.currentKilometer"
                required
                :value="info.currentKilometer"
                type="number"
              />
            </CRow>

            <CRow
              v-if="
                info.ModelValue.value == 'Navgan' ||
                info.ModelValue.value == 'Navgan2' ||
                info.ModelValue.value == 'Navgan3' ||
                info.ModelValue.value == 'Tracking'
              "
            >
              <CInput
                class="col-sm-12 col-lg-6"
                label="نام راننده"
                v-model="info.driver"
                required
                :value="info.driver"
              />
              <CCardGroup class="col-sm-12 col-lg-6">
                <CInput
                  placeholder="ایرانXX"
                  class="col-sm-3 p-0"
                  label="پلاک"
                  required
                  type="number"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  v-model="info.registrationPlate4"
                  :value="info.registrationPlate4"
                  maxlength="2"
                />
                <CInput
                  placeholder="XXX"
                  class="col-sm-4 mt-2 p-0"
                  label=" "
                  required
                  type="number"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  v-model="info.registrationPlate3"
                  :value="info.registrationPlate3"
                  maxlength="3"
                />
                <CSelect
                  class="col-sm-2 mt-2 p-0"
                  label="      "
                  required
                  :options="LetterList"
                  placeholder="انتخاب..."
                  :value="info.registrationPlate2"
                  @change="setLetter($event)"
                />
                <CInput
                  placeholder="XX"
                  class="col-sm-3 mt-2 p-0"
                  label=" "
                  required
                  type="number"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  v-model="info.registrationPlate1"
                  :value="info.registrationPlate1"
                  maxlength="2"
                  minlength="2"
                />
              </CCardGroup>
            </CRow>

            <CRow v-if="info.ModelValue.length == 0"></CRow>

            <CRow v-else>
              <CInput
                v-if="info.ModelValue.value != 'FDA'"
                class="col-sm-12 col-lg-6"
                label="سریال"
                required
                v-model="info.serial"
                :value="info.serial"
                :maxlength="
                  info.ModelValue.value == 'Navgan2' ||
                  info.ModelValue.value == 'Tracking'
                    ? 10
                    : info.ModelValue.value == 'Navgan3'
                    ? 20
                    : 4
                "
              />

              <CInput
                v-if="info.ModelValue.value != 'FDA'"
                class="col-sm-12 col-lg-6"
                label="رمزعبور"
                required
                v-model="info.password"
                :value="info.password"
                maxlength="4"
              />

              <div
                class="col-sm-12 col-lg-6 mb-3"
                v-if="info.ModelValue.value != 'FDA'"
              >
                <label class="typo__label">نوع شبکه</label>
                <multiselect
                  class="needs-validation"
                  v-model="info.networkValue"
                  :options="networkList"
                  :searchable="true"
                  :allow-empty="false"
                  :close-on-select="true"
                  :show-labels="false"
                  placeholder="انتخاب..."
                  label="label"
                  track-by="value"
                  :disabled="disableMultiselect"
                  multiple
                ></multiselect>
              </div>

              <div
                class="col-sm-12 col-lg-6 mb-3"
                v-if="info.ModelValue.value != 'FDA'"
              >
                <label class="typo__label">شبکه پیش فرض</label>
                <multiselect
                  class="needs-validation"
                  v-model="info.defaultNetworkValue"
                  :options="networkList"
                  :searchable="true"
                  :allow-empty="false"
                  :close-on-select="true"
                  :show-labels="false"
                  placeholder="انتخاب..."
                  label="label"
                  track-by="value"
                  :disabled="disableMultiselect"
                ></multiselect>
              </div>

              <CRow
                v-if="info.ModelValue.value == 'FreezEyeV5'"
                class="m-0 p-0"
              >
                <CInput
                  class="col-sm-12 col-lg-6"
                  label="نام سنسور اول"
                  v-model="info.firstSensor"
                  required
                  :value="info.firstSensor"
                />

                <CInput
                  class="col-sm-12 col-lg-6"
                  label="نام سنسور دوم"
                  required
                  v-model="info.secondSensor"
                  :value="info.secondSensor"
                />

                <CInput
                  class="col-sm-12 col-lg-6"
                  label="نام سنسور سوم"
                  required
                  v-model="info.thirdSensor"
                  :value="info.thirdSensor"
                />
              </CRow>

              <CRow v-if="info.ModelValue.value == 'ICH88IPV3'" class="m-0 p-0">
                <CInput
                  class="col-sm-12 col-lg-6"
                  label="نام سنسور اول"
                  v-model="info.firstSensor"
                  required
                  :value="info.firstSensor"
                />

                <CInput
                  class="col-sm-12 col-lg-6"
                  label="نام سنسور دوم"
                  required
                  v-model="info.secondSensor"
                  :value="info.secondSensor"
                />

                <CInput
                  class="col-sm-12 col-lg-6"
                  label="نام سنسور سوم"
                  required
                  v-model="info.thirdSensor"
                  :value="info.thirdSensor"
                />

                <CInput
                  class="col-sm-12 col-lg-6"
                  label="نام سنسور چهارم"
                  required
                  v-model="info.forthSensor"
                  :value="info.forthSensor"
                />

                <CInput
                  class="col-sm-12 col-lg-6"
                  label="نام سنسور پنجم"
                  v-model="info.fifthSensor"
                  required
                  :value="info.fifthSensor"
                />

                <CInput
                  class="col-sm-12 col-lg-6"
                  label="نام سنسور ششم"
                  required
                  v-model="info.sixthSensor"
                  :value="info.sixthSensor"
                />

                <CInput
                  class="col-sm-12 col-lg-6"
                  label="نام سنسور هفتم"
                  required
                  v-model="info.seventhSensor"
                  :value="info.seventhSensor"
                />

                <CInput
                  class="col-sm-12 col-lg-6"
                  label="نام سنسور هشتم"
                  required
                  v-model="info.eigthSensor"
                  :value="info.eigthSensor"
                />
              </CRow>

              <CRow
                v-if="
                  info.ModelValue.value == 'Navgan' ||
                  info.ModelValue.value == 'ICH44IP'
                "
                class="m-0 p-0"
              >
                <CInput
                  class="col-sm-12 col-lg-6"
                  label="نام سنسور اول"
                  v-model="info.firstSensor"
                  required
                  :value="info.firstSensor"
                />

                <CInput
                  class="col-sm-12 col-lg-6"
                  label="نام سنسور دوم"
                  required
                  v-model="info.secondSensor"
                  :value="info.secondSensor"
                />

                <CInput
                  class="col-sm-12 col-lg-6"
                  label="نام سنسور سوم"
                  required
                  v-model="info.thirdSensor"
                  :value="info.thirdSensor"
                />

                <CInput
                  class="col-sm-12 col-lg-6"
                  label="نام سنسور چهارم"
                  required
                  v-model="info.forthSensor"
                  :value="info.forthSensor"
                />
              </CRow>

              <CRow
                v-if="
                  info.ModelValue.value == 'Navgan2' ||
                  info.ModelValue.value == 'Navgan3' ||
                  info.ModelValue.value == 'Tracking'
                "
                class="m-0 p-0"
              >
                <CInput
                  class="col-sm-12 col-lg-6"
                  label="نام سنسور اول"
                  v-model="info.firstSensor"
                  required
                  :value="info.firstSensor"
                />
              </CRow>

              <CRow
                v-if="
                  info.ModelValue.value == 'FE22WE' ||
                  info.ModelValue.value == 'FreezEyeV3'
                "
                class="m-0 p-0"
              >
                <CInput
                  class="col-sm-12 col-lg-6"
                  label="نام سنسور اول"
                  v-model="info.firstSensor"
                  required
                  :value="info.firstSensor"
                />

                <CInput
                  class="col-sm-12 col-lg-6"
                  label="نام سنسور دوم"
                  required
                  v-model="info.secondSensor"
                  :value="info.secondSensor"
                />
              </CRow>

              <CRow
                v-if="
                  info.ModelValue.value != 'Navgan2' &&
                  info.ModelValue.value != 'Navgan3' &&
                  info.ModelValue.value != 'FDA' &&
                  info.ModelValue.value != 'Tracking'
                "
                class="m-0 p-0"
              >
                <CInput
                  maxLength="15"
                  class="col-sm-12 col-lg-6"
                  label="Ethernet IP"
                  v-model="info.ethernetIpAddress"
                  :value="info.ethernetIpAddress"
                  required
                />
                <CInput
                  maxLength="5"
                  class="col-sm-12 col-lg-6"
                  label="Ethernet Port"
                  v-model="info.ethernetPortAddress"
                  :value="info.ethernetPortAddress"
                  required
                />
                <CInput
                  maxLength="15"
                  class="col-sm-12 col-lg-6"
                  label="WiFi IP"
                  v-model="info.wifiIpAddress"
                  :value="info.wifiIpAddress"
                  required
                />
                <CInput
                  maxLength="5"
                  class="col-sm-12 col-lg-6"
                  label="WiFi Pprt"
                  v-model="info.wifiPortAddress"
                  :value="info.wifiPortAddress"
                  required
                />
                <CInput
                  maxLength="15"
                  class="col-sm-12 col-lg-6"
                  label="GPRS IP"
                  v-model="info.gprsIpAddress"
                  :value="info.gprsIpAddress"
                  required
                />
                <CInput
                  maxLength="5"
                  class="col-sm-12 col-lg-6"
                  label="GPRS Port"
                  v-model="info.gprsPortAddress"
                  :value="info.gprsPortAddress"
                  required
                />
              </CRow>
            </CRow>
            <h6 class="text-secondary my-2">انتخاب سازمان</h6>
            <v-jstree
              :data="structureList"
              show-checkbox
              allow-batch
              whole-row
              noDots
              @item-click="itemClick"
            ></v-jstree>
          </CCol>
          <CCol>
            <CRow
              ><l-map
                style="height: 450px"
                :zoom="zoom"
                :center="center"
                ref="limitMap"
                @click="getLatLong($event)"
              >
                <l-control-layers position="bottomleft"></l-control-layers>
                <l-tile-layer
                  v-for="tileProvider in tileProviders"
                  :key="tileProvider.name"
                  :name="tileProvider.name"
                  :visible="tileProvider.visible"
                  :url="tileProvider.url"
                  :attribution="tileProvider.attribution"
                  layer-type="base"
                />

                <l-marker :lat-lng="markerLatLng">
                  <l-icon>
                    <span style="font-size: 30px"
                      ><i class="fa fa-map-marker" aria-hidden="true"></i>
                    </span>
                  </l-icon>
                </l-marker>

                <l-control
                  position="topright"
                  class="align-items-center justify-content-center"
                >
                  <CRow class="mx-2">
                    <CInput
                      class="col-5 p-0 m-0"
                      style="direction: ltr"
                      :disabled="true"
                      :placeholder="'lng: ' + markerLatLng[1]"
                      :value="markerLatLng[1]"
                      v-model="markerLatLng[1]"
                      @input="changeLocation($event, 'lng')"
                    ></CInput>

                    <CInput
                      class="col-5 p-0 m-0"
                      style="direction: ltr"
                      :disabled="true"
                      :placeholder="'lat: ' + markerLatLng[0]"
                      :value="markerLatLng[0]"
                      v-model="markerLatLng[0]"
                      @input="changeLocation($event, 'lat')"
                    >
                    </CInput>
                  </CRow>
                </l-control> </l-map
            ></CRow>

            <CRow v-if="info.ModelValue.value == 'FDA'" class="m-0 p-0 mt-4">
              <CInput
                class="col-sm-12 col-lg-6"
                label="کد شعبه"
                v-model="info.FdaBranchId"
                required
                :value="info.FdaBranchId"
                maxLength="10"
              />

              <CInput
                class="col-sm-12 col-lg-6"
                label="کدانبار"
                required
                v-model="info.FdaRoomId"
                :value="info.FdaRoomId"
                maxLength="10"
              />

              <CInput
                class="col-sm-12 col-lg-6"
                label="کد سنسور"
                required
                v-model="info.FdaSensorId1"
                :value="info.FdaSensorId1"
                maxLength="10"
              />

              <CInput
                class="col-sm-12"
                label="آدرس وب سرویس"
                required
                v-model="info.FdaWebServiceAddress"
                :value="info.FdaWebServiceAddress"
              />
            </CRow>

            <CRow
              v-if="info.ModelValue.value == 'FreezEyeV5'"
              class="m-0 p-0 mt-4"
            >
              <CInput
                class="col-sm-12 col-lg-6"
                label="کد شعبه"
                v-model="info.FdaBranchId"
                :value="info.FdaBranchId"
                maxLength="10"
              />

              <CInput
                class="col-sm-12 col-lg-6"
                label="کدانبار"
                v-model="info.FdaRoomId"
                :value="info.FdaRoomId"
                maxLength="10"
              />

              <CInput
                class="col-sm-12 col-lg-6"
                label="کد سنسور اول"
                v-model="info.FdaSensorId1"
                :value="info.FdaSensorId1"
                maxLength="10"
              />
              <CInput
                class="col-sm-12 col-lg-6"
                label="کد سنسور دوم"
                v-model="info.FdaSensorId2"
                :value="info.FdaSensorId2"
                maxLength="10"
              />
              <CInput
                class="col-sm-12 col-lg-6"
                label="کد سنسور سوم"
                v-model="info.FdaSensorId3"
                :value="info.FdaSensorId3"
                maxLength="10"
              />
            </CRow>

            <CRow
              v-if="info.ModelValue.value == 'ICH88IPV3'"
              class="m-0 p-0 mt-4"
            >
              <CInput
                class="col-sm-12 col-lg-6"
                label="کد شعبه"
                v-model="info.FdaBranchId"
                :value="info.FdaBranchId"
                maxLength="10"
              />

              <CInput
                class="col-sm-12 col-lg-6"
                label="کدانبار"
                v-model="info.FdaRoomId"
                :value="info.FdaRoomId"
                maxLength="10"
              />

              <CInput
                class="col-sm-12 col-lg-6"
                label="کد سنسور اول"
                v-model="info.FdaSensorId1"
                :value="info.FdaSensorId1"
                maxLength="10"
              />
              <CInput
                class="col-sm-12 col-lg-6"
                label="کد سنسور دوم"
                v-model="info.FdaSensorId2"
                :value="info.FdaSensorId2"
                maxLength="10"
              />
              <CInput
                class="col-sm-12 col-lg-6"
                label="کد سنسور سوم"
                v-model="info.FdaSensorId3"
                :value="info.FdaSensorId3"
                maxLength="10"
              />
              <CInput
                class="col-sm-12 col-lg-6"
                label="کد سنسور چهارم"
                v-model="info.FdaSensorId4"
                :value="info.FdaSensorId4"
                maxLength="10"
              />
              <CInput
                class="col-sm-12 col-lg-6"
                label="کد سنسور پنجم"
                v-model="info.FdaSensorId5"
                :value="info.FdaSensorId5"
                maxLength="10"
              />
              <CInput
                class="col-sm-12 col-lg-6"
                label="کد سنسور ششم"
                v-model="info.FdaSensorId6"
                :value="info.FdaSensorId6"
                maxLength="10"
              />
              <CInput
                class="col-sm-12 col-lg-6"
                label="کد سنسور هفتم"
                v-model="info.FdaSensorId7"
                :value="info.FdaSensorId7"
                maxLength="10"
              />
              <CInput
                class="col-sm-12 col-lg-6"
                label="کد سنسور هشتم"
                v-model="info.FdaSensorId8"
                :value="info.FdaSensorId8"
                maxLength="10"
              />
            </CRow>
            <CRow
              v-if="
                info.ModelValue.value == 'Navgan2' ||
                info.ModelValue.value == 'Navgan3' ||
                info.ModelValue.value == 'Tracking'
              "
              class="m-0 p-0 mt-4"
            >
              <CInput
                class="col-sm-12 col-lg-6"
                label="کد شعبه"
                v-model="info.FdaBranchId"
                :value="info.FdaBranchId"
                maxLength="10"
              />

              <CInput
                class="col-sm-12 col-lg-6"
                label="کدانبار"
                v-model="info.FdaRoomId"
                :value="info.FdaRoomId"
                maxLength="10"
              />

              <CInput
                class="col-sm-12 col-lg-6"
                label="کد سنسور اول"
                v-model="info.FdaSensorId1"
                :value="info.FdaSensorId1"
                maxLength="10"
              />
            </CRow>
            <CRow
              v-if="
                info.ModelValue.value == 'Navgan' ||
                info.ModelValue.value == 'ICH44IP'
              "
              class="m-0 p-0 mt-4"
            >
              <CInput
                class="col-sm-12 col-lg-6"
                label="کد شعبه"
                v-model="info.FdaBranchId"
                :value="info.FdaBranchId"
                maxLength="10"
              />

              <CInput
                class="col-sm-12 col-lg-6"
                label="کدانبار"
                v-model="info.FdaRoomId"
                :value="info.FdaRoomId"
                maxLength="10"
              />

              <CInput
                class="col-sm-12 col-lg-6"
                label="کد سنسور اول"
                v-model="info.FdaSensorId1"
                :value="info.FdaSensorId1"
                maxLength="10"
              />
              <CInput
                class="col-sm-12 col-lg-6"
                label="کد سنسور دوم"
                v-model="info.FdaSensorId2"
                :value="info.FdaSensorId2"
                maxLength="10"
              />
              <CInput
                class="col-sm-12 col-lg-6"
                label="کد سنسور سوم"
                v-model="info.FdaSensorId3"
                :value="info.FdaSensorId3"
                maxLength="10"
              />
              <CInput
                class="col-sm-12 col-lg-6"
                label="کد سنسور چهارم"
                v-model="info.FdaSensorId4"
                :value="info.FdaSensorId4"
                maxLength="10"
              />
            </CRow>

            <CRow
              v-if="
                info.ModelValue.value == 'FE22WE' ||
                info.ModelValue.value == 'FreezEyeV3'
              "
              class="m-0 p-0 mt-4"
            >
              <CInput
                class="col-sm-12 col-lg-6"
                label="کد شعبه"
                v-model="info.FdaBranchId"
                :value="info.FdaBranchId"
                maxLength="10"
              />

              <CInput
                class="col-sm-12 col-lg-6"
                label="کدانبار"
                v-model="info.FdaRoomId"
                :value="info.FdaRoomId"
                maxLength="10"
              />

              <CInput
                class="col-sm-12 col-lg-6"
                label="کد سنسور اول"
                v-model="info.FdaSensorId1"
                :value="info.FdaSensorId1"
                maxLength="10"
              />

              <CInput
                class="col-sm-12 col-lg-6"
                label="کد سنسور دوم"
                v-model="info.FdaSensorId2"
                :value="info.FdaSensorId2"
                maxLength="10"
              />
            </CRow>
            <!-- <CRow v-if="info.ModelValue.value == 'Navgan'" class="m-0 p-0 mt-4">
              <CInput
                class="col-sm-12 col-lg-6"
                label="کد شعبه"
                v-model="info.FdaBranchId"
                :value="info.FdaBranchId"
                maxLength="10"
              />

              <CInput
                class="col-sm-12 col-lg-6"
                label="کدانبار"
                v-model="info.FdaRoomId"
                :value="info.FdaRoomId"
                maxLength="10"
              />

              <CInput
                class="col-sm-12 col-lg-6"
                label="کد سنسور اول"
                v-model="info.FdaSensorId1"
                :value="info.FdaSensorId1"
                maxLength="10"
              />
              <CInput
                class="col-sm-12 col-lg-6"
                label="کد سنسور دوم"
                v-model="info.FdaSensorId2"
                :value="info.FdaSensorId2"
                maxLength="10"
              />
            </CRow> -->
          </CCol>
        </CRow>

        <br />
        <CTextarea
          label="توضیحات"
          placeholder="Content..."
          rows="5"
          v-model="info.description"
        />
      </CForm>

      <template #footer>
        <CButton
          v-if="modalButtonSubmit == 'تایید'"
          @click="addModal = false"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />تایید</CButton
        >
        <CButton
          v-if="modalButtonSubmit != 'تایید'"
          @click="addModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" class="mx-2" />لغو</CButton
        >
        <CButton
          v-if="modalButtonSubmit != 'تایید'"
          @click="submitForm"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" class="mx-2" />{{
            modalButtonSubmit
          }}</CButton
        >
      </template>
    </CModal>

    <!-----------------------------------------------------------------------  setting modal -->
    <CModal title="تنظیمات" :show.sync="settingModal" size="xl">
      <CAlert color="warning" closeButton :show.sync="alert">
        {{ alertText }}
      </CAlert>
      <h5 class="text-primary mb-3" >
        تنظیمات دستگاه
        <span class="text-danger" >{{ groupName }}</span>
      </h5>
      <hr />
      <!-- ************************************************wifi setting -->
      <CForm class="needs-validation2" novalidate>
        <CRow class="mt-2">
          <CCard class="mb-0 p-0">
            <CButton
              block
              class="text-right shadow-none card-header"
              @click="showWifi = showWifi === 4 ? false : 4"
            >
              <h5 class="text-primary">
                اطلاعات WiFi
                <small class="text-secondary mx-3"
                  >آخرین به روزرسانی: {{ wifi.updateTime }}</small
                >
              </h5>
            </CButton>
            <CCollapse :show="showWifi === 4">
              <CCardBody>
                <CRow>
                  <CInput
                    maxLength="15"
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="IP"
                    v-model="wifi.ipAddress"
                    :value="wifi.ipAddress"
                    required
                  />
                  <CInput
                    maxLength="15"
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="Subnet Mask"
                    v-model="wifi.subnetMask"
                    :value="wifi.subnetMask"
                    required
                  />
                  <CInput
                    maxLength="15"
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="Gateway"
                    v-model="wifi.gateway"
                    :value="wifi.gateway"
                    required
                  />
                  <CInput
                    maxLength="15"
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="DNS"
                    v-model="wifi.dns"
                    :value="wifi.dns"
                    required
                  />
                </CRow>
                <CRow class="justify-content-center mt-2">
                  <CButton
                    @click="recieveDeviceSetting('wifi')"
                    color="info"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon
                      name="cil-cloud-download"
                      class="mx-1"
                    />دریافت</CButton
                  >
                  <CButton
                    @click="setDeviceSetting('wifi')"
                    color="success"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon
                      name="cil-check-circle"
                      class="mx-1"
                    />اعمال</CButton
                  >
                  <!-- <CButton
                    @click="refreshDeviceSetting('wifi')"
                    color="warning"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon name="cil-loop-circular" class="mx-1" />به
                    روزرسانی</CButton
                  > -->
                </CRow>
                <CRow v-if="spinnerWifi" class="justify-content-center mt-2">
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </CRow>
              </CCardBody>
            </CCollapse>
          </CCard>
        </CRow>
      </CForm>

      <!-- ************************************************wifi ssid and password setting -->
      <CForm class="needs-validation2" novalidate>
        <CRow class="mt-2">
          <CCard class="mb-0 p-0">
            <CButton
              block
              class="text-right shadow-none card-header"
              @click="showWifiSsid = showWifiSsid === 4 ? false : 4"
            >
              <h5 class="text-primary">
                اطلاعات WiFi- SSID/PASS
                <small class="text-secondary mx-3"
                  >آخرین به روزرسانی: {{ wifi.updateTime }}</small
                >
              </h5>
            </CButton>
            <CCollapse :show="showWifiSsid === 4">
              <CCardBody>
                <CRow>
                  <CInput
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="SSID"
                    v-model="wifi.ssid"
                    :value="wifi.ssid"
                    required
                  />
                  <CInput
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="Password"
                    v-model="wifi.password"
                    :value="wifi.password"
                    required
                  />
                  <CInputCheckbox
                    label="فعال "
                    class="mr-3 mb-2"
                    :checked="wifi.active"
                    @change="wifi.active = !wifi.active"
                  />
                </CRow>
                <CRow class="justify-content-center mt-2">
                  <CButton
                    @click="recieveDeviceSetting('wifi_ssid')"
                    color="info"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon
                      name="cil-cloud-download"
                      class="mx-1"
                    />دریافت</CButton
                  >
                  <CButton
                    @click="setDeviceSetting('wifi_ssid')"
                    color="success"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon
                      name="cil-check-circle"
                      class="mx-1"
                    />اعمال</CButton
                  >
                  <!-- <CButton
                    @click="refreshDeviceSetting('wifi')"
                    color="warning"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon name="cil-loop-circular" class="mx-1" />به
                    روزرسانی</CButton
                  > -->
                </CRow>
                <CRow
                  v-if="spinnerWifiSsid"
                  class="justify-content-center mt-2"
                >
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </CRow>
              </CCardBody>
            </CCollapse>
          </CCard>
        </CRow>
      </CForm>
      <!-- ************************************************ethernet setting -->
      <CForm class="needs-validationEthernet" novalidate>
        <CRow class="mt-2">
          <CCard class="mb-0 p-0">
            <CButton
              block
              class="text-right shadow-none card-header"
              @click="showEthernet = showEthernet === 5 ? false : 5"
            >
              <h5 class="text-primary">
                اطلاعات Ethernet<small class="text-secondary mx-3"
                  >آخرین به روزرسانی: {{ ethernet.updateTime }}</small
                >
              </h5>
            </CButton>
            <CCollapse :show="showEthernet === 5">
              <CCardBody>
                <CRow>
                  <CInput
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="IP"
                    v-model="ethernet.ipAddress"
                    :value="ethernet.ipAddress"
                    maxLength="15"
                    required
                  />
                  <CInput
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="Subnet Mask"
                    v-model="ethernet.subnetMask"
                    :value="ethernet.subnetMask"
                    maxLength="15"
                    required
                  />
                  <CInput
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="Gateway"
                    v-model="ethernet.gateway"
                    :value="ethernet.gateway"
                    maxLength="15"
                    required
                  />
                  <CInput
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="DNS"
                    v-model="ethernet.dns"
                    :value="ethernet.dns"
                    maxLength="15"
                    required
                  />
                </CRow>
                <CRow class="justify-content-center mt-2">
                  <CButton
                    @click="recieveDeviceSetting('ethernet')"
                    color="info"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon
                      name="cil-cloud-download"
                      class="mx-1"
                    />دریافت</CButton
                  >
                  <CButton
                    @click="setDeviceSetting('ethernet')"
                    color="success"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon
                      name="cil-check-circle"
                      class="mx-1"
                    />اعمال</CButton
                  >
                  <!-- <CButton
                    @click="refreshDeviceSetting('ethernet')"
                    color="warning"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon name="cil-loop-circular" class="mx-1" />به
                    روزرسانی</CButton
                  > -->
                </CRow>
                <CRow
                  v-if="spinnerEthernet"
                  class="justify-content-center mt-2"
                >
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </CRow>
              </CCardBody>
            </CCollapse>
          </CCard>
        </CRow>
      </CForm>
      <!-- ************************************************server setting -->
      <CForm class="needs-validationServer" novalidate>
        <CRow class="mt-2">
          <CCard class="mb-0 p-0">
            <CButton
              block
              class="text-right shadow-none card-header"
              @click="showGPRS = showGPRS === 5 ? false : 5"
            >
              <h5 class="text-primary">
                اطلاعات سرور<small class="text-secondary mx-3"
                  >آخرین به روزرسانی: {{ serverInfo.updateTime }}</small
                >
              </h5>
            </CButton>
            <CCollapse :show="showGPRS === 5">
              <CCardBody>
                <CRow align-vertical="center">
                  <CInput
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="IP Ethernet"
                    v-model="serverInfo.ipAddressEthernet"
                    :value="serverInfo.ipAddressEthernet"
                    maxLength="15"
                    required
                  />
                  <CInput
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="IP WiFi"
                    v-model="serverInfo.ipAddressWiFi"
                    :value="serverInfo.ipAddressWiFi"
                    maxLength="15"
                    required
                  />
                  <CInput
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="IP GPRS"
                    v-model="serverInfo.ipAddressGPRS"
                    :value="serverInfo.ipAddressGPRS"
                    maxLength="15"
                    required
                  />
                  <CInput
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="port"
                    v-model="serverInfo.port"
                    :value="serverInfo.port"
                    type="number"
                    required
                  />
                  <CInput
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="فاصله زمانی"
                    v-model="serverInfo.timeDistance"
                    :value="serverInfo.timeDistance"
                    type="number"
                    required
                  />

                  <CInputCheckbox
                    label="wifi "
                    class="mr-3 mb-2 mt-3 col-sm-12 col-md-5 col-lg-3"
                    :checked="serverInfo.wifi"
                    @change="serverInfo.wifi = !serverInfo.wifi"
                  />
                  <CInputCheckbox
                    label="ethernet"
                    class="mr-3 mb-2 mt-3 col-sm-12 col-md-5 col-lg-3"
                    :checked="serverInfo.ethernet"
                    @change="serverInfo.ethernet = !serverInfo.ethernet"
                  />
                  <CInputCheckbox
                    label="gprs"
                    class="mr-3 mb-2 mt-3 col-sm-12 col-md-5 col-lg-3"
                    :checked="serverInfo.gprs"
                    @change="serverInfo.gprs = !serverInfo.gprs"
                  />

                  <CInputCheckbox
                    label="Debug System"
                    class="mr-3 mb-2 mt-3 col-sm-12 col-md-5 col-lg-3"
                    :checked="serverInfo.debugSystem"
                    @change="serverInfo.debugSystem = !serverInfo.debugSystem"
                  />
                  <CInputCheckbox
                    label="Debug GSM"
                    class="mr-3 mb-2 mt-3 col-sm-12 col-md-5 col-lg-3"
                    :checked="serverInfo.debugGsm"
                    @change="serverInfo.debugGsm = !serverInfo.debugGsm"
                  />
                  <CInputCheckbox
                    label="Debug WIFI"
                    class="mr-3 mb-2 mt-3 col-sm-12 col-md-5 col-lg-3"
                    :checked="serverInfo.debugWifi"
                    @change="serverInfo.debugWifi = !serverInfo.debugWifi"
                  />
                </CRow>
                <CRow class="justify-content-center mt-2">
                  <CButton
                    @click="recieveDeviceSetting('server')"
                    color="info"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon
                      name="cil-cloud-download"
                      class="mx-1"
                    />دریافت</CButton
                  >
                  <CButton
                    @click="setDeviceSetting('server')"
                    color="success"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon
                      name="cil-check-circle"
                      class="mx-1"
                    />اعمال</CButton
                  >
                  <!-- <CButton
                    @click="refreshDeviceSetting('server')"
                    color="warning"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon name="cil-loop-circular" class="mx-1" />به
                    روزرسانی</CButton
                  > -->
                </CRow>
                <CRow v-if="spinnerServer" class="justify-content-center mt-2">
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </CRow>
              </CCardBody>
            </CCollapse>
          </CCard>
        </CRow>
      </CForm>
      <!-- ************************************************simcard setting -->
      <CRow class="mt-2">
        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showSimcard = showSimcard === 3 ? false : 3"
          >
            <h5 class="text-primary">
              اطلاعات سیم کارت
              <small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ simcardUpdateTime }}</small
              >
            </h5>
          </CButton>
          <CCollapse :show="showSimcard === 3">
            <CCardBody>
              <CRow>
                <div class="col-sm-12 col-md-6 col-lg-4">
                  <label class="typo__label">اپراتور</label>
                  <multiselect
                    class="needs-validation"
                    v-model="SimcardOprator"
                    :options="SimcardOpratorList"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    :show-labels="false"
                    placeholder="انتخاب..."
                    label="name"
                    track-by="id"
                    :disabled="disableMultiselect"
                  ></multiselect>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-4">
                  <label class="typo__label">نوع سیم کارت</label>
                  <multiselect
                    class="needs-validation"
                    v-model="SimcardType"
                    :options="SimcardTypeList"
                    :searchable="true"
                    :allow-empty="false"
                    :close-on-select="true"
                    :show-labels="false"
                    placeholder="انتخاب..."
                    label="name"
                    track-by="id"
                    :disabled="disableMultiselect"
                  ></multiselect>
                </div>
              </CRow>
              <CRow class="justify-content-center mt-2">
                <CButton
                  @click="recieveDeviceSetting('simcard')"
                  color="info"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon
                    name="cil-cloud-download"
                    class="mx-1"
                  />دریافت</CButton
                >
                <CButton
                  @click="setDeviceSetting('simcard')"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
                >
                <!-- <CButton
                  @click="refreshDeviceSetting('simcard')"
                  color="warning"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-loop-circular" class="mx-1" />به
                  روزرسانی</CButton
                > -->
              </CRow>
              <CRow v-if="spinnerSimcard" class="justify-content-center mt-2">
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </CRow>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CRow>

      <!-- ************************************************startDelay setting -->
      <CRow class="mt-2">
        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showStartDelay = showStartDelay === 3 ? false : 3"
          >
            <h5 class="text-primary">
              اطلاعات تاخیر استارت
              <small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ startDelayUpdateTime }}</small
              >
            </h5>
          </CButton>
          <CCollapse :show="showStartDelay === 3">
            <CCardBody>
              <CRow>
                <CInput
                  class="col-sm-12 col-lg-6"
                  label="تاخیر استارت"
                  placeholder="واحد : ثانیه"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  type="number"
                  maxlength="4"
                  v-model="info.startDelay"
                  :value="info.startDelay"
                />
              </CRow>
              <CRow class="justify-content-center mt-2">
                <CButton
                  @click="recieveDeviceSetting('startDelay')"
                  color="info"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon
                    name="cil-cloud-download"
                    class="mx-1"
                  />دریافت</CButton
                >
                <CButton
                  @click="setDeviceSetting('startDelay')"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
                >
                <!-- <CButton
                  @click="refreshDeviceSetting('simcard')"
                  color="warning"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-loop-circular" class="mx-1" />به
                  روزرسانی</CButton
                > -->
              </CRow>
              <CRow
                v-if="spinnerStartDelay"
                class="justify-content-center mt-2"
              >
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </CRow>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CRow>

      <!-- ************************************************alarm setting setting -->
      <CRow class="mt-2">
        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showVoiceAlarm = showVoiceAlarm === 4 ? false : 4"
          >
            <h5 class="text-primary">
              اطلاعات تایمر آلارم صوتی
              <small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ voiceAlarmInfo.updateTime }}</small
              >
            </h5>
          </CButton>
          <CCollapse :show="showVoiceAlarm === 4">
            <CCardBody>
              <CRow>
                <CInput
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="تاخیر"
                  placeholder="واحد: "
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  type="number"
                  maxlength="4"
                  required
                  v-model="voiceAlarmInfo.delay"
                  :value="voiceAlarmInfo.delay"
                />

                <CInput
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="طول آلارم"
                  placeholder="واحد: "
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  type="number"
                  maxlength="4"
                  required
                  v-model="voiceAlarmInfo.length"
                  :value="voiceAlarmInfo.length"
                />

                <CInputCheckbox
                  label="آلارم صوتی دما"
                  class="mt-4 mr-2 pt-3 col-sm-12 col-md-6 col-lg-4 px-4"
                  :checked="voiceAlarmInfo.voiceTemp"
                  @change="voiceAlarmInfo.voiceTemp = !voiceAlarmInfo.voiceTemp"
                />
                <CInputCheckbox
                  label="آلارم پیامکی دما"
                  class="mt-4 mr-2 pt-3 col-sm-12 col-md-6 col-lg-4 px-4"
                  :checked="voiceAlarmInfo.smsTemp"
                  @change="voiceAlarmInfo.smsTemp = !voiceAlarmInfo.smsTemp"
                />
                <CInputCheckbox
                  label="آلارم صوتی رطوبت"
                  class="mt-4 mr-2 pt-3 col-sm-12 col-md-6 col-lg-4 px-4"
                  :checked="voiceAlarmInfo.voiceHum"
                  @change="voiceAlarmInfo.voiceHum = !voiceAlarmInfo.voiceHum"
                />
                <CInputCheckbox
                  label="آلارم پیامکی رطوبت"
                  class="mt-4 mr-2 pt-3 col-sm-12 col-md-6 col-lg-4 px-4"
                  :checked="voiceAlarmInfo.smsHum"
                  @change="voiceAlarmInfo.smsHum = !voiceAlarmInfo.smsHum"
                />
              </CRow>
              <CRow class="justify-content-center mt-2">
                <CButton
                  @click="recieveDeviceSetting('voiceAlarm')"
                  color="info"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon
                    name="cil-cloud-download"
                    class="mx-1"
                  />دریافت</CButton
                >
                <CButton
                  @click="setDeviceSetting('voiceAlarm')"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
                >
                <!-- <CButton
                  @click="refreshDeviceSetting('voiceAlarm')"
                  color="warning"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-loop-circular" class="mx-1" />به
                  روزرسانی</CButton
                > -->
              </CRow>
              <CRow
                v-if="spinnerVoiceAlarm"
                class="justify-content-center mt-2"
              >
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </CRow>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CRow>

      <!-- ************************************************sms credit setting -->
      <!-- <CRow class="mt-2">
           <CCard class="mb-0 p-0">
            <CButton
              block
              class="text-right shadow-none card-header"
              @click="showSmsCostAlarm = showSmsCostAlarm === 5 ? false : 5"
            >
              <h5 class="text-primary">اطلاعات پیامک اعتبار</h5>
            </CButton>
            <CCollapse :show="showSmsCostAlarm === 5">
              <CCardBody>
                <CRow>
                  <CInput
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="حد ریالی"
                    v-model="SmsCost.cost"
                    :value="SmsCost.cost"
                  />

                  <vue-clock-picker
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="زمان ارسال"
                    v-model="SmsCost.sendTime"
                    :value="SmsCost.sendTime"
                  >
                  </vue-clock-picker>
                </CRow>
              </CCardBody>
            </CCollapse>
          </CCard>
           </CRow> -->

      <!-- ************************************************puls setting -->
      <CRow class="mt-2">
        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showPulsAlarm = showPulsAlarm === 6 ? false : 6"
          >
            <h5 class="text-primary">
              اطلاعات نبض
              <small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ pulsInfo.updateTime }}</small
              >
            </h5>
          </CButton>
          <CCollapse :show="showPulsAlarm === 6">
            <CCardBody>
              <CRow>
                <vue-clock-picker
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="نبض اول"
                  v-model="pulsInfo.first"
                  :value="pulsInfo.first"
                >
                </vue-clock-picker>
                <vue-clock-picker
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="نبض دوم"
                  v-model="pulsInfo.second"
                  :value="pulsInfo.second"
                >
                </vue-clock-picker>
              </CRow>
              <CRow class="justify-content-center mt-3">
                <CButton
                  @click="recieveDeviceSetting('puls')"
                  color="info"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon
                    name="cil-cloud-download"
                    class="mx-1"
                  />دریافت</CButton
                >
                <CButton
                  @click="setDeviceSetting('puls')"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
                >
                <!-- <CButton
                  @click="refreshDeviceSetting('puls')"
                  color="warning"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-loop-circular" class="mx-1" />به
                  روزرسانی</CButton
                > -->
              </CRow>
              <CRow v-if="spinnerPuls" class="justify-content-center mt-2">
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </CRow>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CRow>

      <!-- ************************************************date time setting -->
      <CRow class="mt-2">
        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showDateTeimeAlarm = showDateTeimeAlarm === 6 ? false : 6"
          >
            <h5 class="text-primary">
              اطلاعات تاریخ و ساعت
              <small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ dateTime.updateTime }}</small
              >
            </h5>
          </CButton>
          <CCollapse :show="showDateTeimeAlarm === 6">
            <CCardBody>
              <CRow>
                <CInput
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="تاریخ و ساعت"
                  v-model="dateTime.dateTime"
                  :value="dateTime.dateTime"
                  :disabled="true"
                />
              </CRow>
              <CRow class="justify-content-center mt-3">
                <CButton
                  @click="recieveDeviceSetting('dateTime')"
                  color="info"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon
                    name="cil-cloud-download"
                    class="mx-1"
                  />دریافت</CButton
                >
                <CButton
                  @click="setDeviceSetting('dateTime')"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
                >
                <!-- <CButton
                  @click="refreshDeviceSetting('puls')"
                  color="warning"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-loop-circular" class="mx-1" />به
                  روزرسانی</CButton
                > -->
              </CRow>
              <CRow v-if="spinnerPuls" class="justify-content-center mt-2">
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </CRow>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CRow>

      <!-- ************************************************serialNumber setting -->
      <CRow class="mt-2">
        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showSerialNumber = showSerialNumber === 3 ? false : 3"
          >
            <h5 class="text-primary">
              اطلاعات شماره سریال
              <small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ serial.serialTime }}</small
              >
            </h5>
          </CButton>
          <CCollapse :show="showSerialNumber === 3">
            <CCardBody>
              <CRow>
                <CInput
                  class="col-sm-12 col-lg-6"
                  label="شماره سریال"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  maxlength="4"
                  v-model="serial.serialNumber"
                  :value="serial.serialNumber"
                />
              </CRow>
              <CRow class="justify-content-center mt-2">
                <CButton
                  @click="recieveDeviceSetting('serial')"
                  color="info"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon
                    name="cil-cloud-download"
                    class="mx-1"
                  />دریافت</CButton
                >
                <CButton
                  @click="setDeviceSetting('serial')"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
                >
                <!-- <CButton
                  @click="refreshDeviceSetting('simcard')"
                  color="warning"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-loop-circular" class="mx-1" />به
                  روزرسانی</CButton
                > -->
              </CRow>
              <CRow
                v-if="spinnerSerialNumber"
                class="justify-content-center mt-2"
              >
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </CRow>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CRow>

      <!-- ************************************************sms setting -->
      <CForm class="needs-validationSms" novalidate>
        <CRow class="mt-2">
          <CCard class="mb-0 p-0">
            <CButton
              block
              class="text-right shadow-none card-header"
              @click="showSmsAlarm = showSmsAlarm === 7 ? false : 7"
            >
              <h5 class="text-primary">
                اطلاعات پیامک
                <small class="text-secondary mx-3"
                  >آخرین به روزرسانی: {{ smsSettingInfo.updateTime }}</small
                >
              </h5>
            </CButton>
            <CCollapse :show="showSmsAlarm === 7">
              <CCardBody>
                <CRow>
                  <div class="col-sm-12 col-md-6 form-group">
                    <label class="typo__label">گیرنده پیام</label>
                    <multiselect
                      class="needs-validationSms"
                      v-model="smsSettingInfo.reception"
                      :options="receptionList"
                      :allowEmpty="false"
                      :searchable="true"
                      :close-on-select="true"
                      :show-labels="false"
                      placeholder="انتخاب..."
                      label="label"
                      track-by="value"
                      :disabled="disableMultiselect"
                      required
                      @input="refreshDeviceSetting('sms')"
                    ></multiselect>
                  </div>

                  <CInput
                    id="mobileNumber"
                    class="col-sm-12 col-md-6"
                    label="شماره همراه"
                    v-model="smsSettingInfo.phoneNumber"
                    :value="smsSettingInfo.phoneNumber"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    type="number"
                    maxlength="11"
                  />
                </CRow>

                <h5 class="text-primary mb-3">تنظیمات پیامک</h5>
                <hr />
                <CRow>
                  <CInput
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="تایمر پیامک حد بالا دما"
                    v-model="smsSettingInfo.timeMaxTemp"
                    :value="smsSettingInfo.timeMaxTemp"
                    type="number"
                  />
                  <CInput
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="تایمر پیامک حد پایین دما"
                    type="number"
                    v-model="smsSettingInfo.timeMinTemp"
                    :value="smsSettingInfo.timeMinTemp"
                  />
                  <CInput
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="تایمر پیامک حد بالا رطوبت"
                    v-model="smsSettingInfo.timeMaxHum"
                    :value="smsSettingInfo.timeMaxHum"
                    type="number"
                  />
                  <CInput
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="تایمر پیامک حد پایین رطوبت"
                    type="number"
                    v-model="smsSettingInfo.timeMinHum"
                    :value="smsSettingInfo.timeMinHum"
                  />
                  <CInput
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="تایمر پیامک قطع سنسور"
                    v-model="smsSettingInfo.timeDisSensor"
                    :value="smsSettingInfo.timeDisSensor"
                    type="number"
                  />
                  <CInput
                    class="col-sm-12 col-md-6 col-lg-4"
                    label="تایمر پیامک قطع برق"
                    type="number"
                    v-model="smsSettingInfo.timeDisPower"
                    :value="smsSettingInfo.timeDisPower"
                  />
                  <CInputCheckbox
                    label="فعال "
                    class="mr-3 mb-2"
                    :checked="smsSettingInfo.active"
                    @change="smsSettingInfo.active = !smsSettingInfo.active"
                  />
                  <CInputCheckbox
                    label="ارسال نبض"
                    class="mr-3 mb-2"
                    :checked="smsSettingInfo.puls"
                    @change="smsSettingInfo.puls = !smsSettingInfo.puls"
                  />
                  <CInputCheckbox
                    label="پیامک متنی"
                    class="mr-3 mb-2"
                    :checked="smsSettingInfo.textSms"
                    @change="smsSettingInfo.textSms = !smsSettingInfo.textSms"
                  />
                </CRow>

                <CRow class="justify-content-center mt-2">
                  <CButton
                    @click="recieveDeviceSetting('sms')"
                    color="info"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon
                      name="cil-cloud-download"
                      class="mx-1"
                    />دریافت</CButton
                  >
                  <CButton
                    @click="setDeviceSetting('sms')"
                    color="success"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon
                      name="cil-check-circle"
                      class="mx-1"
                    />اعمال</CButton
                  >
                  <!-- <CButton
                    @click="refreshDeviceSetting('sms')"
                    color="warning"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon name="cil-loop-circular" class="mx-1" />به
                    روزرسانی</CButton
                  > -->
                </CRow>
                <CRow v-if="spinnerSms" class="justify-content-center mt-2">
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </CRow>
              </CCardBody>
            </CCollapse>
          </CCard>
        </CRow>
      </CForm>

      <!-- ************************************************sms alarm temp setting -->
      <CForm class="needs-validationSms" novalidate>
        <CRow class="mt-2">
          <CCard class="mb-0 p-0">
            <CButton
              block
              class="text-right shadow-none card-header"
              @click="showSmsAlarmTemp = showSmsAlarmTemp === 7 ? false : 7"
            >
              <h5 class="text-primary">
                اطلاعات پیامک- آلارم دما
                <small class="text-secondary mx-3"
                  >آخرین به روزرسانی: {{ smsSettingInfo.updateTime }}</small
                >
              </h5>
            </CButton>
            <CCollapse :show="showSmsAlarmTemp === 7">
              <CCardBody>
                <CRow>
                  <div class="col-sm-12 col-md-6 form-group">
                    <label class="typo__label">گیرنده پیام</label>
                    <multiselect
                      class="needs-validationSms"
                      v-model="smsSettingInfo.receptionTemp"
                      :options="receptionList"
                      :allowEmpty="false"
                      :searchable="true"
                      :close-on-select="true"
                      :show-labels="false"
                      placeholder="انتخاب..."
                      label="label"
                      track-by="value"
                      :disabled="disableMultiselect"
                      required
                      @input="refreshDeviceSetting('smsTemp')"
                    ></multiselect>
                  </div>
                </CRow>
                <!-- <h5 class="text-primary mb-2 mt-3">تنظیمات سطح آلارم</h5> -->
                <!-- <hr /> -->
                <CRow class="mt-2 p-2">
                  <table class="table table-striped m-2">
                    <thead>
                      <tr>
                        <th scope="col">ردیف</th>
                        <th scope="col">سنسور</th>
                        <th scope="col">آلارم-بالا</th>
                        <th scope="col">آلارم-پایین</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, i) in settingValues"
                        :key="item.name + item.index"
                      >
                        <!-- <th scope="row">{{i+1}}</th> -->
                        <td v-if="item.type == 1">{{ i + 1 }}</td>
                        <td v-if="item.type == 1">
                          {{ item.name + " " + item.indexName }}
                        </td>
                        <td v-if="item.type == 1">
                          <CInput
                            type="number"
                            v-model="settingValues[i].alarmUp"
                            :value="settingValues[i].alarmUp"
                          />
                        </td>
                        <td v-if="item.type == 1">
                          <CInput
                            type="number"
                            v-model="settingValues[i].alarmDown"
                            :value="settingValues[i].alarmDown"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </CRow>
                <CRow class="justify-content-center mt-2">
                  <CButton
                    @click="recieveDeviceSetting('smsTemp')"
                    color="info"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon
                      name="cil-cloud-download"
                      class="mx-1"
                    />دریافت</CButton
                  >
                  <CButton
                    @click="setDeviceSetting('smsTemp')"
                    color="success"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon
                      name="cil-check-circle"
                      class="mx-1"
                    />اعمال</CButton
                  >
                  <!-- <CButton
                    @click="refreshDeviceSetting('sms')"
                    color="warning"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon name="cil-loop-circular" class="mx-1" />به
                    روزرسانی</CButton
                  > -->
                </CRow>
                <CRow v-if="spinnerSmsTemp" class="justify-content-center mt-2">
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </CRow>
              </CCardBody>
            </CCollapse>
          </CCard>
        </CRow>
      </CForm>

      <!-- ************************************************sms alarm hummidity setting -->
      <CForm class="needs-validationSms" novalidate>
        <CRow class="mt-2">
          <CCard class="mb-0 p-0">
            <CButton
              block
              class="text-right shadow-none card-header"
              @click="showSmsAlarmHum = showSmsAlarmHum === 7 ? false : 7"
            >
              <h5 class="text-primary">
                اطلاعات پیامک- آلارم رطوبت
                <small class="text-secondary mx-3"
                  >آخرین به روزرسانی: {{ smsSettingInfo.updateTime }}</small
                >
              </h5>
            </CButton>
            <CCollapse :show="showSmsAlarmHum === 7">
              <CCardBody>
                <CRow>
                  <div class="col-sm-12 col-md-6 form-group">
                    <label class="typo__label">گیرنده پیام</label>
                    <multiselect
                      class="needs-validationSms"
                      v-model="smsSettingInfo.receptionHum"
                      :options="receptionList"
                      :allowEmpty="false"
                      :searchable="true"
                      :close-on-select="true"
                      :show-labels="false"
                      placeholder="انتخاب..."
                      label="label"
                      track-by="value"
                      :disabled="disableMultiselect"
                      required
                      @input="refreshDeviceSetting('smsHum')"
                    ></multiselect>
                  </div>
                </CRow>

                <!-- <h5 class="text-primary mb-2 mt-3">تنظیمات سطح آلارم</h5> -->
                <!-- <hr /> -->
                <CRow class="mt-2 p-2">
                  <table class="table table-striped m-2">
                    <thead>
                      <tr>
                        <th scope="col">ردیف</th>
                        <th scope="col">سنسور</th>
                        <th scope="col">آلارم-بالا</th>
                        <th scope="col">آلارم-پایین</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, i) in settingValues"
                        :key="item.name + item.index"
                      >
                        <!-- <th scope="row">{{i+1}}</th> -->
                        <td v-if="item.type == 2">{{ i + 1 }}</td>
                        <td v-if="item.type == 2">
                          {{ item.name + " " + item.indexName }}
                        </td>
                        <td v-if="item.type == 2">
                          <CInput
                            type="number"
                            v-model="settingValues[i].alarmUp"
                            :value="settingValues[i].alarmUp"
                          />
                        </td>
                        <td v-if="item.type == 2">
                          <CInput
                            type="number"
                            v-model="settingValues[i].alarmDown"
                            :value="settingValues[i].alarmDown"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </CRow>
                <CRow class="justify-content-center mt-2">
                  <CButton
                    @click="recieveDeviceSetting('smsHum')"
                    color="info"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon
                      name="cil-cloud-download"
                      class="mx-1"
                    />دریافت</CButton
                  >
                  <CButton
                    @click="setDeviceSetting('smsHum')"
                    color="success"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon
                      name="cil-check-circle"
                      class="mx-1"
                    />اعمال</CButton
                  >
                  <!-- <CButton
                    @click="refreshDeviceSetting('sms')"
                    color="warning"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon name="cil-loop-circular" class="mx-1" />به
                    روزرسانی</CButton
                  > -->
                </CRow>
                <CRow v-if="spinnerSmsHum" class="justify-content-center mt-2">
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </CRow>
              </CCardBody>
            </CCollapse>
          </CCard>
        </CRow>
      </CForm>

      <!-- ************************************************sensor setting -->
      <CForm class="needs-validationSensor" novalidate>
        <CRow class="mt-2">
          <CCard class="mb-0 p-0">
            <CButton
              block
              class="text-right shadow-none card-header"
              @click="showSensorAlarm = showSensorAlarm === 8 ? false : 8"
            >
              <h5 class="text-primary">
                اطلاعات سنسور
                <small class="text-secondary mx-3"
                  >آخرین به روزرسانی: {{ sensorUpdateTime }}</small
                >
              </h5>
            </CButton>
            <CCollapse :show="showSensorAlarm === 8">
              <CCardBody>
                <CRow>
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <label class="typo__label">شماره سنسور</label>
                    <multiselect
                      class="needs-validationSensor"
                      v-model="indexValueSensor"
                      :options="indexListSensor"
                      :searchable="true"
                      :allow-empty="false"
                      :close-on-select="true"
                      :show-labels="false"
                      placeholder="انتخاب..."
                      label="label"
                      track-by="value"
                      :disabled="disableMultiselect"
                      @select="createTableSensor($event)"
                    ></multiselect></div
                ></CRow>

                <h5 class="text-primary mt-3">تنظیمات</h5>
                <hr />
                <CRow class="mt-1">
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <label class="typo__label">نوع سنسور</label>
                    <multiselect
                      class="needs-validation"
                      v-model="typeValue"
                      :options="typeList"
                      :searchable="true"
                      :allow-empty="false"
                      :close-on-select="true"
                      :show-labels="false"
                      placeholder="انتخاب..."
                      label="label"
                      track-by="value"
                      :disabled="disableMultiselect"
                    ></multiselect>
                  </div>
                  <CInputCheckbox
                    label="فعال"
                    class="mt-4 mr-2 pt-3 col-sm-12 col-md-6 col-lg-4 px-4"
                    :checked="activeSensor"
                    @change="activeSensor = !activeSensor"
                  />
                </CRow>
                <CRow class="mt-2 p-2">
                  <table class="table table-striped m-2">
                    <thead>
                      <tr>
                        <th scope="col">ردیف</th>
                        <th scope="col">سنسور</th>
                        <th scope="col">رله-بالا</th>
                        <th scope="col">رله پایین</th>
                        <th scope="col">آلارم-بالا</th>
                        <th scope="col">آلارم-پایین</th>
                        <th scope="col">کالیبراسیون</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, i) in selectedSensors"
                        :key="item.name + item.index"
                      >
                        <!-- <th scope="row">{{i+1}}</th> -->
                        <td>{{ i + 1 }}</td>
                        <td>{{ item.name }}</td>
                        <td>
                          <CInput
                            type="number"
                            v-model="settingValuesSensor[i].validHighLimit"
                            :value="settingValuesSensor[i].validHighLimit"
                          />
                        </td>
                        <td>
                          <CInput
                            type="number"
                            v-model="settingValuesSensor[i].validLowLimit"
                            :value="settingValuesSensor[i].validLowLimit"
                          />
                        </td>
                        <td>
                          <CInput
                            type="number"
                            v-model="settingValuesSensor[i].alarmHighLimit"
                            :value="settingValuesSensor[i].alarmHighLimit"
                          />
                        </td>
                        <td>
                          <CInput
                            type="number"
                            v-model="settingValuesSensor[i].alarmLowLimit"
                            :value="settingValuesSensor[i].alarmLowLimit"
                          />
                        </td>
                        <td>
                          <CInput
                            type="number"
                            v-model="settingValuesSensor[i].calibration"
                            :value="settingValuesSensor[i].calibration"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </CRow>
                <CRow class="justify-content-center mt-2">
                  <CButton
                    @click="recieveDeviceSetting('sensor')"
                    color="info"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon
                      name="cil-cloud-download"
                      class="mx-1"
                    />دریافت</CButton
                  >
                  <CButton
                    @click="setDeviceSetting('sensor')"
                    color="success"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon
                      name="cil-check-circle"
                      class="mx-1"
                    />اعمال</CButton
                  >
                  <!-- <CButton
                    @click="refreshDeviceSetting('sensor')"
                    color="warning"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon name="cil-loop-circular" class="mx-1" />به
                    روزرسانی</CButton
                  > -->
                </CRow>
                <CRow v-if="spinnerSensor" class="justify-content-center mt-2">
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div class="spinner-grow text-secondary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </CRow>
              </CCardBody>
            </CCollapse>
          </CCard>
        </CRow>
      </CForm>

      <!-- *********************************************** alarm Setting -->
      <CForm class="needs-validationWebAlarm" novalidate>
        <CRow class="mt-2">
          <CCard class="mb-0 p-0">
            <CButton
              block
              class="text-right shadow-none card-header"
              @click="showAlarm = showAlarm === 7 ? false : 7"
            >
              <h5 class="text-primary">
                آلارم سنسور- وب
                <!-- <small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ alarmUpdateTime }}</small
              > -->
              </h5>
            </CButton>
            <CCollapse :show="showAlarm === 7">
              <CCardBody>
                <CRow class="mt-2 p-2">
                  <table class="table table-striped m-2">
                    <thead>
                      <tr>
                        <th scope="col">ردیف</th>
                        <th scope="col">سنسور</th>
                        <th scope="col">بیشینه</th>
                        <th scope="col">کمینه</th>
                        <th scope="col">دوره آلارم</th>
                        <th scope="col">کالیبراسیون</th>
                        <th scope="col">فعال بودن آلارم</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, i) in alarmMinMax" :key="i">
                        <!-- <th scope="row">{{i+1}}</th> -->
                        <td>{{ i + 1 }}</td>
                        <td>{{ item.sensorName }}</td>
                        <td>
                          <CInput
                            type="number"
                            v-model="item.alarmMax"
                            :value="item.alarmMax"
                          />
                        </td>

                        <td>
                          <CInput
                            type="number"
                            v-model="item.alarmMin"
                            :value="item.alarmMin"
                          />
                        </td>
                        <td>
                          <CInput
                            type="number"
                            v-model="item.alarmTime"
                            :value="item.alarmTime"
                          />
                        </td>
                        <td>
                          <CInput
                            type="number"
                            v-model="item.calibration"
                            :value="item.calibration"
                          />
                        </td>
                        <td>
                          <CInputCheckbox
                            :checked="item.alarmActive"
                            @change="item.alarmActive = !item.alarmActive"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </CRow>
                <CRow class="justify-content-center mt-2">
                  <CButton
                    @click="getSensors(deviceId)"
                    color="info"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon
                      name="cil-cloud-download"
                      class="mx-1"
                    />دریافت</CButton
                  >
                  <CButton
                    @click="setSensors()"
                    color="success"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon
                      name="cil-check-circle"
                      class="mx-1"
                    />اعمال</CButton
                  >
                  <!-- <CButton
                    @click="refreshDeviceSetting('sensor')"
                    color="warning"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon name="cil-loop-circular" class="mx-1" />به
                    روزرسانی</CButton
                  > -->
                </CRow>
              </CCardBody>
            </CCollapse>
          </CCard>
        </CRow>
      </CForm>

      <template #footer>
        <CButton
          @click="autoRefreshSettingValue2()"
          color="info"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-loop-circular" class="mx-1" />بروزرسانی</CButton
        >
        <CButton
          @click="settingModal = false"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" class="mx-1" />بازگشت</CButton
        >
      </template>
    </CModal>

    <!----------------------------------------------------------------------- FDA setting modal -->
    <CModal title="تنظیمات" :show.sync="settingModalFda" size="xl">
      <CAlert color="warning" closeButton :show.sync="alert">
        {{ alertText }}
      </CAlert>
      <h5 class="text-primary mb-3">
        تنظیمات دستگاه
        <span class="text-danger" dir="ltr">{{ groupName }}</span>
      </h5>
      <hr />

      <FDASetting :deviceId="deviceId" ref="FDA" @update="changeAlarm" />

      <template #footer>
        <!-- <CButton
          @click="settingModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" class="mx-1"/>لغو</CButton
        > -->
        <CButton
          @click="settingModalFda = false"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" class="mx-1" />بازگشت</CButton
        >
      </template>
    </CModal>

    <!----------------------------------------------------------------------- Tracking setting modal -->
    <CModal title="تنظیمات" :show.sync="settingModalTracking" size="xl">
      <CAlert color="warning" closeButton :show.sync="alert">
        {{ alertText }}
      </CAlert>
      <h5 class="text-primary mb-3">
        تنظیمات دستگاه
        <span class="text-danger" dir="ltr">{{ groupName }}</span>
      </h5>
      <hr />

      <TrackingSetting
        :deviceId="deviceId"
        ref="Tracking"
        @update="changeAlarm"
      />

      <template #footer>
        <!-- <CButton
          @click="settingModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" class="mx-1"/>لغو</CButton
        > -->
        <CButton
          @click="settingModalTracking = false"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" class="mx-1" />بازگشت</CButton
        >
      </template>
    </CModal>

    <!----------------------------------------------------------------------- Tracking setting2 modal -->
    <CModal title="تنظیمات" :show.sync="settingModalTracking2" size="xl">
      <CAlert color="warning" closeButton :show.sync="alert">
        {{ alertText }}
      </CAlert>
      <h5 class="text-primary mb-3">
        تنظیمات دستگاه
        <span class="text-danger" dir="ltr">{{ groupName }}</span>
      </h5>
      <hr />

      <TrackingSetting2
        :deviceId="deviceId"
        ref="Tracking2"
        @update="changeAlarm"
      />

      <template #footer>
        <!-- <CButton
          @click="settingModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" class="mx-1"/>لغو</CButton
        > -->
        <CButton
          @click="settingModalTracking2 = false"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" class="mx-1" />بازگشت</CButton
        >
      </template>
    </CModal>

    <!----------------------------------------------------------------------- Tracking setting3 modal -->
    <CModal title="تنظیمات" :show.sync="settingModalTracking3" size="xl">
      <CAlert color="warning" closeButton :show.sync="alert">
        {{ alertText }}
      </CAlert>
      <h5 class="text-primary mb-3">
        تنظیمات دستگاه
        <span class="text-danger" dir="ltr">{{ groupName }}</span>
      </h5>
      <hr />

      <TrackingSetting3
        :deviceId="deviceId"
        ref="Tracking3"
        @update="changeAlarm"
      />

      <template #footer>
        <!-- <CButton
          @click="settingModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" class="mx-1"/>لغو</CButton
        > -->
        <CButton
          @click="settingModalTracking3 = false"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" class="mx-1" />بازگشت</CButton
        >
      </template>
    </CModal>

    <!----------------------------------------------------------------------- Tracking settingJahad modal -->
    <CModal title="تنظیمات" :show.sync="settingModalTrackingJahad" size="xl">
      <CAlert color="warning" closeButton :show.sync="alert">
        {{ alertText }}
      </CAlert>
      <h5 class="text-primary mb-3">
        تنظیمات دستگاه
        <span class="text-danger" dir="ltr">{{ groupName }}</span>
      </h5>
      <hr />

      <TrackingJahadSetting
        :deviceId="deviceId"
        ref="TrackingJahadSetting"
        @update="changeAlarm"
      />

      <template #footer>
        <!-- <CButton
          @click="settingModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" class="mx-1"/>لغو</CButton
        > -->
        <CButton
          @click="settingModalTrackingJahad = false"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" class="mx-1" />بازگشت</CButton
        >

        <CButton
          @click="setDeviceSetting('resetDevice')"
          color="primary"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" class="mx-1" />ریست دستگاه</CButton
        >

        <CButton
          @click="setDeviceSetting('breakPolomp')"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" class="mx-1" />فک پلمپ</CButton
        >
      </template>
    </CModal>

    <!----------------------------------------------------------------------- Ich setting modal -->
    <CModal title="تنظیمات" :show.sync="settingModalIch" size="xl">
      <CAlert color="warning" closeButton :show.sync="alert">
        {{ alertText }}
      </CAlert>
      <h5 class="text-primary mb-3">
        تنظیمات دستگاه
        <span class="text-danger" dir="ltr">{{ groupName }}</span>
      </h5>
      <hr />

      <IchSetting :deviceId="deviceId" ref="Ich" @update="changeAlarm2" />

      <template #footer>
        <!-- <CButton
          @click="settingModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" class="mx-1"/>لغو</CButton
        > -->
        <CButton
          @click="settingModalIch = false"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" class="mx-1" />بازگشت</CButton
        >
      </template>
    </CModal>

    <!----------------------------------------------------------------------- Ich4 setting modal -->
    <CModal title="تنظیمات" :show.sync="settingModalIch4" size="xl">
      <CAlert color="warning" closeButton :show.sync="alert">
        {{ alertText }}
      </CAlert>
      <h5 class="text-primary mb-3">
        تنظیمات دستگاه
        <span class="text-danger" dir="ltr">{{ groupName }}</span>
      </h5>
      <hr />

      <IchSetting4 :deviceId="deviceId" ref="Ich4" @update="changeAlarm2" />

      <template #footer>
        <!-- <CButton
          @click="settingModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" class="mx-1"/>لغو</CButton
        > -->
        <CButton
          @click="settingModalIch4 = false"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" class="mx-1" />بازگشت</CButton
        >
      </template>
    </CModal>

    <!----------------------------------------------------------------------- FE22WE setting modal -->
    <CModal title="تنظیمات" :show.sync="settingModalFE22WE" size="xl">
      <CAlert color="warning" closeButton :show.sync="alert">
        {{ alertText }}
      </CAlert>
      <h5 class="text-primary mb-3">
        تنظیمات دستگاه
        <span class="text-danger" dir="ltr">{{ groupName }}</span>
      </h5>
      <hr />

      <FE22WESetting :deviceId="deviceId" ref="FE22WE" @update="changeAlarm2" />

      <template #footer>
        <!-- <CButton
          @click="settingModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" class="mx-1"/>لغو</CButton
        > -->
        <CButton
          @click="settingModalFE22WE = false"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" class="mx-1" />بازگشت</CButton
        >
      </template>
    </CModal>

    <!----------------------------------------------------------------------- FreezEyeV3 setting modal -->
    <CModal title="تنظیمات" :show.sync="settingModalFreezEyeV3" size="xl">
      <CAlert color="warning" closeButton :show.sync="alert">
        {{ alertText }}
      </CAlert>
      <h5 class="text-primary mb-3">
        تنظیمات دستگاه
        <span class="text-danger" dir="ltr">{{ groupName }}</span>
      </h5>
      <hr />

      <FreezEyeV3Setting
        :deviceId="deviceId"
        ref="FreezEyeV3"
        @update="changeAlarm2"
      />

      <template #footer>
        <!-- <CButton
          @click="settingModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" class="mx-1"/>لغو</CButton
        > -->
        <CButton
          @click="settingModalFreezEyeV3 = false"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" class="mx-1" />بازگشت</CButton
        >
      </template>
    </CModal>

    <!----------------------------------------------------------------------- Log setting modal -->
    <CModal title="مدیریت لاگ" :show.sync="settingModalLog" size="xl">
      <CAlert color="warning" closeButton :show.sync="alert">
        {{ alertText }}
      </CAlert>
      <h5 class="text-primary mb-3">
        دریافت/حذف لاگ
        <span class="text-danger">{{ groupName }}</span>
      </h5>
      <hr />

      <log-setting :deviceId="deviceId" ref="Log" @update="changeAlarm" />

      <template #footer>
        <!-- <CButton
          @click="settingModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" class="mx-1"/>لغو</CButton
        > -->
        <CButton
          @click="settingModalLog = false"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" class="mx-1" />بازگشت</CButton
        >
      </template>
    </CModal>

    <!----------------------------------------------------------------------- Alert modal -->
    <CModal
      :title="alertModalTitle"
      :color="alertModalColor"
      :show.sync="alertModal"
    >
      {{ alertModalText }}

      <template #footer>
        <CButton
          v-if="alertModalTitle != 'حذف دستگاه'"
          @click="alertModal = false"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" class="mx-1" />{{
            alertModalButtonText
          }}</CButton
        >
        <CButton
          v-if="alertModalTitle == 'حذف دستگاه'"
          @click="deleteDevice"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" class="mx-1" />{{
            alertModalButtonText
          }}</CButton
        >
      </template>
    </CModal>

    <!----------------------------------------------------------------------- sensor modal -->
    <CModal title="سنسور/رله" :show.sync="sensorModal" size="xl">
      <CForm class="needs-validation" novalidate>
        <h5 class="text-primary mb-3">
          مشاهده سنسورهای دستگاه
          <span class="text-danger">{{ groupName }}</span>
        </h5>
        <hr />

        <CRow class="justify-content-center"
          ><CButton
            class="btn btn-primary col-sm-5 col-md-3 col-lg-2 mx-1 mt-1"
            v-for="sensor in SensorList.carSensorTypes"
            :key="sensor.sensorTypeName"
            @click="sensorSetting(sensor)"
            >{{ sensor.sensorTypeName }}</CButton
          ></CRow
        >

        <table class="table table-striped m-2">
          <thead>
            <tr>
              <th scope="col">ردیف</th>
              <th scope="col">سنسور</th>
              <th scope="col">مقدار</th>
              <th scope="col">تاریخ/زمان</th>
              <th scope="col">عملیات</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in selectedSensorList" :key="item.id">
              <!-- <th scope="row">{{i+1}}</th> -->
              <td>{{ i + 1 }}</td>
              <td>{{ item.sensorIndexName }}</td>
              <td>{{ item.sensorValue }}</td>
              <td>{{ item.jalaliSensorDateTime }}</td>
              <td>
                <CButton
                  @click="
                    viewActionSensor(
                      item.sensorIndex,
                      item.sensorIndexName,
                      item.jalaliSensorDateTime
                    )
                  "
                  color="info"
                  class="mx-1"
                  ><CIcon name="cil-chart-line"
                /></CButton>
                <!-- <CButton
                  @click="settingActionSensor(item.sensorIndex)"
                  color="warning"
                  class="mx-1"
                  ><CIcon name="cil-settings"
                /></CButton> -->
              </td>
            </tr>
          </tbody>
        </table>
      </CForm>

      <template #footer>
        <!-- <CButton
          @click="sensorModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" />لغو</CButton
        > -->
        <!-- <CButton
          @click="settingActionSensor()"
          color="warning"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-settings" />تنظیم سنسور</CButton
        > -->
        <CButton
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          @click="sensorModal = false"
          ><CIcon name="cil-check-circle" class="mx-2" />بازگشت</CButton
        >
      </template>
    </CModal>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="css">
.table-wrapper {
  height: 60vh !important;
}
</style>

<script>
import axios from "axios";
import { Values } from "../../../src/commonValues";
import vMultiselectListbox from "vue-multiselect-listbox";
import $ from "jquery";
import Multiselect from "vue-multiselect";
import router from "../../router";
import VJstree from "vue-jstree-master"; //rtl
import VueClockPicker from "@pencilpix/vue2-clock-picker";
import FdaSetting from "./FDASetting.vue";
import TrackingSetting from "./TrackingSetting.vue";
import TrackingSetting2 from "./TrackingSetting2.vue";
import TrackingSetting3 from "./TrackingSetting3.vue";
import TrackingJahadSetting from "./TrackingJahadSetting.vue";
import IchSetting from "./IchSetting.vue";
import IchSetting4 from "./Ich4Setting.vue";
import FE22WESetting from "./FE22WESetting.vue";
import FreezEyeV3Setting from "./FreezEyeV3Setting.vue";

import LogSetting from "./logSetting.vue";

import {
  LMap,
  LTileLayer,
  LMarker,
  LTooltip,
  LControlLayers,
  LIcon,
  LControl,
} from "vue2-leaflet";

import "babel-polyfill";
import FDASetting from "./FDASetting.vue";

export default {
  name: "Modals",

  components: {
    VueClockPicker,
    vMultiselectListbox,
    Multiselect,
    VJstree,
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LControlLayers,
    LIcon,
    LControl,
    FDASetting,
    TrackingSetting,
    TrackingSetting2,
    TrackingSetting3,
    TrackingJahadSetting,
    IchSetting,
    IchSetting4,
    LogSetting,
    FE22WESetting,
    FreezEyeV3Setting,
  },

  data() {
    return {
      timeOut: 30000,
      spinnerWifi: false,
      spinnerWifiSsid: false,
      spinnerEthernet: false,
      spinnerServer: false,
      spinnerSimcard: false,
      spinnerStartDelay: false,
      spinnerVoiceAlarm: false,
      spinnerPuls: false,
      spinnerSms: false,
      spinnerSmsHum: false,
      spinnerSmsTemp: false,
      spinnerSensor: false,
      spinnerSerialNumber: false,

      fillterActive: false,
      showFilter: 0,
      structureListFillter: [],
      devicesFelltered: [],
      alarmMinMax: [],
      showAlarm: 1,

      tileProviders: Values.tileProviders,
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 6,
      center: [33.504, 51.26],
      markerLatLng: [33.504, 51.26],

      accordion: 0,
      showGPRS: 0,
      showSimcard: 0,
      showWifi: 0,
      showWifiSsid: 0,
      showEthernet: 0,
      showSmsReception: 0,
      showVoiceAlarm: 0,
      showSmsCostAlarm: 0,
      showPulsAlarm: 0,
      showSmsAlarm: 0,
      showSmsAlarmHum: 0,
      showSmsAlarmTemp: 0,
      showSensorAlarm: 0,
      showStartDelay: 0,
      showSerialNumber: 0,
      showDateTeimeAlarm: 0,

      addModal: false,
      assignModal: false,
      settingModalFda: false,
      settingModalTracking: false,
      settingModalTracking2: false,
      settingModalTracking3: false,
      settingModalTrackingJahad: false,
      settingModalIch: false,
      settingModalIch4: false,
      settingModalFE22WE: false,
      settingModalFreezEyeV3: false,
      settingModalLog: false,
      devices: [],
      modalTitle: "",
      modalButtonSubmit: "",

      alertModal: false,
      alertModalTitle: "",
      alertModalText: "",
      alertModalButtonText: "",
      alertModalColor: "",
      deviceId: "",

      smsModal: false,
      settingModal: false,
      smsSettingInfo: {
        phoneNumber: "",
        timeMaxTemp: "",
        timeMinTemp: "",
        timeMaxHum: "",
        timeMinHum: "",
        timeDisPower: "",
        timeDisSensor: "",
        reception: {
          value: "1",
          label: "گیرنده اول",
        },
        receptionTemp: {
          value: "1",
          label: "گیرنده اول",
        },
        receptionHum: {
          value: "1",
          label: "گیرنده اول",
        },
        active: false,
        textSms: false,
        puls: false,
      },
      receptionList: [
        {
          value: "1",
          label: "گیرنده اول",
        },
        {
          value: "2",
          label: "گیرنده دوم",
        },
        {
          value: "3",
          label: "گیرنده سوم",
        },
        {
          value: "4",
          label: "گیرنده چهارم",
        },
        {
          value: "5",
          label: "گیرنده پنجم",
        },
        {
          value: "6",
          label: "گیرنده ششم",
        },
      ],

      detectedCarModal: false,
      detectedCarModalTitle: "",
      detectedCarModalText: "",
      detectedCarModalButtonText: "",
      detectedCarModalColor: "",
      detectedCarModalStatus: true,
      detectedCarModalInfo: Object,

      info: {
        id: "",
        name: "",
        serial: "",
        status: { label: "", value: 4 },
        description: "",
        ModelValue: [{ label: "", value: "" }],
        networkValue: [{ label: "", value: 0 }],
        defaultNetworkValue: { label: "", value: 0 },
        password: "",
        startDelay: 0,
        eigthSensor: "8",
        seventhSensor: "7",
        sixthSensor: "6",
        fifthSensor: "5",
        forthSensor: "4",
        thirdSensor: "3",
        secondSensor: "2",
        firstSensor: "1",
        gprsIpAddress: "127.0.0.1",
        wifiIpAddress: "127.0.0.1",
        ethernetIpAddress: "127.0.0.1",
        gprsPortAddress: 3242,
        wifiPortAddress: 3242,
        ethernetPortAddress: 3242,
        FdaWebServiceAddress: "",
        periodicUpdateTimeValue: [{ label: "", value: 0 }],
        currentKilometer: 0,
        registrationPlate1: "",
        registrationPlate2: "",
        registrationPlate3: "",
        registrationPlate4: "",
        driver: "",
        deviceType: [{ label: "ثابت", value: false }],
        dailyReportSend: [{ label: "فعال", value: true }],

        FdaBranchId: "",
        FdaRoomId: "",

        FdaSensorId1: "1",
        FdaSensorId2: "2",
        FdaSensorId3: "3",
        FdaSensorId4: "4",
        FdaSensorId5: "5",
        FdaSensorId6: "6",
        FdaSensorId7: "7",
        FdaSensorId8: "8",
        simcardNum: "",
      },

      LetterList: [
        {
          value: "الف",
          label: "الف",
        },
        {
          value: "ب",
          label: "ب",
        },
        {
          value: "پ",
          label: "پ",
        },
        {
          value: "ت",
          label: "ت",
        },
        {
          value: "ث",
          label: "ث",
        },
        {
          value: "ج",
          label: "ج",
        },
        {
          value: "چ",
          label: "چ",
        },
        {
          value: "ح",
          label: "ح",
        },
        {
          value: "خ",
          label: "خ",
        },
        {
          value: "د",
          label: "د",
        },
        {
          value: "ذ",
          label: "ذ",
        },
        {
          value: "ر",
          label: "ر",
        },
        {
          value: "ز",
          label: "ز",
        },
        {
          value: "ژ",
          label: "ژ",
        },
        {
          value: "س",
          label: "س",
        },
        {
          value: "ش",
          label: "ش",
        },
        {
          value: "ص",
          label: "ص",
        },
        {
          value: "ض",
          label: "ض",
        },
        {
          value: "ط",
          label: "ط",
        },
        {
          value: "ظ",
          label: "ظ",
        },
        {
          value: "ع",
          label: "ع",
        },
        {
          value: "غ",
          label: "غ",
        },
        {
          value: "ف",
          label: "ف",
        },
        {
          value: "ق",
          label: "ق",
        },
        {
          value: "ک",
          label: "ک",
        },
        {
          value: "گ",
          label: "گ",
        },
        {
          value: "ل",
          label: "ل",
        },
        {
          value: "م",
          label: "م",
        },
        {
          value: "ن",
          label: "ن",
        },
        {
          value: "و",
          label: "و",
        },
        {
          value: "ه",
          label: "ه",
        },
        {
          value: "ی",
          label: "ی",
        },
      ],

      deviceTypeList: [
        { label: "ثابت", value: false },
        { label: "متحرک", value: true },
      ],

      dailyReportSendList: [
        { label: "فعال", value: true },
        { label: "غیرفعال", value: false },
      ],

      startDelayUpdateTime: "---",

      simcard: {
        simCardNum: "",
        sendSmsStatus: false,
        simcardDataStatus: false,
        updateTime: "---",
      },

      wifi: {
        ipAddress: "",
        subnetMask: "",
        gateway: "",
        dns: "",
        ssid: "",
        password: "",
        active: false,
        updateTime: "---",
      },

      ethernet: {
        ipAddress: "",
        subnetMask: "",
        gateway: "",
        dns: "",
        updateTime: "---",
      },

      serverInfo: {
        ipAddressGPRS: "",
        ipAddressWiFi: "",
        ipAddressEthernet: "",
        port: "",
        timeDistance: "",
        debugSystem: false,
        debugGsm: false,
        debugWifi: false,

        wifi: false,
        ethernet: false,
        gprs: false,
        updateTime: "---",
      },

      smsReception: {
        first: "",
        second: "",
        third: "",
        forth: "",
        fifth: "",
        sixth: "",
        updateTime: "---",
      },

      voiceAlarmInfo: {
        delay: "",
        length: "",
        voiceTemp: false,
        smsTemp: false,
        voiceHum: false,
        smsHum: false,
        updateTime: "---",
      },

      serial: { serialTime: "", serialNumber: "" },

      SmsCost: {
        sendTime: "",
        cost: "",
      },

      pulsInfo: {
        first: "",
        second: "",
        updateTime: "---",
      },

      dateTime: { dateTime: "", updateTime: "" },

      StatusList: [],
      optionList: [],
      selectedList: [],
      SimcardOpratorList: [
        { name: "همراه اول", id: 1 },
        { name: "ایرانسل", id: 2 },
        { name: "سایر", id: 0 },
      ],
      SimcardOprator: [],
      simcardUpdateTime: "---",

      SimcardTypeList: [
        { name: "ثابت", id: 1 },
        { name: "اعتباری", id: 2 },
      ],
      SimcardType: [],

      groupName: "",
      disableMultiselect: false,

      ModelList: [],
      // ModelList: [
      //   { label: "wifi", value: "wifi" },
      //   { label: "ethernet", value: "ethernet" },
      //   { label: "gprs", value: "gprs" },
      // ],

      networkList: [
        // { label: "wifi", value: "0" },
        // { label: "ethernet", value: "1" },
        // { label: "gprs", value: "gprs" },
      ],

      sensorModal: false,
      selectedSensorList: [],
      selectedSensorTypeId: Number,
      // SensorList: [],
      SensorList: [
        {
          serialNumber: "",
          carSensorTypes: [],
        },
      ],

      alert: false,
      alertText: "",
      showPage: true,

      structureList: [],
      selectedParent: "",

      settingValues: [],
      settingValuesSensor: [],

      fullData: [],
      indexListSensor: [],

      indexValueSensor: { label: "", value: "" },
      sensorUpdateTime: "---",

      typeList: [
        { label: "LPTO", value: "1" },
        { label: "HPTO", value: "10" },
        { label: "HPTH", value: "11" },
      ],

      typeValue: [],
      selectedSensors: [],
      activeSensor: false,

      periodicUpdateTime: [
        {
          value: 0,
          label: "غیرفعال",
        },
        {
          value: 10,
          label: "10 دقیقه",
        },
        {
          value: 20,
          label: "20 دقیقه",
        },
        {
          value: 30,
          label: "30 دقیقه",
        },
        {
          value: 40,
          label: "40 دقیقه",
        },
        {
          value: 50,
          label: "50 دقیقه",
        },
        {
          value: 1440,
          label: "روزانه",
        },
      ],

      iconList: [
        { value: "fa-align-left", label: "fa-align-left" },
        { value: "fa-align-right", label: "fa-align-right" },
        { value: "fa-amazon", label: "fa-amazon" },
        { value: "fa-ambulance", label: "fa-ambulance" },
        { value: "fa-anchor", label: "fa-anchor" },
        { value: "fa-android", label: "fa-android" },
        { value: "fa-angellist", label: "fa-angellist" },
        { value: "fa-angle-double-down", label: "fa-angle-double-down" },
        { value: "fa-angle-double-left", label: "fa-angle-double-left" },
        { value: "fa-angle-double-right", label: "fa-angle-double-right" },
        { value: "fa-angle-double-up", label: "fa-angle-double-up" },
        { value: "fa-angle-left", label: "fa-angle-left" },
        { value: "fa-angle-right", label: "fa-angle-right" },
        { value: "fa-angle-up", label: "fa-angle-up" },
        { value: "fa-apple", label: "fa-apple" },
        { value: "fa-archive", label: "fa-archive" },
        { value: "fa-area-chart", label: "fa-area-chart" },
        { value: "fa-arrow-circle-down", label: "fa-arrow-circle-down" },
        { value: "fa-arrow-circle-left", label: "fa-arrow-circle-left" },
        { value: "fa-arrow-circle-o-down", label: "fa-arrow-circle-o-down" },
        { value: "fa-arrow-circle-o-left", label: "fa-arrow-circle-o-left" },
        { value: "fa-arrow-circle-o-right", label: "fa-arrow-circle-o-right" },
        { value: "fa-arrow-circle-o-up", label: "fa-arrow-circle-o-up" },
        { value: "fa-arrow-circle-right", label: "fa-arrow-circle-right" },
        { value: "fa-arrow-circle-up", label: "fa-arrow-circle-up" },
        { value: "fa-arrow-down", label: "fa-arrow-down" },
        { value: "fa-arrow-left", label: "fa-arrow-left" },
        { value: "fa-arrow-right", label: "fa-arrow-right" },
        { value: "fa-arrow-up", label: "fa-arrow-up" },
        { value: "fa-arrows", label: "fa-arrows" },
        { value: "fa-arrows-alt", label: "fa-arrows-alt" },
        { value: "fa-arrows-h", label: "fa-arrows-h" },
        { value: "fa-arrows-v", label: "fa-arrows-v" },
        { value: "fa-asterisk", label: "fa-asterisk" },
        { value: "fa-at", label: "fa-at" },
        { value: "fa-automobile", label: "fa-automobile" },
        { value: "fa-backward", label: "fa-backward" },
        { value: "fa-balance-scale", label: "fa-balance-scale" },
        { value: "fa-ban", label: "fa-ban" },
        { value: "fa-bank", label: "fa-bank" },
        { value: "fa-bar-chart", label: "fa-bar-chart" },
        { value: "fa-bar-chart-o", label: "fa-bar-chart-o" },
        { value: "fa-battery-full", label: "fa-battery-full" },
        { value: "fa-beer", label: "fa-beer" },
        { value: "fa-behance", label: "fa-behance" },
        { value: "fa-behance-square", label: "fa-behance-square" },
        { value: "fa-bell", label: "fa-bell" },
        { value: "fa-bell-o", label: "fa-bell-o" },
        { value: "fa-bell-slash", label: "fa-bell-slash" },
        { value: "fa-bell-slash-o", label: "fa-bell-slash-o" },
        { value: "fa-bicycle", label: "fa-bicycle" },
        { value: "fa-binoculars", label: "fa-binoculars" },
        { value: "fa-birthday-cake", label: "fa-birthday-cake" },
        { value: "fa-bitbucket", label: "fa-bitbucket" },
        { value: "fa-bitbucket-square", label: "fa-bitbucket-square" },
        { value: "fa-bitcoin", label: "fa-bitcoin" },
        { value: "fa-black-tie", label: "fa-black-tie" },
        { value: "fa-bold", label: "fa-bold" },
        { value: "fa-bolt", label: "fa-bolt" },
        { value: "fa-bomb", label: "fa-bomb" },
        { value: "fa-book", label: "fa-book" },
        { value: "fa-bookmark", label: "fa-bookmark" },
        { value: "fa-bookmark-o", label: "fa-bookmark-o" },
        { value: "fa-briefcase", label: "fa-briefcase" },
        { value: "fa-btc", label: "fa-btc" },
        { value: "fa-bug", label: "fa-bug" },
        { value: "fa-building", label: "fa-building" },
        { value: "fa-building-o", label: "fa-building-o" },
        { value: "fa-bullhorn", label: "fa-bullhorn" },
        { value: "fa-bullseye", label: "fa-bullseye" },
        { value: "fa-bus", label: "fa-bus" },
        { value: "fa-cab", label: "fa-cab" },
        { value: "fa-calendar", label: "fa-calendar" },
        { value: "fa-camera", label: "fa-camera" },
        { value: "fa-car", label: "fa-car" },
        { value: "fa-caret-up", label: "fa-caret-up" },
        { value: "fa-cart-plus", label: "fa-cart-plus" },
        { value: "fa-cc", label: "fa-cc" },
        { value: "fa-cc-amex", label: "fa-cc-amex" },
        { value: "fa-cc-jcb", label: "fa-cc-jcb" },
        { value: "fa-cc-paypal", label: "fa-cc-paypal" },
        { value: "fa-cc-stripe", label: "fa-cc-stripe" },
        { value: "fa-cc-visa", label: "fa-cc-visa" },
        { value: "fa-chain", label: "fa-chain" },
        { value: "fa-check", label: "fa-check" },
        { value: "fa-chevron-left", label: "fa-chevron-left" },
        { value: "fa-chevron-right", label: "fa-chevron-right" },
        { value: "fa-chevron-up", label: "fa-chevron-up" },
        { value: "fa-child", label: "fa-child" },
        { value: "fa-chrome", label: "fa-chrome" },
        { value: "fa-circle", label: "fa-circle" },
        { value: "fa-circle-o", label: "fa-circle-o" },
        { value: "fa-circle-o-notch", label: "fa-circle-o-notch" },
        { value: "fa-circle-thin", label: "fa-circle-thin" },
        { value: "fa-clipboard", label: "fa-clipboard" },
        { value: "fa-clock-o", label: "fa-clock-o" },
        { value: "fa-clone", label: "fa-clone" },
        { value: "fa-close", label: "fa-close" },
        { value: "fa-cloud", label: "fa-cloud" },
        { value: "fa-cloud-download", label: "fa-cloud-download" },
        { value: "fa-cloud-upload", label: "fa-cloud-upload" },
        { value: "fa-cny", label: "fa-cny" },
        { value: "fa-code", label: "fa-code" },
        { value: "fa-code-fork", label: "fa-code-fork" },
        { value: "fa-codepen", label: "fa-codepen" },
        { value: "fa-coffee", label: "fa-coffee" },
        { value: "fa-cog", label: "fa-cog" },
        { value: "fa-cogs", label: "fa-cogs" },
        { value: "fa-columns", label: "fa-columns" },
        { value: "fa-comment", label: "fa-comment" },
        { value: "fa-comment-o", label: "fa-comment-o" },
        { value: "fa-commenting", label: "fa-commenting" },
        { value: "fa-commenting-o", label: "fa-commenting-o" },
        { value: "fa-comments", label: "fa-comments" },
        { value: "fa-comments-o", label: "fa-comments-o" },
        { value: "fa-compass", label: "fa-compass" },
        { value: "fa-compress", label: "fa-compress" },
        { value: "fa-connectdevelop", label: "fa-connectdevelop" },
        { value: "fa-contao", label: "fa-contao" },
        { value: "fa-copy", label: "fa-copy" },
        { value: "fa-copyright", label: "fa-copyright" },
        { value: "fa-creative-commons", label: "fa-creative-commons" },
        { value: "fa-credit-card", label: "fa-credit-card" },
        { value: "fa-crop", label: "fa-crop" },
        { value: "fa-crosshairs", label: "fa-crosshairs" },
        { value: "fa-css3", label: "fa-css3" },
        { value: "fa-cube", label: "fa-cube" },
        { value: "fa-cubes", label: "fa-cubes" },
        { value: "fa-cut", label: "fa-cut" },
        { value: "fa-cutlery", label: "fa-cutlery" },
        { value: "fa-dashboard", label: "fa-dashboard" },
        { value: "fa-dashcube", label: "fa-dashcube" },
        { value: "fa-database", label: "fa-database" },
        { value: "fa-dedent", label: "fa-dedent" },
        { value: "fa-delicious", label: "fa-delicious" },
        { value: "fa-desktop", label: "fa-desktop" },
        { value: "fa-deviantart", label: "fa-deviantart" },
        { value: "fa-diamond", label: "fa-diamond" },
        { value: "fa-digg", label: "fa-digg" },
        { value: "fa-dollar", label: "fa-dollar" },
        { value: "fa-download", label: "fa-download" },
        { value: "fa-dribbble", label: "fa-dribbble" },
        { value: "fa-dropbox", label: "fa-dropbox" },
        { value: "fa-drupal", label: "fa-drupal" },
        { value: "fa-edit", label: "fa-edit" },
        { value: "fa-eject", label: "fa-eject" },
        { value: "fa-ellipsis-h", label: "fa-ellipsis-h" },
        { value: "fa-ellipsis-v", label: "fa-ellipsis-v" },
        { value: "fa-empire", label: "fa-empire" },
        { value: "fa-envelope", label: "fa-envelope" },
        { value: "fa-envelope-o", label: "fa-envelope-o" },
        { value: "fa-eur", label: "fa-eur" },
        { value: "fa-euro", label: "fa-euro" },
        { value: "fa-exchange", label: "fa-exchange" },
        { value: "fa-exclamation", label: "fa-exclamation" },
        { value: "fa-exclamation-circle", label: "fa-exclamation-circle" },
        { value: "fa-exclamation-triangle", label: "fa-exclamation-triangle" },
        { value: "fa-expand", label: "fa-expand" },
        { value: "fa-expeditedssl", label: "fa-expeditedssl" },
        { value: "fa-external-link", label: "fa-external-link" },
        { value: "fa-external-link-square", label: "fa-external-link-square" },
        { value: "fa-eye", label: "fa-eye" },
        { value: "fa-eye-slash", label: "fa-eye-slash" },
        { value: "fa-eyedropper", label: "fa-eyedropper" },
        { value: "fa-facebook", label: "fa-facebook" },
        { value: "fa-facebook-f", label: "fa-facebook-f" },
        { value: "fa-facebook-official", label: "fa-facebook-official" },
        { value: "fa-facebook-square", label: "fa-facebook-square" },
        { value: "fa-fast-backward", label: "fa-fast-backward" },
        { value: "fa-fast-forward", label: "fa-fast-forward" },
        { value: "fa-fax", label: "fa-fax" },
        { value: "fa-feed", label: "fa-feed" },
        { value: "fa-female", label: "fa-female" },
        { value: "fa-fighter-jet", label: "fa-fighter-jet" },
        { value: "fa-file", label: "fa-file" },
        { value: "fa-file-archive-o", label: "fa-file-archive-o" },
        { value: "fa-file-audio-o", label: "fa-file-audio-o" },
        { value: "fa-file-code-o", label: "fa-file-code-o" },
        { value: "fa-file-excel-o", label: "fa-file-excel-o" },
        { value: "fa-file-image-o", label: "fa-file-image-o" },
        { value: "fa-file-movie-o", label: "fa-file-movie-o" },
        { value: "fa-file-o", label: "fa-file-o" },
        { value: "fa-file-pdf-o", label: "fa-file-pdf-o" },
        { value: "fa-file-photo-o", label: "fa-file-photo-o" },
        { value: "fa-file-picture-o", label: "fa-file-picture-o" },
        { value: "fa-file-powerpoint-o", label: "fa-file-powerpoint-o" },
        { value: "fa-file-sound-o", label: "fa-file-sound-o" },
        { value: "fa-file-text", label: "fa-file-text" },
        { value: "fa-file-text-o", label: "fa-file-text-o" },
        { value: "fa-file-video-o", label: "fa-file-video-o" },
        { value: "fa-file-word-o", label: "fa-file-word-o" },
        { value: "fa-file-zip-o", label: "fa-file-zip-o" },
        { value: "fa-files-o", label: "fa-files-o" },
        { value: "fa-film", label: "fa-film" },
        { value: "fa-filter", label: "fa-filter" },
        { value: "fa-fire", label: "fa-fire" },
        { value: "fa-fire-extinguisher", label: "fa-fire-extinguisher" },
        { value: "fa-firefox", label: "fa-firefox" },
        { value: "fa-flag", label: "fa-flag" },
        { value: "fa-flag-checkered", label: "fa-flag-checkered" },
        { value: "fa-flag-o", label: "fa-flag-o" },
        { value: "fa-flash", label: "fa-flash" },
        { value: "fa-flask", label: "fa-flask" },
        { value: "fa-flickr", label: "fa-flickr" },
        { value: "fa-floppy-o", label: "fa-floppy-o" },
        { value: "fa-folder", label: "fa-folder" },
        { value: "fa-folder-o", label: "fa-folder-o" },
        { value: "fa-folder-open", label: "fa-folder-open" },
        { value: "fa-folder-open-o", label: "fa-folder-open-o" },
        { value: "fa-font", label: "fa-font" },
        { value: "fa-fonticons", label: "fa-fonticons" },
        { value: "fa-forumbee", label: "fa-forumbee" },
        { value: "fa-forward", label: "fa-forward" },
        { value: "fa-foursquare", label: "fa-foursquare" },
        { value: "fa-frown-o", label: "fa-frown-o" },
        { value: "fa-futbol-o", label: "fa-futbol-o" },
        { value: "fa-gamepad", label: "fa-gamepad" },
        { value: "fa-gavel", label: "fa-gavel" },
        { value: "fa-gbp", label: "fa-gbp" },
        { value: "fa-ge", label: "fa-ge" },
        { value: "fa-gear", label: "fa-gear" },
        { value: "fa-gears", label: "fa-gears" },
        { value: "fa-genderless", label: "fa-genderless" },
        { value: "fa-get-pocket", label: "fa-get-pocket" },
        { value: "fa-gg", label: "fa-gg" },
        { value: "fa-gg-circle", label: "fa-gg-circle" },
        { value: "fa-gift", label: "fa-gift" },
        { value: "fa-git", label: "fa-git" },
        { value: "fa-git-square", label: "fa-git-square" },
        { value: "fa-github", label: "fa-github" },
        { value: "fa-github-alt", label: "fa-github-alt" },
        { value: "fa-github-square", label: "fa-github-square" },
        { value: "fa-gittip", label: "fa-gittip" },
        { value: "fa-glass", label: "fa-glass" },
        { value: "fa-globe", label: "fa-globe" },
        { value: "fa-google", label: "fa-google" },
        { value: "fa-google-plus", label: "fa-google-plus" },
        { value: "fa-google-plus-square", label: "fa-google-plus-square" },
        { value: "fa-google-wallet", label: "fa-google-wallet" },
        { value: "fa-graduation-cap", label: "fa-graduation-cap" },
        { value: "fa-gratipay", label: "fa-gratipay" },
        { value: "fa-group", label: "fa-group" },
        { value: "fa-h-square", label: "fa-h-square" },
        { value: "fa-hacker-news", label: "fa-hacker-news" },
        { value: "fa-hand-grab-o", label: "fa-hand-grab-o" },
        { value: "fa-hand-lizard-o", label: "fa-hand-lizard-o" },
        { value: "fa-hand-o-down", label: "fa-hand-o-down" },
        { value: "fa-hand-o-left", label: "fa-hand-o-left" },
        { value: "fa-hand-o-right", label: "fa-hand-o-right" },
        { value: "fa-hand-o-up", label: "fa-hand-o-up" },
        { value: "fa-hand-paper-o", label: "fa-hand-paper-o" },
        { value: "fa-hand-peace-o", label: "fa-hand-peace-o" },
        { value: "fa-hand-pointer-o", label: "fa-hand-pointer-o" },
        { value: "fa-hand-rock-o", label: "fa-hand-rock-o" },
        { value: "fa-hand-scissors-o", label: "fa-hand-scissors-o" },
        { value: "fa-hand-spock-o", label: "fa-hand-spock-o" },
        { value: "fa-hand-stop-o", label: "fa-hand-stop-o" },
        { value: "fa-hdd-o", label: "fa-hdd-o" },
        { value: "fa-header", label: "fa-header" },
        { value: "fa-headphones", label: "fa-headphones" },
        { value: "fa-heart", label: "fa-heart" },
        { value: "fa-heart-o", label: "fa-heart-o" },
        { value: "fa-heartbeat", label: "fa-heartbeat" },
        { value: "fa-history", label: "fa-history" },
        { value: "fa-home", label: "fa-home" },
        { value: "fa-hospital-o", label: "fa-hospital-o" },
        { value: "fa-hotel", label: "fa-hotel" },
        { value: "fa-hourglass", label: "fa-hourglass" },
        { value: "fa-hourglass-1", label: "fa-hourglass-1" },
        { value: "fa-hourglass-2", label: "fa-hourglass-2" },
        { value: "fa-hourglass-3", label: "fa-hourglass-3" },
        { value: "fa-hourglass-end", label: "fa-hourglass-end" },
        { value: "fa-hourglass-half", label: "fa-hourglass-half" },
        { value: "fa-hourglass-o", label: "fa-hourglass-o" },
        { value: "fa-hourglass-start", label: "fa-hourglass-start" },
        { value: "fa-houzz", label: "fa-houzz" },
        { value: "fa-html5", label: "fa-html5" },
        { value: "fa-i-cursor", label: "fa-i-cursor" },
        { value: "fa-ils", label: "fa-ils" },
        { value: "fa-image", label: "fa-image" },
        { value: "fa-inbox", label: "fa-inbox" },
        { value: "fa-indent", label: "fa-indent" },
        { value: "fa-industry", label: "fa-industry" },
        { value: "fa-info", label: "fa-info" },
        { value: "fa-info-circle", label: "fa-info-circle" },
        { value: "fa-inr", label: "fa-inr" },
        { value: "fa-instagram", label: "fa-instagram" },
        { value: "fa-institution", label: "fa-institution" },
        { value: "fa-internet-explorer", label: "fa-internet-explorer" },
        { value: "fa-intersex", label: "fa-intersex" },
        { value: "fa-ioxhost", label: "fa-ioxhost" },
        { value: "fa-italic", label: "fa-italic" },
        { value: "fa-joomla", label: "fa-joomla" },
        { value: "fa-jpy", label: "fa-jpy" },
        { value: "fa-jsfiddle", label: "fa-jsfiddle" },
        { value: "fa-key", label: "fa-key" },
        { value: "fa-keyboard-o", label: "fa-keyboard-o" },
        { value: "fa-krw", label: "fa-krw" },
        { value: "fa-language", label: "fa-language" },
        { value: "fa-laptop", label: "fa-laptop" },
        { value: "fa-lastfm", label: "fa-lastfm" },
        { value: "fa-lastfm-square", label: "fa-lastfm-square" },
        { value: "fa-leaf", label: "fa-leaf" },
        { value: "fa-leanpub", label: "fa-leanpub" },
        { value: "fa-legal", label: "fa-legal" },
        { value: "fa-lemon-o", label: "fa-lemon-o" },
        { value: "fa-level-down", label: "fa-level-down" },
        { value: "fa-level-up", label: "fa-level-up" },
        { value: "fa-life-bouy", label: "fa-life-bouy" },
        { value: "fa-life-buoy", label: "fa-life-buoy" },
        { value: "fa-life-ring", label: "fa-life-ring" },
        { value: "fa-life-saver", label: "fa-life-saver" },
        { value: "fa-lightbulb-o", label: "fa-lightbulb-o" },
        { value: "fa-line-chart", label: "fa-line-chart" },
        { value: "fa-link", label: "fa-link" },
        { value: "fa-linkedin", label: "fa-linkedin" },
        { value: "fa-linkedin-square", label: "fa-linkedin-square" },
        { value: "fa-linux", label: "fa-linux" },
        { value: "fa-list", label: "fa-list" },
        { value: "fa-list-alt", label: "fa-list-alt" },
        { value: "fa-list-ol", label: "fa-list-ol" },
        { value: "fa-list-ul", label: "fa-list-ul" },
        { value: "fa-location-arrow", label: "fa-location-arrow" },
        { value: "fa-lock", label: "fa-lock" },
        { value: "fa-long-arrow-down", label: "fa-long-arrow-down" },
        { value: "fa-long-arrow-left", label: "fa-long-arrow-left" },
        { value: "fa-long-arrow-right", label: "fa-long-arrow-right" },
        { value: "fa-long-arrow-up", label: "fa-long-arrow-up" },
        { value: "fa-magic", label: "fa-magic" },
        { value: "fa-magnet", label: "fa-magnet" },
        { value: "fa-mars-stroke-v", label: "fa-mars-stroke-v" },
        { value: "fa-maxcdn", label: "fa-maxcdn" },
        { value: "fa-meanpath", label: "fa-meanpath" },
        { value: "fa-medium", label: "fa-medium" },
        { value: "fa-medkit", label: "fa-medkit" },
        { value: "fa-meh-o", label: "fa-meh-o" },
        { value: "fa-mercury", label: "fa-mercury" },
        { value: "fa-microphone", label: "fa-microphone" },
        { value: "fa-mobile", label: "fa-mobile" },
        { value: "fa-motorcycle", label: "fa-motorcycle" },
        { value: "fa-mouse-pointer", label: "fa-mouse-pointer" },
        { value: "fa-music", label: "fa-music" },
        { value: "fa-navicon", label: "fa-navicon" },
        { value: "fa-neuter", label: "fa-neuter" },
        { value: "fa-newspaper-o", label: "fa-newspaper-o" },
        { value: "fa-opencart", label: "fa-opencart" },
        { value: "fa-openid", label: "fa-openid" },
        { value: "fa-opera", label: "fa-opera" },
        { value: "fa-outdent", label: "fa-outdent" },
        { value: "fa-pagelines", label: "fa-pagelines" },
        { value: "fa-paper-plane-o", label: "fa-paper-plane-o" },
        { value: "fa-paperclip", label: "fa-paperclip" },
        { value: "fa-paragraph", label: "fa-paragraph" },
        { value: "fa-paste", label: "fa-paste" },
        { value: "fa-pause", label: "fa-pause" },
        { value: "fa-paw", label: "fa-paw" },
        { value: "fa-paypal", label: "fa-paypal" },
        { value: "fa-pencil", label: "fa-pencil" },
        { value: "fa-pencil-square-o", label: "fa-pencil-square-o" },
        { value: "fa-phone", label: "fa-phone" },
        { value: "fa-photo", label: "fa-photo" },
        { value: "fa-picture-o", label: "fa-picture-o" },
        { value: "fa-pie-chart", label: "fa-pie-chart" },
        { value: "fa-pied-piper", label: "fa-pied-piper" },
        { value: "fa-pied-piper-alt", label: "fa-pied-piper-alt" },
        { value: "fa-pinterest", label: "fa-pinterest" },
        { value: "fa-pinterest-p", label: "fa-pinterest-p" },
        { value: "fa-pinterest-square", label: "fa-pinterest-square" },
        { value: "fa-plane", label: "fa-plane" },
        { value: "fa-play", label: "fa-play" },
        { value: "fa-play-circle", label: "fa-play-circle" },
        { value: "fa-play-circle-o", label: "fa-play-circle-o" },
        { value: "fa-plug", label: "fa-plug" },
        { value: "fa-plus", label: "fa-plus" },
        { value: "fa-plus-circle", label: "fa-plus-circle" },
        { value: "fa-plus-square", label: "fa-plus-square" },
        { value: "fa-plus-square-o", label: "fa-plus-square-o" },
        { value: "fa-power-off", label: "fa-power-off" },
        { value: "fa-print", label: "fa-print" },
        { value: "fa-puzzle-piece", label: "fa-puzzle-piece" },
        { value: "fa-qq", label: "fa-qq" },
        { value: "fa-qrcode", label: "fa-qrcode" },
        { value: "fa-question", label: "fa-question" },
        { value: "fa-question-circle", label: "fa-question-circle" },
        { value: "fa-quote-left", label: "fa-quote-left" },
        { value: "fa-quote-right", label: "fa-quote-right" },
        { value: "fa-ra", label: "fa-ra" },
        { value: "fa-random", label: "fa-random" },
        { value: "fa-rebel", label: "fa-rebel" },
        { value: "fa-recycle", label: "fa-recycle" },
        { value: "fa-reddit", label: "fa-reddit" },
        { value: "fa-reddit-square", label: "fa-reddit-square" },
        { value: "fa-refresh", label: "fa-refresh" },
        { value: "fa-registered", label: "fa-registered" },
        { value: "fa-remove", label: "fa-remove" },
        { value: "fa-renren", label: "fa-renren" },
        { value: "fa-reorder", label: "fa-reorder" },
        { value: "fa-repeat", label: "fa-repeat" },
        { value: "fa-reply", label: "fa-reply" },
        { value: "fa-reply-all", label: "fa-reply-all" },
        { value: "fa-retweet", label: "fa-retweet" },
        { value: "fa-rmb", label: "fa-rmb" },
        { value: "fa-road", label: "fa-road" },
        { value: "fa-rocket", label: "fa-rocket" },
        { value: "fa-rotate-left", label: "fa-rotate-left" },
        { value: "fa-rotate-right", label: "fa-rotate-right" },
        { value: "fa-rouble", label: "fa-rouble" },
        { value: "fa-rss", label: "fa-rss" },
        { value: "fa-rss-square", label: "fa-rss-square" },
        { value: "fa-rub", label: "fa-rub" },
        { value: "fa-ruble", label: "fa-ruble" },
        { value: "fa-rupee", label: "fa-rupee" },
        { value: "fa-safari", label: "fa-safari" },
        { value: "fa-sliders", label: "fa-sliders" },
        { value: "fa-slideshare", label: "fa-slideshare" },
        { value: "fa-smile-o", label: "fa-smile-o" },
        { value: "fa-sort-asc", label: "fa-sort-asc" },
        { value: "fa-sort-desc", label: "fa-sort-desc" },
        { value: "fa-sort-down", label: "fa-sort-down" },
        { value: "fa-spinner", label: "fa-spinner" },
        { value: "fa-spoon", label: "fa-spoon" },
        { value: "fa-spotify", label: "fa-spotify" },
        { value: "fa-square", label: "fa-square" },
        { value: "fa-square-o", label: "fa-square-o" },
        { value: "fa-star", label: "fa-star" },
        { value: "fa-star-half", label: "fa-star-half" },
        { value: "fa-stop", f04d: "fa-stop" },
        { value: "fa-subscript", label: "fa-subscript" },
        { value: "fa-tablet", f10a: "fa-tablet" },
        { value: "fa-tachometer", label: "fa-tachometer" },
        { value: "fa-tag", label: "fa-tag" },
        { value: "fa-tags", label: "fa-tags" },
      ],

      filteredListIcon: [],
      show_icon: false,
      selectedIcon: "fa fa-car",
      searchIconValue: "",
      is_search_icon: false,

      ipformat:
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
      mobileFormat: /^(09(0[1-2]|1[0-9]|3[0-9]|2[0-1])-?[0-9]{3}-?[0-9]{4})$/,
      emailFormat: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
    };
  },

  computed: {
    parametersTable() {
      return {
        data:
          this.fillterActive == false ? this.devices : this.devicesFelltered,
        actionMode: "multiple",
        // showPerPage:true,
        perPageSizes: [5, 10, 25, 50, 100],
        defaultPerPage: 5,
        //dir:"ltr",
        columns: [
          {
            key: "rowNumber",
            title: "ردیف",
            sortable: false,
          },
          {
            key: "deviceName",
            title: "نام",
          },
          {
            key: "statusName",
            title: "وضعیت",
          },
          {
            key: "systemId",
            title: "سریال",
          },
          {
            key: "modelTypeName",
            title: "مدل دستگاه",
          },
          // {
          //   key: "description",
          //   title: "توضیحات",
          // },
        ],
        // actions: [
        //   "view",
        //   "edit",
        //   "delete",
        //
        //   "sms",
        //   "network",
        //   "setting",
        // ],
        actions: ["view", "edit", "delete", "setting", "sensor", "sms"],
      };
    },
  },

  mounted() {
    this.refreshTable();

    this.GetOrganizationalStructureTree();

    // get status list value from server
    axios
      .get(Values.serverIp + "Constant/GetCarStatusSelectList")
      .then((response) => {
        //console.log(response.data);
        this.StatusList = response.data;
      });

    // get model list value from server
    axios
      .get(Values.serverIp + "DeviceType/GetDeviceTypeSelectList")
      .then((response) => {
        console.log(response.data);
        this.ModelList = response.data;
      });

    // get network list
    axios
      .get(Values.serverIp + "Constant/GetNetworkTypeFreezEyeV5SelectList")
      .then((response) => {
        console.log(response.data);

        this.networkList = response.data;
      });

    axios.get(Values.serverIp + "Dashboard/GetMapLayers").then((response) => {
      if (response.status == 200) {
        //console.log(response.status);
        this.tileProviders = response.data.layers;
      }
    });


    this.addDirectionLTR();
  },

  methods: {

    //******************************************************* rtl content of data table */
    addDirectionLTR() {
      const tds = document.querySelectorAll('tbody');
      tds.forEach(td => {
        td.style.direction = 'ltr';
      });
    },


    changeLocation(data, latLng) {
      if (latLng == "lat") this.markerLatLng[0] = data;
      else this.markerLatLng[1] = data;
      console.log(this.markerLatLng);
    },
    //********************************************************************* set Letter */
    setLetter(val) {
      this.info.registrationPlate2 = val.target.value;
    },

    //********************************************************************* recieve sensor data */
    getSensors(data) {
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(Values.serverIp + "Sensor/GetSensorsAlarmWebUi", data, config)
        .then((response) => {
          if (response.status == 200) {
            console.log(response.data);
            this.alarmMinMax = response.data;
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },
    //********************************************************************* recieve sensor data */
    setSensors() {
      var forms = document.querySelectorAll(".needs-validationWebAlarm");
      let formValid = true;

      for (var i = 0; i < forms[0].length; i++) {
        if (
          forms[0][i].type == "text" &&
          forms[0][i].required &&
          forms[0][i].value.length == 0
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (
          forms[0][i].type == "number" &&
          forms[0][i].required &&
          forms[0][i].value == ""
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (
          forms[0][i].type == "select-one" &&
          forms[0][i].required &&
          forms[0][i].value == ""
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (
          forms[0][i].type == "text" &&
          !forms[0][i].value.match(this.ipformat) &&
          !forms[0][i].value.length == 0 &&
          forms[0][i].maxLength == 15
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        }
      }
      if (formValid == true) {
        const config = { headers: { "Content-Type": "application/json" } };
        for (var i = 0; i < this.alarmMinMax.length; i++) {
          if (this.alarmMinMax[i].alarmMax == "")
            this.alarmMinMax[i].alarmMax = null;
          if (this.alarmMinMax[i].alarmMin == "")
            this.alarmMinMax[i].alarmMin = null;
          if (this.alarmMinMax[i].alarmTime == "")
            this.alarmMinMax[i].alarmTime = 0;
          if (this.alarmMinMax[i].calibration == "")
            this.alarmMinMax[i].calibration = 0;
        }
        axios
          .post(
            Values.serverIp + "Sensor/UpdateSensorsAlarmWeb",
            this.alarmMinMax,
            config
          )
          .then((response) => {
            if (response.status == 200) {
              console.log(response.data);
              if (response.data == 0) {
                this.alertModal = true;
                this.alertModalTitle = "تغییرات";
                this.alertModalText = "تغیرات با موفقیت انجام شد.";
                (this.alertModalColor = "success"),
                  (this.alertModalButtonText = "تایید");
              } else {
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                this.alertModalText = "لطفا دوباره تلاش فرمایید.";
                (this.alertModalColor = "warning"),
                  (this.alertModalButtonText = "تایید");
              }
            }
          })
          .catch((response) => {
            if (response.status != 200) {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
              (this.alertModalColor = "info"),
                (this.alertModalButtonText = "تایید");
            }
          });
      } else {
        this.alert = true;
        this.alertText = "لطفا تمامی موارد الزامی را وارد نمایید.";
      }
    },
    //************************************************************************search icon */
    searchIcon(data) {
      console.log(data);
      if (data.length > 0) {
        this.is_search_icon = true;
        this.filteredListIcon = this.iconList.filter(function (el) {
          return el.value.includes(data);
        });
      } else {
        this.is_search_icon = false;
        this.filteredListIcon = [];
      }
    },
    //************************************************************************ set icon */
    setIcon(data) {
      this.selectedIcon = "fa " + data.value;
      //console.log(this.selectedIcon);
    },

    //************************************************************************* change alarm */
    changeAlarm(data) {
      if (data == 1) {
        this.addModal = false;
        (this.alertModal = true),
          (this.alertModalTitle = "تغییرات"),
          (this.alertModalText = "تغییرات با موفقیت انجام شد."),
          (this.alertModalColor = "success"),
          (this.alertModalButtonText = "تایید"),
          this.refreshTable();
      } else if (data == 2) {
        // modal unsuccessful edit change
        this.alertModal = true;
        this.alertModalTitle = "خطایی رخ داده";
        this.alertModalText = "!!! لطفا دوباره تلاش فرمایید.";
        (this.alertModalColor = "warning"),
          (this.alertModalButtonText = "تایید");
      } else if (data == 3) {
        this.alertModal = true;
        this.alertModalTitle = "تنظیمات";
        this.alertModalText = "درخواست تنظیمات با موفقیت ارسال شد.";
        this.alertModalColor = "success";
        this.alertModalButtonText = "تایید";
      }
    },

    //************************************************************************* change alarm 2*/
    changeAlarm2(data) {
      if (data == 1) {
        this.addModal = false;
        (this.alertModal = true),
          (this.alertModalTitle = "تغییرات"),
          (this.alertModalText = "تغییرات با موفقیت انجام شد."),
          (this.alertModalColor = "success"),
          (this.alertModalButtonText = "تایید"),
          this.refreshTable();
      } else if (data == 2) {
        this.alertModal = true;
        this.alertModalTitle = "تنظیمات";
        this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
        this.alertModalColor = "danger";
        this.alertModalButtonText = "تایید";
      } else if (data == 3) {
        this.alertModal = true;
        this.alertModalTitle = "تنظیمات";
        this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
        this.alertModalColor = "danger";
        this.alertModalButtonText = "تایید";
      } else if (data == 4) {
        this.alertModal = true;
        this.alertModalTitle = "تنظیمات";
        this.alertModalText = "پاسخی دریافت نشد.";
        this.alertModalColor = "danger";
        this.alertModalButtonText = "تایید";
      }
      if (data == 5) {
        this.addModal = false;
        (this.alertModal = true),
          (this.alertModalTitle = "دریافت"),
          (this.alertModalText = "دریافت با موفقیت انجام شد."),
          (this.alertModalColor = "success"),
          (this.alertModalButtonText = "تایید"),
          this.refreshTable();
      }
    },

    //************************************************************************* map updated */
    showMap() {
      setTimeout(() => {
        //mapObject is a property that is part of leaflet
        this.$refs.limitMap.mapObject.invalidateSize();
      }, 100);

      // set display of map footer none
      $(".leaflet-control-attribution").hide();

      // select map and gives it latlngs
      // this.$nextTick(() => {
      //   this.mapOfLimits = this.$refs.limitMap.mapObject;
      //   this.mapOfLimits.on(window.L.Draw.Event.CREATED, (e) => {
      //     this.positionArrayEdit = [];
      //     const layer = e.layer;
      //     this.polygons = layer;
      //     this.polygonsValue = true;
      //     this.info.positionArray = JSON.stringify(this.polygons.getLatLngs());
      //     console.log(this.polygons.getLatLngs());
      //   });
      // });
    },

    getLatLong(event) {
      //console.log(event.latlng);
      this.center = [event.latlng.lat, event.latlng.lng];
      this.markerLatLng = [event.latlng.lat, event.latlng.lng];
    },
    //********************************************************************* get organiztion tree */
    GetOrganizationalStructureTree() {
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp +
            "OrganizationalStructure/GetOrganizationalStructureTree",
          JSON.stringify(""),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            //console.log(response.data);
            this.structureList = response.data;
            this.structureListFillter = response.data;
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },

    //****************************************************************** select parrent */
    itemClick(node) {
      this.selectedParent = node.model.id;
      //console.log(this.selectedParent);
    },
    
    //********************************************************************* refresh datatable */
    refreshTable() {
      axios
        .get(Values.serverIp + "Device/Devices")
        .then((response) => {
          console.log(response.data);
          this.devices = response.data.data;
        })
        .catch((response) => {
          //console.log("in catch");
          if (response.response.status == 403) {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.showPage = false),
              (this.alertModalTitle = "عدم مجوز"),
              (this.alertModalText =
                "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
              (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          } else if (response.response.status == 401) {
            //token has expired
            // modal unsuccessful edit change
            localStorage.removeItem("token");
            localStorage.removeItem("username");
            delete axios.defaults.headers.common["Authorization"];
          }
        });
    },

    //********************************************************************* datatable view action */
    viewAction(data) {
      // disable alet
      this.alert = false;
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "Device/GetDevice",
          JSON.stringify(data.deviceId),
          config
        )
        .then((response) => {
          console.log(response.data.data);
          if (response.status == 200) {
            this.addModal = true;
            this.modalTitle = "اطلاعات دستگاه";
            this.modalButtonSubmit = "تایید";

            this.showMap();

            // clear all red borders
            $(".form-control").removeAttr("style");

            this.structureList = JSON.parse(response.data.tree);

            // info
            this.info.id = response.data.data.deviceId;
            this.info.name = response.data.data.deviceName;
            this.info.serial = response.data.data.systemId;
            this.info.password = response.data.data.password;
            this.setDeviceStatusValue(response.data.data.statusId);
            this.setDailayReportValue(
              response.data.data.sendEmailForDailyReport
            );
            this.info.description = response.data.data.description;
            this.setModelValue(response.data.data.modelType);

            this.info.currentKilometer = response.data.data.currentKilometer;
            this.info.simcardNum = response.data.data.simCardNumber;

            this.selectedIcon = response.data.data.icon;

            response.data.data.networkTypeList == null
              ? (response.data.data.networkTypeList = null)
              : this.setNetworkValue(response.data.data.networkTypeList);

            response.data.data.defaultNetworkTypeId == 0
              ? response.data.data.defaultNetworkTypeId == 0
              : this.setDefaultNetworkValue(
                  response.data.data.defaultNetworkTypeId
                );
            this.setperiodicUpdateTimeValue(
              response.data.data.updateLogTimeMinute
            );

            // this.setNetworkValue(response.data.data.networkTypeList);
            // this.setDefaultNetworkValue(
            //   response.data.data.defaultNetworkTypeId
            // );
            // this.setperiodicUpdateTimeValue(
            //   response.data.data.UpdateLogTimeMinute
            // );

            //sms receiption
            this.smsReception.first = response.data.data.phoneNumber1;
            this.smsReception.second = response.data.data.phoneNumber2;
            this.smsReception.third = response.data.data.phoneNumber3;
            this.smsReception.forth = response.data.data.phoneNumber4;
            this.smsReception.fifth = response.data.data.phoneNumber5;
            this.smsReception.sixth = response.data.data.phoneNumber6;

            this.info.FdaBranchId = response.data.data.branchId;
            this.info.FdaRoomId = response.data.data.roomId;
            this.info.FdaSensorId1 = response.data.data.sensorId1;
            this.info.FdaSensorId2 = response.data.data.sensorId2;
            this.info.FdaSensorId3 = response.data.data.sensorId3;
            this.info.FdaSensorId4 = response.data.data.sensorId4;
            this.info.FdaSensorId5 = response.data.data.sensorId5;
            this.info.FdaSensorId6 = response.data.data.sensorId6;
            this.info.FdaSensorId7 = response.data.data.sensorId7;
            this.info.FdaSensorId8 = response.data.data.sensorId8;

            this.info.FdaWebServiceAddress = response.data.data.webService;

            this.setSensorIndexName(response.data.data.sensorIndexNameList);

            (this.info.gprsIpAddress = response.data.data.gprsIp),
              (this.info.wifiIpAddress = response.data.data.wifiIp),
              (this.info.ethernetIpAddress = response.data.data.ethernetIp),
              (this.info.ethernetPortAddress = response.data.data.ethernetPort),
              (this.info.gprsPortAddress = response.data.data.gprsPort),
              (this.info.wifiPortAddress = response.data.data.wifiPort),
              // geo
              (this.markerLatLng = [
                response.data.data.deviceLat,
                response.data.data.deviceLong,
              ]);
            this.center = [
              response.data.data.deviceLat,
              response.data.data.deviceLong,
            ];
            //this.markerLatLng[1] = response.data.data.deviceLong;

            //showMap();

            // simcard
            this.simcard.simCardNum = response.data.data.simCartNumber;
            this.simcard.sendSmsStatus = response.data.data.isSmsActive;
            this.simcard.simcardDataStatus =
              response.data.data.isSimCartDataActive;
            this.setSimcardOprator(response.data.data.simCardTypeOperator);
            this.setSimcardType(response.data.data.simCardTypeCreditOrFixed);

            // wifi
            this.wifi.ipAddress = response.data.data.wifiIpAddress;
            this.wifi.subnetMask = response.data.data.wifiMask;
            this.wifi.gateway = response.data.data.wifiGateway;
            this.wifi.dns = response.data.data.wifiDns;
            this.wifi.ssid = response.data.data.wifiSsid;
            this.wifi.password = response.data.data.wifiPassword;

            // ethernet
            this.ethernet.ipAddress = response.data.data.ehtrIpAddress;
            this.ethernet.subnetMask = response.data.data.ehtrMask;
            this.ethernet.gateway = response.data.data.ehtrGateway;
            this.ethernet.dns = response.data.data.ehtrDns;

            this.info.driver = response.data.data.driverName;
            this.setDeviceType(response.data.data.isMovingDevice);

            if (response.data.data.registrationPlate != null) {
              this.info.registrationPlate1 =
                response.data.data.registrationPlate.substring(0, 2);
              if (response.data.data.registrationPlate.substring(2, 3) != "ا") {
                (this.info.registrationPlate2 =
                  response.data.data.registrationPlate.substring(2, 3)),
                  (this.info.registrationPlate3 =
                    response.data.data.registrationPlate.substring(3, 6)),
                  (this.info.registrationPlate4 =
                    response.data.data.registrationPlate.substring(6));
              } else {
                (this.info.registrationPlate2 =
                  response.data.data.registrationPlate.substring(2, 5)),
                  (this.info.registrationPlate3 =
                    response.data.data.registrationPlate.substring(5, 8)),
                  (this.info.registrationPlate4 =
                    response.data.data.registrationPlate.substring(8));
              }
            }

            // make all part to disabled
            $(".form-check, .form-control-file, .form-control").attr(
              "disabled",
              true
            );
            this.disableMultiselect = true;
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },

    //********************************************************************* datatable edit action */
    editAction(data) {
      this.restoreDefault();

      // disable alet
      this.alert = false;
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "Device/GetDeviceForUpdate",
          JSON.stringify(data.deviceId),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            console.log(response.data.data);
            this.addModal = true;
            this.modalTitle = "ویرایش دستگاه";
            this.modalButtonSubmit = "اعمال";

            this.showMap();

            // clear all red borders
            $(".form-control").removeAttr("style");

            // make all part to enabled
            $(".form-check, .form-control-file, .form-control").attr(
              "disabled",
              false
            );
            this.disableMultiselect = false;

            this.structureList = JSON.parse(response.data.tree);
            this.selectedParent = response.data.data.organizationId;

            // info
            this.info.id = response.data.data.deviceId;
            this.info.name = response.data.data.deviceName;
            this.info.serial = response.data.data.systemId;
            this.info.password = response.data.data.password;
            this.setDeviceStatusValue(response.data.data.statusId);
            this.setDailayReportValue(
              response.data.data.sendEmailForDailyReport
            );

            this.info.description = response.data.data.description;
            this.setModelValue(response.data.data.modelType);

            this.info.currentKilometer = response.data.data.currentKilometer;

            this.info.simcardNum = response.data.data.simCardNumber;

            this.selectedIcon = response.data.data.icon;

            //sms receiption
            this.smsReception.first = response.data.data.phoneNumber1;
            this.smsReception.second = response.data.data.phoneNumber2;
            this.smsReception.third = response.data.data.phoneNumber3;
            this.smsReception.forth = response.data.data.phoneNumber4;
            this.smsReception.fifth = response.data.data.phoneNumber5;
            this.smsReception.sixth = response.data.data.phoneNumber6;

            response.data.data.networkTypeList == null
              ? (response.data.data.networkTypeList = null)
              : this.setNetworkValue(response.data.data.networkTypeList);

            response.data.data.defaultNetworkTypeId == 0
              ? response.data.data.defaultNetworkTypeId == 0
              : this.setDefaultNetworkValue(
                  response.data.data.defaultNetworkTypeId
                );
            this.setperiodicUpdateTimeValue(
              response.data.data.updateLogTimeMinute
            );

            this.info.FdaBranchId = response.data.data.branchId;
            this.info.FdaRoomId = response.data.data.roomId;
            this.info.FdaSensorId1 = response.data.data.sensorId1;
            this.info.FdaSensorId2 = response.data.data.sensorId2;
            this.info.FdaSensorId3 = response.data.data.sensorId3;
            this.info.FdaSensorId4 = response.data.data.sensorId4;
            this.info.FdaSensorId5 = response.data.data.sensorId5;
            this.info.FdaSensorId6 = response.data.data.sensorId6;
            this.info.FdaSensorId7 = response.data.data.sensorId7;
            this.info.FdaSensorId8 = response.data.data.sensorId8;
            this.info.FdaWebServiceAddress = response.data.data.webService;

            this.setSensorIndexName(response.data.data.sensorIndexNameList);

            (this.info.gprsIpAddress = response.data.data.gprsIp),
              (this.info.wifiIpAddress = response.data.data.wifiIp),
              (this.info.ethernetIpAddress = response.data.data.ethernetIp),
              (this.info.ethernetPortAddress = response.data.data.ethernetPort),
              (this.info.gprsPortAddress = response.data.data.gprsPort),
              (this.info.wifiPortAddress = response.data.data.wifiPort),
              //geo
              (this.markerLatLng = [
                response.data.data.deviceLat,
                response.data.data.deviceLong,
              ]);
            //this.markerLatLng[1] = response.data.data.deviceLong;
            this.center = [
              response.data.data.deviceLat,
              response.data.data.deviceLong,
            ];

            this.info.driver = response.data.data.driverName;
            this.setDeviceType(response.data.data.isMovingDevice);

            if (response.data.data.registrationPlate != null) {
              this.info.registrationPlate1 =
                response.data.data.registrationPlate.substring(0, 2);
              if (response.data.data.registrationPlate.substring(2, 3) != "ا") {
                (this.info.registrationPlate2 =
                  response.data.data.registrationPlate.substring(2, 3)),
                  (this.info.registrationPlate3 =
                    response.data.data.registrationPlate.substring(3, 6)),
                  (this.info.registrationPlate4 =
                    response.data.data.registrationPlate.substring(6));
              } else {
                (this.info.registrationPlate2 =
                  response.data.data.registrationPlate.substring(2, 5)),
                  (this.info.registrationPlate3 =
                    response.data.data.registrationPlate.substring(5, 8)),
                  (this.info.registrationPlate4 =
                    response.data.data.registrationPlate.substring(8));
              }
            }
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },

    //********************************************************************* datatable delete action */
    deleteAction(data) {
      console.log(data);
      (this.alertModal = true),
        (this.alertModalTitle = "حذف دستگاه"),
        (this.alertModalText =
          "آیا از حذف دستگاه " + data.deviceName + " مطمئن هستید؟"),
        (this.alertModalColor = "warning"),
        (this.alertModalButtonText = "بله"),
        (this.deviceId = data.deviceId);
    },

    //********************************************************************* datatable assign car action */
    sensorAction(data) {
      this.groupName = data.deviceName;
      this.deviceId = data.deviceId;
      this.selectedSensorList = [];

      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "Device/GetDeviceSensors",
          JSON.stringify(this.deviceId),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            //console.log(response.data);
            this.SensorList = response.data;
            this.sensorModal = true;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //********************************************************************* smsAction */
    smsAction(data) {
      this.deviceId = data.deviceId;

      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "Device/GetDeviceSensors",
          JSON.stringify(this.deviceId),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            this.SensorList = response.data;
            this.fullData = response.data;
            this.setIndexList(this.fullData);
            this.createTable();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //*************************************** create table */
    createTable() {
      this.settingValues = [];
      for (var i = 0; i < this.SensorList.carSensorTypes.length; i++) {
        for (
          var j = 0;
          j < this.SensorList.carSensorTypes[i].values.length;
          j++
        ) {
          //console.log(this.SensorList.carSensorTypes[i].values[j].sensorIndex);
          this.settingValues.push({
            name: this.SensorList.carSensorTypes[i].sensorTypeName,
            type: this.SensorList.carSensorTypes[i].sensorType,
            index: this.SensorList.carSensorTypes[i].values[j].sensorIndex,
            indexName:
              this.SensorList.carSensorTypes[i].values[j].sensorIndexName,
            alarmUp: "",
            alarmDown: "",
          });
        }
      }
    },

    //******************************************************************** sms action 2 */
    smsAction2(data) {
      this.deviceId = data.deviceId;
      this.groupName = data.deviceName;
      this.$refs.Log.restoreDefault();
      //this.$refs.Log.getSensors(data.deviceId);
      this.settingModalLog = true;
    },

    //********************************************************************* setting Action */
    settingAction(data) {
      console.log(data);

      console.log(data.deviceId);
      if (data.modelTypeName == "FreezEyeV5") {
        this.restoreDefault();
        this.groupName = data.deviceName;
        this.smsAction(data);
        this.settingModal = true;
        this.indexValueSensor = { label: "", value: "" };
        this.deviceId = data.deviceId;
        this.getSensors(data.deviceId);
      } else if (data.modelTypeName == "FDA") {
        this.deviceId = data.deviceId;
        this.groupName = data.deviceName;

        this.$refs.FDA.restoreDefault();
        this.$refs.FDA.getSensors(data.deviceId);
        this.settingModalFda = true;
      } else if (data.modelTypeName == "Navgan") {
        this.deviceId = data.deviceId;
        this.groupName = data.deviceName;
        this.$refs.Tracking.restoreDefault();
        this.$refs.Tracking.getSensors(data.deviceId);
        this.settingModalTracking = true;
      } else if (data.modelTypeName == "Navgan2") {
        this.deviceId = data.deviceId;
        this.groupName = data.deviceName;
        //this.$refs.Tracking2.restoreDefault();
        this.$refs.Tracking2.getSensors(data.deviceId);
        this.settingModalTracking2 = true;
      } else if (data.modelTypeName == "Navgan3") {
        this.deviceId = data.deviceId;
        this.groupName = data.deviceName;
        //this.$refs.Tracking3.restoreDefault();
        this.$refs.Tracking3.getSensors(data.deviceId);
        this.settingModalTracking3 = true;
      } else if (data.modelTypeName == "Tracking") {
        this.deviceId = data.deviceId;
        this.groupName = data.deviceName;
        //this.$refs.Tracking2.restoreDefault();
        this.$refs.TrackingJahadSetting.getSensors(data.deviceId);
        this.settingModalTrackingJahad = true;
      } else if (data.modelTypeName == "ICH88IPV3") {
        this.deviceId = data.deviceId;
        this.groupName = data.deviceName;
        this.settingModalIch = true;
        this.$refs.Ich.restoreDefault();
        this.$refs.Ich.getSensors(data.deviceId);
        this.$refs.Ich.refreshDeviceSetting("ethernet", data.deviceId, 1);
        this.$refs.Ich.refreshDeviceSetting("mac", data.deviceId, 1);
        this.$refs.Ich.refreshDeviceSetting("voiceAlarm", data.deviceId, 1);
        // this.$refs.Ich.refreshDeviceSetting("log", data.deviceId, 1);
        this.$refs.Ich.refreshDeviceSetting("server", data.deviceId, 1);
        this.$refs.Ich.refreshDeviceSetting("puls", data.deviceId, 1);
        this.$refs.Ich.refreshDeviceSetting("dateTime", data.deviceId, 1);
        this.$refs.Ich.refreshDeviceSetting("simcard", data.deviceId, 1);
        this.$refs.Ich.refreshDeviceSetting("sms", data.deviceId, 1);
        this.$refs.Ich.refreshDeviceSetting("smsOwner", data.deviceId, 1);
        this.$refs.Ich.refreshDeviceSetting("smsPersian", data.deviceId, 1);
        this.$refs.Ich.refreshDeviceSetting("smsDelay", data.deviceId, 1);
        this.$refs.Ich.refreshDeviceSetting("sensorTemp", data.deviceId, 1);
        this.$refs.Ich.refreshDeviceSetting("sensorHum", data.deviceId, 1);
        this.$refs.Ich.refreshDeviceSetting("sensor", data.deviceId, 1);
        this.$refs.Ich.refreshDeviceSetting("serial", data.deviceId, 1);
      } else if (data.modelTypeName == "ICH44IP") {
        this.deviceId = data.deviceId;
        this.groupName = data.deviceName;
        this.settingModalIch4 = true;
        this.$refs.Ich4.restoreDefault();
        this.$refs.Ich4.getSensors(data.deviceId);
        this.$refs.Ich4.refreshDeviceSetting("ethernet", data.deviceId, 1);
        this.$refs.Ich4.refreshDeviceSetting("mac", data.deviceId, 1);
        this.$refs.Ich4.refreshDeviceSetting("voiceAlarm", data.deviceId, 1);
        // this.$refs.Ich.refreshDeviceSetting("log", data.deviceId, 1);
        this.$refs.Ich4.refreshDeviceSetting("server", data.deviceId, 1);
        this.$refs.Ich4.refreshDeviceSetting("puls", data.deviceId, 1);
        this.$refs.Ich4.refreshDeviceSetting("dateTime", data.deviceId, 1);
        this.$refs.Ich4.refreshDeviceSetting("simcard", data.deviceId, 1);
        this.$refs.Ich4.refreshDeviceSetting("sms", data.deviceId, 1);
        this.$refs.Ich4.refreshDeviceSetting("smsOwner", data.deviceId, 1);
        this.$refs.Ich4.refreshDeviceSetting("smsPersian", data.deviceId, 1);
        this.$refs.Ich4.refreshDeviceSetting("smsDelay", data.deviceId, 1);
        this.$refs.Ich4.refreshDeviceSetting("sensorTemp", data.deviceId, 1);
        this.$refs.Ich4.refreshDeviceSetting("sensorHum", data.deviceId, 1);
        this.$refs.Ich4.refreshDeviceSetting("sensor", data.deviceId, 1);
        this.$refs.Ich4.refreshDeviceSetting("serial", data.deviceId, 1);
      } else if (data.modelTypeName == "FE22WE") {
        this.deviceId = data.deviceId;
        this.groupName = data.deviceName;
        this.$refs.FE22WE.restoreDefault();
        this.$refs.FE22WE.getSensors(data.deviceId);
        this.$refs.FE22WE.refreshDeviceSetting("ethernet", data.deviceId, 1);
        this.$refs.FE22WE.refreshDeviceSetting("voiceAlarm", data.deviceId, 1);
        this.$refs.FE22WE.refreshDeviceSetting("log", data.deviceId, 1);
        this.$refs.FE22WE.refreshDeviceSetting("server", data.deviceId, 1);
        this.$refs.FE22WE.refreshDeviceSetting("puls", data.deviceId, 1);
        this.$refs.FE22WE.refreshDeviceSetting("dateTime", data.deviceId, 1);
        this.$refs.FE22WE.refreshDeviceSetting("simcard", data.deviceId, 1);
        this.$refs.FE22WE.refreshDeviceSetting("sms", data.deviceId, 1);
        this.$refs.FE22WE.refreshDeviceSetting("smsFlag", data.deviceId, 1);
        this.$refs.FE22WE.refreshDeviceSetting("smsDelay", data.deviceId, 1);
        this.$refs.FE22WE.refreshDeviceSetting(
          "sensorTempHum",
          data.deviceId,
          1
        );
        this.$refs.FE22WE.refreshDeviceSetting(
          "sensorTempHum_hum",
          data.deviceId,
          1
        );
        this.$refs.FE22WE.refreshDeviceSetting("sensor", data.deviceId, 1);
        this.$refs.FE22WE.refreshDeviceSetting("serial", data.deviceId, 1);

        this.settingModalFE22WE = true;
      } else if (data.modelTypeName == "FreezEyeV3") {
        this.deviceId = data.deviceId;
        this.groupName = data.deviceName;
        this.settingModalFreezEyeV3 = true;
        this.$refs.FreezEyeV3.restoreDefault();
        this.$refs.FreezEyeV3.getSensors(data.deviceId);
        this.$refs.FreezEyeV3.refreshDeviceSetting(
          "ethernet",
          data.deviceId,
          1
        );
        this.$refs.FreezEyeV3.refreshDeviceSetting("mac", data.deviceId, 1);
        this.$refs.FreezEyeV3.refreshDeviceSetting(
          "voiceAlarm",
          data.deviceId,
          1
        );
        // this.$refs.Ich.refreshDeviceSetting("log", data.deviceId, 1);
        this.$refs.FreezEyeV3.refreshDeviceSetting("server", data.deviceId, 1);
        this.$refs.FreezEyeV3.refreshDeviceSetting("puls", data.deviceId, 1);
        this.$refs.FreezEyeV3.refreshDeviceSetting(
          "dateTime",
          data.deviceId,
          1
        );
        this.$refs.FreezEyeV3.refreshDeviceSetting("simcard", data.deviceId, 1);
        this.$refs.FreezEyeV3.refreshDeviceSetting("sms", data.deviceId, 1);
        this.$refs.FreezEyeV3.refreshDeviceSetting(
          "smsOwner",
          data.deviceId,
          1
        );
        this.$refs.FreezEyeV3.refreshDeviceSetting(
          "smsPersian",
          data.deviceId,
          1
        );
        this.$refs.FreezEyeV3.refreshDeviceSetting(
          "smsDelay",
          data.deviceId,
          1
        );
        this.$refs.FreezEyeV3.refreshDeviceSetting(
          "sensorTempHum",
          data.deviceId,
          1
        );
        this.$refs.FreezEyeV3.refreshDeviceSetting(
          "sensorTempHum_hum",
          data.deviceId,
          1
        );
        this.$refs.FreezEyeV3.refreshDeviceSetting("sensor", data.deviceId, 1);
        this.$refs.FreezEyeV3.refreshDeviceSetting("serial", data.deviceId, 1);
      }

      // clear all red borders
      $(".form-control").removeAttr("style");

      // make all part to enabled
      $(".form-check, .form-control-file, .form-control").attr(
        "disabled",
        false
      );
      this.disableMultiselect = false;
      //this.settingValuesSensor=[];
    },

    //********************************************************************* dataTable actions */
    handleAction(actionName, data) {
      if (actionName == "view") {
        this.viewAction(data);
      } else if (actionName == "edit") {
        this.editAction(data);
      } else if (actionName == "delete") {
        this.deleteAction(data);
      } else if (actionName == "sensor") {
        this.sensorAction(data);
      } else if (actionName == "sms") {
        this.smsAction2(data);
      } else if (actionName == "setting") {
        this.settingAction(data);
      }
    },

    //********************************************************************* edit and create device */
    submitForm() {
      // make all part to enabled
      $(".form-check, .form-control-file, .form-control").attr(
        "disabled",
        false
      );

      // clear all red borders
      $(".form-control, .needs-validation > .multiselect__tags").removeAttr(
        "style"
      );

      $(".form-control, .needs-validationSms > .multiselect__tags").removeAttr(
        "style"
      );

      $(
        ".form-control, .needs-validationSensor > .multiselect__tags"
      ).removeAttr("style");

      var forms = document.querySelectorAll(".needs-validation");
      let formValid = true;
      if (this.selectedParent != "") {
        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          }
        }
        if (this.info.status.value == "") {
          $(".needs-validation > .multiselect__tags").css(
            "border-color",
            "red"
          );
          formValid = false;
        }
        if (
          this.info.ModelValue.value == "" ||
          this.info.ModelValue.length == 0
        ) {
          $(".needs-validation > .multiselect__tags").css(
            "border-color",
            "red"
          );
          formValid = false;
        }

        if (
          this.info.defaultNetworkValue.value == 0 &&
          this.info.ModelValue.value != "FDA"
        ) {
          $(".needs-validation > .multiselect__tags").css(
            "border-color",
            "red"
          );
          formValid = false;
        }

        if (
          this.info.networkValue.length == 0 &&
          this.info.ModelValue.value != "FDA"
        ) {
          $(".needs-validation > .multiselect__tags").css(
            "border-color",
            "red"
          );
          formValid = false;
        }

        let api = "";
        if (this.modalButtonSubmit == "اعمال") api = "EditDevice";
        else {
          api = "CreateDevice";
          this.info.id = null;
        }

        if (formValid == true) {
          let netType = [];
          //console.log(this.carGroupvalue.length);
          for (let j = 0; j < this.info.networkValue.length; j = j + 1)
            netType.push(this.info.networkValue[j].value);
          console.log(this.info);
          axios
            .post(Values.serverIp + "Device/" + api, {
              //info
              deviceId: this.info.id,
              deviceName: this.info.name,
              systemId: this.info.serial,
              password: this.info.password,
              statusId: JSON.parse(this.info.status.value),
              modelType: this.info.ModelValue.value,
              networkTypeList: netType,
              organizationId: this.selectedParent,
              description: this.info.description,
              currentKilometer: this.info.currentKilometer,
              simCardNumber: this.info.simcardNum,
              sensorIndexNameList:
                this.info.ModelValue.value == "FreezEyeV5"
                  ? [
                      { SensorIndex: 1, SensorName: this.info.firstSensor },
                      { SensorIndex: 2, SensorName: this.info.secondSensor },
                      { SensorIndex: 3, SensorName: this.info.thirdSensor },
                    ]
                  : this.info.ModelValue.value == "Navgan"
                  ? [
                      { SensorIndex: 1, SensorName: this.info.firstSensor },
                      { SensorIndex: 2, SensorName: this.info.secondSensor },
                      { SensorIndex: 3, SensorName: this.info.thirdSensor },
                      { SensorIndex: 4, SensorName: this.info.forthSensor },
                    ]
                  : this.info.ModelValue.value == "ICH88IPV3"
                  ? [
                      { SensorIndex: 1, SensorName: this.info.firstSensor },
                      { SensorIndex: 2, SensorName: this.info.secondSensor },
                      { SensorIndex: 3, SensorName: this.info.thirdSensor },
                      { SensorIndex: 4, SensorName: this.info.forthSensor },
                      { SensorIndex: 5, SensorName: this.info.fifthSensor },
                      { SensorIndex: 6, SensorName: this.info.sixthSensor },
                      { SensorIndex: 7, SensorName: this.info.seventhSensor },
                      { SensorIndex: 8, SensorName: this.info.eigthSensor },
                    ]
                  : this.info.ModelValue.value == "ICH44IP"
                  ? [
                      { SensorIndex: 1, SensorName: this.info.firstSensor },
                      { SensorIndex: 2, SensorName: this.info.secondSensor },
                      { SensorIndex: 3, SensorName: this.info.thirdSensor },
                      { SensorIndex: 4, SensorName: this.info.forthSensor },
                    ]
                  : this.info.ModelValue.value == "Navgan2"
                  ? [{ SensorIndex: 1, SensorName: this.info.firstSensor }]
                  : this.info.ModelValue.value == "Navgan3"
                  ? [{ SensorIndex: 1, SensorName: this.info.firstSensor }]
                  : this.info.ModelValue.value == "Tracking"
                  ? [{ SensorIndex: 1, SensorName: this.info.firstSensor }]
                  : this.info.ModelValue.value == "FE22WE" ||
                    this.info.ModelValue.value == "FreezEyeV3"
                  ? [
                      { SensorIndex: 1, SensorName: this.info.firstSensor },
                      { SensorIndex: 2, SensorName: this.info.secondSensor },
                    ]
                  : [],
              defaultNetworkTypeId: this.info.defaultNetworkValue.value,

              updateLogTimeMinute: this.info.periodicUpdateTimeValue.value,

              //icon
              icon: this.selectedIcon,

              //Fda
              branchId: this.info.FdaBranchId,
              roomId: this.info.FdaRoomId,
              sensorId1: this.info.FdaSensorId1,
              sensorId2: this.info.FdaSensorId2,
              sensorId3: this.info.FdaSensorId3,
              sensorId4: this.info.FdaSensorId4,
              sensorId5: this.info.FdaSensorId5,
              sensorId6: this.info.FdaSensorId6,
              sensorId7: this.info.FdaSensorId7,
              sensorId8: this.info.FdaSensorId8,

              webService: this.info.FdaWebServiceAddress,

              //geo
              deviceLat: this.markerLatLng[0],
              deviceLong: this.markerLatLng[1],

              ethernetIp: this.info.ethernetIpAddress,
              gprsIp: this.info.gprsIpAddress,
              wifiIp: this.info.wifiIpAddress,
              ethernetPort: this.info.ethernetPortAddress,
              gprsPort: this.info.gprsPortAddress,
              wifiPort: this.info.wifiPortAddress,
              defaultNetworkType: this.info.defaultNetworkValue.value,

              //sms receiption
              phoneNumber1: this.smsReception.first,
              phoneNumber2: this.smsReception.second,
              phoneNumber3: this.smsReception.third,
              phoneNumber4: this.smsReception.forth,
              phoneNumber5: this.smsReception.fifth,
              phoneNumber6: this.smsReception.sixth,

              registrationPlate:
                this.info.registrationPlate1 +
                this.info.registrationPlate2 +
                this.info.registrationPlate3 +
                this.info.registrationPlate4,
              driverName: this.info.driver,
              isMovingDevice: this.info.deviceType.value,
              sendEmailForDailyReport: this.info.dailyReportSend.value,
            })
            .then((response) => {
              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.addModal = false;
                  (this.alertModal = true),
                    (this.alertModalTitle = "تغییرات"),
                    (this.alertModalText = "تغییرات با موفقیت انجام شد."),
                    (this.alertModalColor = "success"),
                    (this.alertModalButtonText = "تایید"),
                    this.refreshTable();
                } else if (response.data == 2) {
                  this.alert = true;
                  this.alertText = "دستگاه وارد شده تکراری است.";
                } else if (response.data == 3) {
                  this.alert = true;
                  this.alertText = "کد شعبه یا کد انبار وارد شده تکراری است!!!";
                } else {
                  // modal unsuccessful edit change
                  this.alertModal = true;
                  this.alertModalTitle = "خطایی رخ داده";
                  this.alertModalText =
                    "شماره سریال یا اطلاعات وارد شده درست نمی باشد.";
                  (this.alertModalColor = "warning"),
                    (this.alertModalButtonText = "تایید");
                }
                // modal successfuly
              } else {
                // modal unsuccessful edit change
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                this.alertModalText =
                  "شماره سریال یا اطلاعات وارد شده درست نمی باشد.";
                (this.alertModalColor = "warning"),
                  (this.alertModalButtonText = "تایید");
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          // this.alert = true;
          // this.alertText = "لطفا تمامی موارد الزامی را وارد نمایید.";
          (this.alertModal = true),
            (this.alertModalTitle = "هشدار"),
            (this.alertModalText = "لطفا تمامی موارد الزامی را وارد نمایید."),
            (this.alertModalColor = "warning"),
            (this.alertModalButtonText = "تایید");
        }
      } else {
        // this.alert = true;
        // this.alertText = "لطفا سازمان را انتخاب نمایید.";
        (this.alertModal = true),
          (this.alertModalTitle = "هشدار"),
          (this.alertModalText = "لطفا سازمان را انتخاب نمایید."),
          (this.alertModalColor = "warning"),
          (this.alertModalButtonText = "تایید");
      }
    },

    //*********************************************************************set device Setting */
    setDeviceSetting(whichSetting) {
      if (whichSetting == "wifi") {
        var forms = document.querySelectorAll(".needs-validation2");
        let formValid = true;

        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          }
        }
        // if (this.info.status.value == "") {
        //   $(".needs-validation > .multiselect__tags").css(
        //     "border-color",
        //     "red"
        //   );
        //   formValid = false;
        // }

        if (!formValid) {
          //console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          this.spinnerWifi = true;

          axios
            .post(
              Values.serverIp + "FreezEyeV5DeviceSetting/SetWifiAddressSetting",
              {
                //wifi
                deviceId: this.deviceId,
                wifiIpAddress: this.wifi.ipAddress,
                wifiSubnetMask: this.wifi.subnetMask,
                wifiGateway: this.wifi.gateway,
                wifiDns: this.wifi.dns,
                wifiSsid: this.wifi.ssid,
                wifiPassword: this.wifi.password,
                wifiEnable: this.wifi.active,

                //ethernet
                // ehtrIpAddress: this.ethernet.ipAddress,
                // ehtrMask: this.ethernet.subnetMask,
                // ehtrGateway: this.ethernet.gateway,
                // ehtrDns: this.ethernet.dns,
              }
            )
            .then((response) => {
              this.spinnerWifi = false;
              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.addModal = false;
                  (this.alertModal = true),
                    (this.alertModalTitle = "تنظیمات"),
                    (this.alertModalText =
                      "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                    (this.alertModalColor = "success"),
                    (this.alertModalButtonText = "تایید"),
                    this.refreshDeviceSetting("wifi");
                } else if (response.data == 2) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 3) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 4) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "پاسخی دریافت نشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                }
                // modal successfuly
              } else {
                // modal unsuccessful edit change
                this.spinnerWifi = false;
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                (this.alertModalColor = "warning"),
                  (this.alertModalButtonText = "تایید");
              }
            })
            .catch((error) => {
              this.spinnerWifi = false;
              console.log(error);
            });
        }
      } else if (whichSetting == "wifi_ssid") {
        var forms = document.querySelectorAll(".needs-validation2");
        let formValid = true;

        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          }
        }
        // if (this.info.status.value == "") {
        //   $(".needs-validation > .multiselect__tags").css(
        //     "border-color",
        //     "red"
        //   );
        //   formValid = false;
        // }

        if (!formValid) {
          //console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          this.spinnerWifiSsid = true;

          axios
            .post(
              Values.serverIp +
                "FreezEyeV5DeviceSetting/SetWifiConnectionSetting",
              {
                //wifi
                deviceId: this.deviceId,
                wifiSsid: this.wifi.ssid,
                wifiPassword: this.wifi.password,
                wifiEnable: this.wifi.active,

                //ethernet
                // ehtrIpAddress: this.ethernet.ipAddress,
                // ehtrMask: this.ethernet.subnetMask,
                // ehtrGateway: this.ethernet.gateway,
                // ehtrDns: this.ethernet.dns,
              }
            )
            .then((response) => {
              this.spinnerWifiSsid = false;
              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.addModal = false;
                  (this.alertModal = true),
                    (this.alertModalTitle = "تنظیمات"),
                    (this.alertModalText =
                      "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                    (this.alertModalColor = "success"),
                    (this.alertModalButtonText = "تایید"),
                    this.refreshDeviceSetting("wifi");
                } else if (response.data == 2) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 3) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 4) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "پاسخی دریافت نشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                }
                // modal successfuly
              } else {
                // modal unsuccessful edit change
                this.spinnerWifiSsid = false;
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                (this.alertModalColor = "warning"),
                  (this.alertModalButtonText = "تایید");
              }
            })
            .catch((error) => {
              this.spinnerWifiSsid = false;
              console.log(error);
            });
        }
      } else if (whichSetting == "ethernet") {
        var forms = document.querySelectorAll(".needs-validationEthernet");
        let formValid = true;

        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          }
        }
        if (!formValid) {
          //console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          this.spinnerEthernet = true;
          axios
            .post(
              Values.serverIp + "FreezEyeV5DeviceSetting/SetEthernetSetting",
              {
                deviceId: this.deviceId,

                //ethernet
                ehtrIpAddress: this.ethernet.ipAddress,
                ehtrMask: this.ethernet.subnetMask,
                ehtrGateway: this.ethernet.gateway,
                ehtrDns: this.ethernet.dns,
              }
            )
            .then((response) => {
              this.spinnerEthernet = false;
              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.addModal = false;
                  (this.alertModal = true),
                    (this.alertModalTitle = "تنظیمات"),
                    (this.alertModalText =
                      "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                    (this.alertModalColor = "success"),
                    (this.alertModalButtonText = "تایید"),
                    this.refreshDeviceSetting("wifi");
                } else if (response.data == 2) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 3) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 4) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "پاسخی دریافت نشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                }
                // modal successfuly
              } else {
                // modal unsuccessful edit change
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                (this.alertModalColor = "warning"),
                  (this.alertModalButtonText = "تایید");
              }
            })
            .catch((error) => {
              this.spinnerEthernet = false;
              console.log(error);
            });
        }
      } else if (whichSetting == "server") {
        var forms = document.querySelectorAll(".needs-validationServer");
        let formValid = true;

        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          }
        }
        if (!formValid) {
          //console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          this.spinnerServer = true;

          axios
            .post(
              Values.serverIp + "FreezEyeV5DeviceSetting/SetWebServiceSetting",
              {
                deviceId: this.deviceId,

                //server Ip
                WebServiceGprsAddressIp: this.serverInfo.ipAddressGPRS,
                WebServiceWifiAddressIp: this.serverInfo.ipAddressWiFi,
                WebServiceEthernetAddressIp: this.serverInfo.ipAddressEthernet,
                WebServiceUdpPort: this.serverInfo.port,
                WebBeatPeriodInSeconds: this.serverInfo.timeDistance,
                SystemDebug: this.serverInfo.debugSystem,
                GsmDebug: this.serverInfo.debugGsm,
                WifiDebug: this.serverInfo.debugWifi,
                WifiBeat: this.serverInfo.wifi,
                EthernetBeat: this.serverInfo.ethernet,
                GprsBeat: this.serverInfo.gprs,
              }
            )
            .then((response) => {
              this.spinnerServer = false;

              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.addModal = false;
                  (this.alertModal = true),
                    (this.alertModalTitle = "تنظیمات"),
                    (this.alertModalText =
                      "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                    (this.alertModalColor = "success"),
                    (this.alertModalButtonText = "تایید"),
                    this.refreshDeviceSetting("wifi");
                } else if (response.data == 2) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 3) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 4) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "پاسخی دریافت نشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                }
              } else {
                // modal unsuccessful edit change
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                (this.alertModalColor = "warning"),
                  (this.alertModalButtonText = "تایید");
              }
            })
            .catch((error) => {
              this.spinnerServer = false;
              console.log(error);
            });
        }
      } else if (whichSetting == "simcard") {
        this.spinnerSimcard = true;

        axios
          .post(Values.serverIp + "FreezEyeV5DeviceSetting/SetSimCardSetting", {
            deviceId: this.deviceId,

            // //simcard
            simCardTypeOperator: this.SimcardOprator.id,
            simCardTypeCreditOrFixed: this.SimcardType.id,
          })
          .then((response) => {
            this.spinnerSimcard = false;

            if (response.status == 200) {
              //console.log(response.data);
              if (response.data == 1) {
                this.addModal = false;
                (this.alertModal = true),
                  (this.alertModalTitle = "تنظیمات"),
                  (this.alertModalText =
                    "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                  (this.alertModalColor = "success"),
                  (this.alertModalButtonText = "تایید"),
                  this.refreshDeviceSetting("wifi");
              } else if (response.data == 2) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 3) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 4) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "پاسخی دریافت نشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              }
              // modal successfuly
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            this.spinnerSimcard = false;

            console.log(error);
          });
      } else if (whichSetting == "startDelay") {
        this.spinnerStartDelay = true;

        axios
          .post(
            Values.serverIp +
              "FreezEyeV5DeviceSetting/SetRefrigeratorStartupDelayInSecondsSetting",
            {
              deviceId: this.deviceId,

              // //simcard
              refrigeratorStartupDelayInSeconds: this.info.startDelay,
            }
          )
          .then((response) => {
            this.spinnerStartDelay = false;

            if (response.status == 200) {
              //console.log(response.data);
              if (response.data == 1) {
                this.addModal = false;
                (this.alertModal = true),
                  (this.alertModalTitle = "تنظیمات"),
                  (this.alertModalText =
                    "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                  (this.alertModalColor = "success"),
                  (this.alertModalButtonText = "تایید"),
                  this.refreshDeviceSetting("wifi");
              } else if (response.data == 2) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 3) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 4) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "پاسخی دریافت نشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              }
              // modal successfuly
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            this.spinnerStartDelay = false;

            console.log(error);
          });
      } else if (whichSetting == "serial") {
        if (this.serial.serialNumber.length < 4) {
          this.alertModal = true;
          this.alertModalTitle = "تنظیمات";
          this.alertModalText = "شماره سریال باید چهار رقم باشد.";
          this.alertModalColor = "danger";
          this.alertModalButtonText = "تایید";
        } else {
          this.spinnerSerialNumber = true;
          axios
            .post(
              Values.serverIp + "FreezEyeV5DeviceSetting/SetSystemIdSetting",
              {
                deviceId: this.deviceId,

                // //simcard
                systemId: this.serial.serialNumber,
              }
            )
            .then((response) => {
              this.spinnerSerialNumber = false;

              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.addModal = false;
                  (this.alertModal = true),
                    (this.alertModalTitle = "تنظیمات"),
                    (this.alertModalText = "تنظیمات با موفقیت ارسال شد."),
                    (this.alertModalColor = "success"),
                    (this.alertModalButtonText = "تایید"),
                    this.refreshTable();
                } else if (response.data == 2) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 3) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 4) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "پاسخی دریافت نشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                }
                // modal successfuly
              } else {
                // modal unsuccessful edit change
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                (this.alertModalColor = "danger"),
                  (this.alertModalButtonText = "تایید");
              }
            })
            .catch((error) => {
              this.spinnerSerialNumber = false;
              console.log(error);
            });
        }
      } else if (whichSetting == "voiceAlarm") {
        this.spinnerVoiceAlarm = true;

        axios
          .post(
            Values.serverIp + "FreezEyeV5DeviceSetting/SetAlarmTimerSetting",
            {
              deviceId: this.deviceId,

              //voice alarm
              alarmDelay: this.voiceAlarmInfo.delay,
              alarmDuration: this.voiceAlarmInfo.length,
              temperatureSoundAlarm: this.voiceAlarmInfo.voiceTemp,
              temperatureSmsAlarm: this.voiceAlarmInfo.smsTemp,
              humiditySoundAlarm: this.voiceAlarmInfo.voiceHum,
              humiditySmsAlarm: this.voiceAlarmInfo.smsHum,
            }
          )
          .then((response) => {
            this.spinnerVoiceAlarm = false;

            if (response.status == 200) {
              //console.log(response.data);
              if (response.data == 1) {
                this.addModal = false;
                (this.alertModal = true),
                  (this.alertModalTitle = "تنظیمات"),
                  (this.alertModalText =
                    "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                  (this.alertModalColor = "success"),
                  (this.alertModalButtonText = "تایید"),
                  this.refreshDeviceSetting("wifi");
              } else if (response.data == 2) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 3) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 4) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "پاسخی دریافت نشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              }
              // modal successfuly
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            this.spinnerVoiceAlarm = false;

            console.log(error);
          });
      } else if (whichSetting == "puls") {
        this.spinnerPuls = true;

        axios
          .post(Values.serverIp + "FreezEyeV5DeviceSetting/SetBeatSetting", {
            deviceId: this.deviceId,

            //puls
            firstBeatTime: this.pulsInfo.first,
            secondBeatTime: this.pulsInfo.second,
          })
          .then((response) => {
            this.spinnerPuls = false;

            if (response.status == 200) {
              //console.log(response.data);
              if (response.data == 1) {
                this.addModal = false;
                (this.alertModal = true),
                  (this.alertModalTitle = "تنظیمات"),
                  (this.alertModalText =
                    "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                  (this.alertModalColor = "success"),
                  (this.alertModalButtonText = "تایید"),
                  this.refreshDeviceSetting("wifi");
              } else if (response.data == 2) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 3) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 4) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "پاسخی دریافت نشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              }
              // modal successfuly
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            this.spinnerPuls = false;

            console.log(error);
          });
      } else if (whichSetting == "dateTime") {
        this.spinnerPuls = true;

        axios
          .post(
            Values.serverIp + "FreezEyeV5DeviceSetting/SetDateTimeSetting",
            {
              deviceId: this.deviceId,
            }
          )
          .then((response) => {
            this.spinnerPuls = false;

            if (response.status == 200) {
              //console.log(response.data);
              if (response.data == 1) {
                this.addModal = false;
                (this.alertModal = true),
                  (this.alertModalTitle = "تنظیمات"),
                  (this.alertModalText =
                    "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                  (this.alertModalColor = "success"),
                  (this.alertModalButtonText = "تایید"),
                  this.refreshDeviceSetting("dateTime");
              } else if (response.data == 2) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 3) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 4) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "پاسخی دریافت نشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              }
              // modal successfuly
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            this.spinnerPuls = false;

            console.log(error);
          });
      } else if (whichSetting == "sms") {
        var forms = document.querySelectorAll(".needs-validationSms");
        let formValid = true;

        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].id == "mobileNumber" &&
            !forms[0][i].value.match(this.mobileFormat)
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (this.smsSettingInfo.reception.value == "") {
            $(".needs-validationSms > .multiselect__tags").css(
              "border-color",
              "red"
            );
            formValid = false;
          }
        }

        if (!formValid) {
          //console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          this.spinnerSms = true;
          axios
            .post(
              Values.serverIp +
                "FreezEyeV5DeviceSetting/SetSmsReceiversSetting",
              {
                deviceId: this.deviceId,
                receiver: this.smsSettingInfo.reception.value,
                simCartNumber: this.smsSettingInfo.phoneNumber,

                temperatureHighLimitSmsTimer: this.smsSettingInfo.timeMaxTemp,
                temperatureLowLimitSmsTimer: this.smsSettingInfo.timeMinTemp,
                humidityHighLimitSmsTimer: this.smsSettingInfo.timeMaxHum,
                humidityLowLimitSmsTimer: this.smsSettingInfo.timeMinHum,
                powerDisconnectSmsTimer: this.smsSettingInfo.timeDisPower,
                sensorDisconnectSmsTimer: this.smsSettingInfo.timeDisSensor,

                smsActive: this.smsSettingInfo.active,
                smsText: this.smsSettingInfo.textSms,
                smsBeatSend: this.smsSettingInfo.puls,

                // sms
                // temperatureAlarmLevelSensor1High: this.settingValues[0].alarmUp,
                // temperatureAlarmLevelSensor1Low:
                //   this.settingValues[0].alarmDown,
                // temperatureAlarmLevelSensor2High: this.settingValues[1].alarmUp,
                // temperatureAlarmLevelSensor2Low:
                //   this.settingValues[1].alarmDown,
                // temperatureAlarmLevelSensor3High: this.settingValues[2].alarmUp,
                // temperatureAlarmLevelSensor3Low:
                //   this.settingValues[2].alarmDown,
                // humidityAlarmLevelSensor1High: this.settingValues[3].alarmUp,
                // humidityAlarmLevelSensor1Low: this.settingValues[3].alarmDown,
                // humidityAlarmLevelSensor2High: this.settingValues[4].alarmUp,
                // humidityAlarmLevelSensor2Low: this.settingValues[4].alarmDown,
                // humidityAlarmLevelSensor3High: this.settingValues[5].alarmUp,
                // humidityAlarmLevelSensor3Low: this.settingValues[5].alarmDown,
              }
            )
            .then((response) => {
              this.spinnerSms = false;

              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.addModal = false;
                  (this.alertModal = true),
                    (this.alertModalTitle = "تنظیمات"),
                    (this.alertModalText =
                      "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                    (this.alertModalColor = "success"),
                    (this.alertModalButtonText = "تایید"),
                    this.refreshDeviceSetting("sms");
                } else if (response.data == 2) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 3) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 4) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "پاسخی دریافت نشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                }
                // modal successfuly
              } else {
                // modal unsuccessful edit change
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                (this.alertModalColor = "warning"),
                  (this.alertModalButtonText = "تایید");
              }
            })
            .catch((error) => {
              this.spinnerSms = false;

              console.log(error);
            });
        }
      } else if (whichSetting == "smsTemp") {
        var forms = document.querySelectorAll(".needs-validationSms");
        let formValid = true;

        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].id == "mobileNumber" &&
            !forms[0][i].value.match(this.mobileFormat)
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (this.smsSettingInfo.reception.value == "") {
            $(".needs-validationSms > .multiselect__tags").css(
              "border-color",
              "red"
            );
            formValid = false;
          }
        }

        if (!formValid) {
          //console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          this.spinnerSmsTemp = true;
          axios
            .post(
              Values.serverIp +
                "FreezEyeV5DeviceSetting/SetTemperatureSensorsAlarmSmsLimit",
              {
                deviceId: this.deviceId,
                receiver: this.smsSettingInfo.receptionTemp.value,

                // sms
                temperatureAlarmLevelSensor1High: this.settingValues[0].alarmUp,
                temperatureAlarmLevelSensor1Low:
                  this.settingValues[0].alarmDown,
                temperatureAlarmLevelSensor2High: this.settingValues[1].alarmUp,
                temperatureAlarmLevelSensor2Low:
                  this.settingValues[1].alarmDown,
                temperatureAlarmLevelSensor3High: this.settingValues[2].alarmUp,
                temperatureAlarmLevelSensor3Low:
                  this.settingValues[2].alarmDown,
                // humidityAlarmLevelSensor1High: this.settingValues[3].alarmUp,
                // humidityAlarmLevelSensor1Low: this.settingValues[3].alarmDown,
                // humidityAlarmLevelSensor2High: this.settingValues[4].alarmUp,
                // humidityAlarmLevelSensor2Low: this.settingValues[4].alarmDown,
                // humidityAlarmLevelSensor3High: this.settingValues[5].alarmUp,
                // humidityAlarmLevelSensor3Low: this.settingValues[5].alarmDown,

                // simCartNumber: this.smsSettingInfo.phoneNumber,

                // temperatureHighLimitSmsTimer: this.smsSettingInfo.timeMaxTemp,
                // temperatureLowLimitSmsTimer: this.smsSettingInfo.timeMinTemp,
                // humidityHighLimitSmsTimer: this.smsSettingInfo.timeMaxHum,
                // humidityLowLimitSmsTimer: this.smsSettingInfo.timeMinHum,
                // powerDisconnectSmsTimer: this.smsSettingInfo.timeDisPower,
                // sensorDisconnectSmsTimer: this.smsSettingInfo.timeDisSensor,

                // smsActive: this.smsSettingInfo.active,
                // smsText: this.smsSettingInfo.textSms,
                // smsBeatSend: this.smsSettingInfo.puls,
              }
            )
            .then((response) => {
              this.spinnerSmsTemp = false;

              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.addModal = false;
                  (this.alertModal = true),
                    (this.alertModalTitle = "تنظیمات"),
                    (this.alertModalText =
                      "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                    (this.alertModalColor = "success"),
                    (this.alertModalButtonText = "تایید"),
                    this.refreshDeviceSetting("smsTemp");
                } else if (response.data == 2) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 3) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 4) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "پاسخی دریافت نشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                }
                // modal successfuly
              } else {
                // modal unsuccessful edit change
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                (this.alertModalColor = "warning"),
                  (this.alertModalButtonText = "تایید");
              }
            })
            .catch((error) => {
              this.spinnerSmsTemp = false;

              console.log(error);
            });
        }
      } else if (whichSetting == "smsHum") {
        var forms = document.querySelectorAll(".needs-validationSms");
        let formValid = true;

        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].id == "mobileNumber" &&
            !forms[0][i].value.match(this.mobileFormat)
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (this.smsSettingInfo.reception.value == "") {
            $(".needs-validationSms > .multiselect__tags").css(
              "border-color",
              "red"
            );
            formValid = false;
          }
        }

        if (!formValid) {
          //console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          this.spinnerSmsHum = true;
          axios
            .post(
              Values.serverIp +
                "FreezEyeV5DeviceSetting/SetHumiditySensorsAlarmSmsLimit",
              {
                deviceId: this.deviceId,
                receiver: this.smsSettingInfo.receptionHum.value,

                humidityAlarmLevelSensor1High: this.settingValues[3].alarmUp,
                humidityAlarmLevelSensor1Low: this.settingValues[3].alarmDown,
                humidityAlarmLevelSensor2High: this.settingValues[4].alarmUp,
                humidityAlarmLevelSensor2Low: this.settingValues[4].alarmDown,
                humidityAlarmLevelSensor3High: this.settingValues[5].alarmUp,
                humidityAlarmLevelSensor3Low: this.settingValues[5].alarmDown,

                // sms
                // temperatureAlarmLevelSensor1High: this.settingValues[0].alarmUp,
                // temperatureAlarmLevelSensor1Low:
                //   this.settingValues[0].alarmDown,
                // temperatureAlarmLevelSensor2High: this.settingValues[1].alarmUp,
                // temperatureAlarmLevelSensor2Low:
                //   this.settingValues[1].alarmDown,
                // temperatureAlarmLevelSensor3High: this.settingValues[2].alarmUp,
                // temperatureAlarmLevelSensor3Low:
                //   this.settingValues[2].alarmDown,

                // simCartNumber: this.smsSettingInfo.phoneNumber,

                // temperatureHighLimitSmsTimer: this.smsSettingInfo.timeMaxTemp,
                // temperatureLowLimitSmsTimer: this.smsSettingInfo.timeMinTemp,
                // humidityHighLimitSmsTimer: this.smsSettingInfo.timeMaxHum,
                // humidityLowLimitSmsTimer: this.smsSettingInfo.timeMinHum,
                // powerDisconnectSmsTimer: this.smsSettingInfo.timeDisPower,
                // sensorDisconnectSmsTimer: this.smsSettingInfo.timeDisSensor,

                // smsActive: this.smsSettingInfo.active,
                // smsText: this.smsSettingInfo.textSms,
                // smsBeatSend: this.smsSettingInfo.puls,
              }
            )
            .then((response) => {
              this.spinnerSmsHum = false;

              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.addModal = false;
                  (this.alertModal = true),
                    (this.alertModalTitle = "تنظیمات"),
                    (this.alertModalText =
                      "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                    (this.alertModalColor = "success"),
                    (this.alertModalButtonText = "تایید"),
                    this.refreshDeviceSetting("smsHum");
                } else if (response.data == 2) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 3) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 4) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "پاسخی دریافت نشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                }
                // modal successfuly
              } else {
                // modal unsuccessful edit change
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                (this.alertModalColor = "warning"),
                  (this.alertModalButtonText = "تایید");
              }
            })
            .catch((error) => {
              this.spinnerSmsHum = false;

              console.log(error);
            });
        }
      } else if (whichSetting == "sensor") {
        var forms = document.querySelectorAll(".needs-validationSensor");
        let formValid = true;

        for (var i = 0; i < forms[0].length; i++) {
          if (
            forms[0][i].type == "text" &&
            forms[0][i].required &&
            forms[0][i].value.length == 0
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "text" &&
            !forms[0][i].value.match(this.ipformat) &&
            !forms[0][i].value.length == 0 &&
            forms[0][i].maxLength == 15
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "number" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].type == "select-one" &&
            forms[0][i].required &&
            forms[0][i].value == ""
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (
            forms[0][i].id == "mobileNumber" &&
            !forms[0][i].value.match(this.mobileFormat)
          ) {
            document.getElementById(forms[0][i].id).style.borderColor = "red";
            formValid = false;
          } else if (this.indexValueSensor.value == "") {
            $(".needs-validationSensor > .multiselect__tags").css(
              "border-color",
              "red"
            );
            formValid = false;
          }
        }

        if (!formValid) {
          //console.log("bad ip");
          this.alert = true;
          this.alertText = "داده های وارد شده صحیح نمی باشد.";
        } else {
          this.spinnerSensor = true;

          axios
            .post(
              Values.serverIp + "FreezEyeV5DeviceSetting/SetSensorsSetting",
              {
                deviceId: this.deviceId,
                // sensor
                sensorIndex: this.indexValueSensor.value,
                sensorTypeRegister: this.typeValue.value,
                sensorEnable: this.activeSensor,
                sensorValuesList: this.settingValuesSensor,
              }
            )
            .then((response) => {
              this.spinnerSensor = false;
              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.addModal = false;
                  (this.alertModal = true),
                    (this.alertModalTitle = "تنظیمات"),
                    (this.alertModalText =
                      "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                    (this.alertModalColor = "success"),
                    (this.alertModalButtonText = "تایید"),
                    this.refreshDeviceSetting("wifi");
                } else if (response.data == 2) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 3) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 4) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "پاسخی دریافت نشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                }
                // modal successfuly
              } else {
                // modal unsuccessful edit change
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                (this.alertModalColor = "warning"),
                  (this.alertModalButtonText = "تایید");
              }
            })
            .catch((error) => {
              this.spinnerSensor = false;
              console.log(error);
            });
        }
      } else if (whichSetting == "resetDevice") {
        //console.log(this.deviceId);
        const config = { headers: { "Content-Type": "application/json" } };

        axios
          .post(
            Values.serverIp + "NavganDeviceSetting/SetReset",
            this.deviceId,
            config
          )
          .then((response) => {
            this.spinnerSensor = false;
            if (response.status == 200) {
              //console.log(response.data);
              if (response.data == 1) {
                this.addModal = false;
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "درخواست تنظیمات با موفقیت ارسال شد.";
                this.alertModalColor = "success";
                this.alertModalButtonText = "تایید";
                // this.refreshDeviceSetting("wifi");
              } else if (response.data == 2) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 3) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 4) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "پاسخی دریافت نشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              }
              // modal successfuly
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            this.spinnerSensor = false;
            console.log(error);
          });
      } else if (whichSetting == "breakPolomp") {
        // console.log(this.deviceId);

        const config = { headers: { "Content-Type": "application/json" } };

        axios
          .post(
            Values.serverIp + "NavganDeviceSetting/SetJawState",
            this.deviceId,
            config
          )
          .then((response) => {
            this.spinnerSensor = false;
            if (response.status == 200) {
              //console.log(response.data);
              if (response.data == 1) {
                this.addModal = false;
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "درخواست تنظیمات با موفقیت ارسال شد.";
                this.alertModalColor = "success";
                this.alertModalButtonText = "تایید";
                // this.refreshDeviceSetting("wifi");
              } else if (response.data == 2) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 3) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 4) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "پاسخی دریافت نشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              }
              // modal successfuly
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            this.spinnerSensor = false;
            console.log(error);
          });
      }
    },

    //*********************************************************************set device Setting */
    recieveDeviceSetting(whichSetting) {
      if (whichSetting == "wifi") {
        this.spinnerWifi = true;

        axios
          .post(
            Values.serverIp + "FreezEyeV5DeviceSetting/GetWifiAddressSetting",
            {
              //wifi
              deviceId: this.deviceId,
              wifiIpAddress: this.wifi.ipAddress,
              wifiSubnetMask: this.wifi.subnetMask,
              wifiGateway: this.wifi.gateway,
              wifiDns: this.wifi.dns,
              wifiSsid: this.wifi.ssid,
              wifiPassword: this.wifi.password,
              wifiEnable: this.wifi.active,
            }
          )
          .then((response) => {
            this.spinnerWifi = false;
            if (response.status == 200) {
              //console.log(response.data);
              if (response.data == 1) {
                this.addModal = false;
                (this.alertModal = true),
                  (this.alertModalTitle = "تنظیمات"),
                  (this.alertModalText =
                    "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                  (this.alertModalColor = "success"),
                  (this.alertModalButtonText = "تایید"),
                  this.refreshDeviceSetting("wifi");
              } else if (response.data == 2) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 3) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 4) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "پاسخی دریافت نشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              }
              // modal successfuly
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            console.log(error);
            this.spinnerWifi = false;
          });
      } else if (whichSetting == "wifi_ssid") {
        this.spinnerWifiSsid = true;

        axios
          .post(
            Values.serverIp +
              "FreezEyeV5DeviceSetting/GetWifiConnectionSetting",
            {
              //wifi
              deviceId: this.deviceId,
              wifiSsid: this.wifi.ssid,
              wifiPassword: this.wifi.password,
              wifiEnable: this.wifi.active,
            }
          )
          .then((response) => {
            this.spinnerWifiSsid = false;
            if (response.status == 200) {
              //console.log(response.data);
              if (response.data == 1) {
                this.addModal = false;
                (this.alertModal = true),
                  (this.alertModalTitle = "تنظیمات"),
                  (this.alertModalText =
                    "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                  (this.alertModalColor = "success"),
                  (this.alertModalButtonText = "تایید"),
                  this.refreshDeviceSetting("wifi_ssid");
              } else if (response.data == 2) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 3) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 4) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "پاسخی دریافت نشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              }
              // modal successfuly
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            console.log(error);
            this.spinnerWifiSsid = false;
          });
      } else if (whichSetting == "ethernet") {
        this.spinnerEthernet = true;
        axios
          .post(
            Values.serverIp + "FreezEyeV5DeviceSetting/GetEthernetSetting",
            {
              deviceId: this.deviceId,

              //ethernet
              ehtrIpAddress: this.ethernet.ipAddress,
              ehtrMask: this.ethernet.subnetMask,
              ehtrGateway: this.ethernet.gateway,
              ehtrDns: this.ethernet.dns,
            }
          )
          .then((response) => {
            this.spinnerEthernet = false;
            if (response.status == 200) {
              //console.log(response.data);
              if (response.data == 1) {
                this.addModal = false;
                (this.alertModal = true),
                  (this.alertModalTitle = "تنظیمات"),
                  (this.alertModalText =
                    "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                  (this.alertModalColor = "success"),
                  (this.alertModalButtonText = "تایید"),
                  this.refreshDeviceSetting("ethernet");
              } else if (response.data == 2) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 3) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 4) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "پاسخی دریافت نشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              }
              // modal successfuly
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            this.spinnerEthernet = false;
            console.log(error);
          });
      } else if (whichSetting == "server") {
        this.spinnerServer = true;
        axios
          .post(
            Values.serverIp + "FreezEyeV5DeviceSetting/GetWebServiceSetting",
            {
              deviceId: this.deviceId,

              //server Ip
              webServiceGprsAddressIp: this.serverInfo.ipAddressGPRS,
              webServiceWifiAddressIp: this.serverInfo.ipAddressWiFi,
              webServiceEthernetAddressIp: this.serverInfo.ipAddressEthernet,
              webServiceUdpPort: 0,
              webBeatPeriodInSeconds: 0,
              systemDebug: this.serverInfo.debugSystem,
              gsmDebug: this.serverInfo.debugGsm,
              wifiDebug: this.serverInfo.debugWifi,
              wifiBeat: this.serverInfo.wifi,
              ethernetBeat: this.serverInfo.ethernet,
              gprsBeat: this.serverInfo.gprs,
            }
          )
          .then((response) => {
            this.spinnerServer = false;
            if (response.status == 200) {
              //console.log(response.data);
              if (response.data == 1) {
                this.addModal = false;
                (this.alertModal = true),
                  (this.alertModalTitle = "تنظیمات"),
                  (this.alertModalText =
                    "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                  (this.alertModalColor = "success"),
                  (this.alertModalButtonText = "تایید"),
                  this.refreshDeviceSetting("server");
              } else if (response.data == 2) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 3) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 4) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "پاسخی دریافت نشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              }
              // modal successfuly
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            this.spinnerServer = false;
            console.log(error);
          });
      } else if (whichSetting == "simcard") {
        this.spinnerSimcard = true;
        axios
          .post(Values.serverIp + "FreezEyeV5DeviceSetting/GetSimCardSetting", {
            deviceId: this.deviceId,

            // //simcard
            simCardTypeOperator: this.SimcardOprator.id,
            simCardTypeCreditOrFixed: this.SimcardType.id,
          })
          .then((response) => {
            this.spinnerSimcard = false;
            if (response.status == 200) {
              //console.log(response.data);
              if (response.data == 1) {
                this.addModal = false;
                (this.alertModal = true),
                  (this.alertModalTitle = "تنظیمات"),
                  (this.alertModalText =
                    "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                  (this.alertModalColor = "success"),
                  (this.alertModalButtonText = "تایید"),
                  this.refreshDeviceSetting("simcard");
              } else if (response.data == 2) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 3) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 4) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "پاسخی دریافت نشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              }
              // modal successfuly
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            this.spinnerSimcard = false;
            console.log(error);
          });
      } else if (whichSetting == "startDelay") {
        this.spinnerStartDelay = true;
        axios
          .post(
            Values.serverIp +
              "FreezEyeV5DeviceSetting/GetRefrigeratorStartupDelayInSecondsSetting",
            {
              deviceId: this.deviceId,

              //startDelay
              refrigeratorStartupDelayInSeconds: this.info.startDelay,
            }
          )
          .then((response) => {
            this.spinnerStartDelay = false;
            if (response.status == 200) {
              //console.log(response.data);
              if (response.data == 1) {
                this.addModal = false;
                (this.alertModal = true),
                  (this.alertModalTitle = "تنظیمات"),
                  (this.alertModalText =
                    "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                  (this.alertModalColor = "success"),
                  (this.alertModalButtonText = "تایید"),
                  this.refreshDeviceSetting("startDelay");
              } else if (response.data == 2) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 3) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 4) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "پاسخی دریافت نشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              }
              // modal successfuly
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            this.spinnerStartDelay = false;
            console.log(error);
          });
      } else if (whichSetting == "serial") {
        this.spinnerSerialNumber = true;
        axios
          .post(
            Values.serverIp + "FreezEyeV5DeviceSetting/GetSystemIdSetting",
            {
              deviceId: this.deviceId,

              //startDelay
              systemId: this.serial.serialNumber,
            }
          )
          .then((response) => {
            this.spinnerSerialNumber = false;
            if (response.status == 200) {
              //console.log(response.data);
              if (response.data == 1) {
                this.addModal = false;
                (this.alertModal = true),
                  (this.alertModalTitle = "تنظیمات"),
                  (this.alertModalText =
                    "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                  (this.alertModalColor = "success"),
                  (this.alertModalButtonText = "تایید"),
                  this.refreshDeviceSetting("serial");
              } else if (response.data == 2) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 3) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 4) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "پاسخی دریافت نشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              }
              // modal successfuly
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            this.spinnerSerialNumber = false;
            console.log(error);
          });
      } else if (whichSetting == "voiceAlarm") {
        this.spinnerVoiceAlarm = true;
        axios
          .post(
            Values.serverIp + "FreezEyeV5DeviceSetting/GetAlarmTimerSetting",
            {
              deviceId: this.deviceId,

              //voice alarm
              alarmDelay: 0,
              alarmDuration: 0,
              temperatureSoundAlarm: this.voiceAlarmInfo.voiceTemp,
              temperatureSmsAlarm: this.voiceAlarmInfo.smsTemp,
              humiditySoundAlarm: this.voiceAlarmInfo.voiceHum,
              humiditySmsAlarm: this.voiceAlarmInfo.smsHum,
            }
          )
          .then((response) => {
            this.spinnerVoiceAlarm = false;
            if (response.status == 200) {
              //console.log(response.data);
              if (response.data == 1) {
                this.addModal = false;
                (this.alertModal = true),
                  (this.alertModalTitle = "تنظیمات"),
                  (this.alertModalText =
                    "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                  (this.alertModalColor = "success"),
                  (this.alertModalButtonText = "تایید"),
                  this.refreshDeviceSetting("voiceAlarm");
              } else if (response.data == 2) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 3) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 4) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "پاسخی دریافت نشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              }
              // modal successfuly
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            this.spinnerVoiceAlarm = false;
            console.log(error);
          });
      } else if (whichSetting == "puls") {
        this.spinnerPuls = true;

        axios
          .post(Values.serverIp + "FreezEyeV5DeviceSetting/GetBeatSetting", {
            deviceId: this.deviceId,

            //puls
            firstBeatTime: this.pulsInfo.first,
            secondBeatTime: this.pulsInfo.second,
          })
          .then((response) => {
            this.spinnerPuls = false;
            if (response.status == 200) {
              //console.log(response.data);
              if (response.data == 1) {
                this.addModal = false;
                (this.alertModal = true),
                  (this.alertModalTitle = "تنظیمات"),
                  (this.alertModalText =
                    "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                  (this.alertModalColor = "success"),
                  (this.alertModalButtonText = "تایید"),
                  this.refreshDeviceSetting("puls");
              } else if (response.data == 2) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 3) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 4) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "پاسخی دریافت نشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              }
              // modal successfuly
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            this.spinnerPuls = false;
            console.log(error);
          });
      } else if (whichSetting == "dateTime") {
        this.spinnerPuls = true;

        axios
          .post(
            Values.serverIp + "FreezEyeV5DeviceSetting/GetDateTimeSetting",
            {
              deviceId: this.deviceId,
            }
          )
          .then((response) => {
            this.spinnerPuls = false;
            if (response.status == 200) {
              //console.log(response.data);
              if (response.data == 1) {
                this.addModal = false;
                (this.alertModal = true),
                  (this.alertModalTitle = "تنظیمات"),
                  (this.alertModalText =
                    "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                  (this.alertModalColor = "success"),
                  (this.alertModalButtonText = "تایید"),
                  this.refreshDeviceSetting("dateTime");
              } else if (response.data == 2) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 3) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              } else if (response.data == 4) {
                this.alertModal = true;
                this.alertModalTitle = "تنظیمات";
                this.alertModalText = "پاسخی دریافت نشد.";
                this.alertModalColor = "danger";
                this.alertModalButtonText = "تایید";
              }
              // modal successfuly
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            this.spinnerPuls = false;
            console.log(error);
          });
      } else if (whichSetting == "sms") {
        this.spinnerSms = true;
        if (
          this.smsSettingInfo.reception.value == "1" ||
          this.smsSettingInfo.reception.value == "2" ||
          this.smsSettingInfo.reception.value == "3" ||
          this.smsSettingInfo.reception.value == "4" ||
          this.smsSettingInfo.reception.value == "5" ||
          this.smsSettingInfo.reception.value == "6"
        ) {
          axios
            .post(
              Values.serverIp +
                "FreezEyeV5DeviceSetting/GetSmsReceiversSetting",
              {
                deviceId: this.deviceId,

                // sms
                temperatureAlarmLevelSensor1High: 0,
                temperatureAlarmLevelSensor1Low: 0,
                temperatureAlarmLevelSensor2High: 0,
                temperatureAlarmLevelSensor2Low: 0,
                temperatureAlarmLevelSensor3High: 0,
                temperatureAlarmLevelSensor3Low: 0,
                humidityAlarmLevelSensor1High: 0,
                humidityAlarmLevelSensor1Low: 0,
                humidityAlarmLevelSensor2High: 0,
                humidityAlarmLevelSensor2Low: 0,
                humidityAlarmLevelSensor3High: 0,
                humidityAlarmLevelSensor3Low: 0,

                receiver: this.smsSettingInfo.reception.value,
                simCartNumber: this.smsSettingInfo.phoneNumber,

                temperatureHighLimitSmsTimer: 0,
                temperatureLowLimitSmsTimer: 0,
                humidityHighLimitSmsTimer: 0,
                humidityLowLimitSmsTimer: 0,
                powerDisconnectSmsTimer: 0,
                sensorDisconnectSmsTimer: 0,

                smsActive: this.smsSettingInfo.active,
                smsText: this.smsSettingInfo.textSms,
                smsBeatSend: this.smsSettingInfo.puls,
              }
            )
            .then((response) => {
              this.spinnerSms = false;
              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.addModal = false;
                  (this.alertModal = true),
                    (this.alertModalTitle = "تنظیمات"),
                    (this.alertModalText =
                      "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                    (this.alertModalColor = "success"),
                    (this.alertModalButtonText = "تایید"),
                    this.refreshDeviceSetting("sms");
                } else if (response.data == 2) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 3) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 4) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "پاسخی دریافت نشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                }
                // modal successfuly
              } else {
                // modal unsuccessful edit change
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                (this.alertModalColor = "warning"),
                  (this.alertModalButtonText = "تایید");
              }
            })
            .catch((error) => {
              this.spinnerSms = false;
              console.log(error);
            });
        } else {
          $(".needs-validationSms > .multiselect__tags").css(
            "border-color",
            "red"
          );
          this.alert = true;
          this.alertText = "خطا!!! لطفا گیرنده پیام را انتخاب نمایید.";
        }
      } else if (whichSetting == "smsTemp") {
        this.spinnerSmsTemp = true;
        if (
          this.smsSettingInfo.receptionTemp.value == "1" ||
          this.smsSettingInfo.receptionTemp.value == "2" ||
          this.smsSettingInfo.receptionTemp.value == "3" ||
          this.smsSettingInfo.receptionTemp.value == "4" ||
          this.smsSettingInfo.receptionTemp.value == "5" ||
          this.smsSettingInfo.receptionTemp.value == "6"
        ) {
          axios
            .post(
              Values.serverIp +
                "FreezEyeV5DeviceSetting/GetTemperatureSensorsAlarmSmsLimit",
              {
                deviceId: this.deviceId,

                // sms
                temperatureAlarmLevelSensor1High: 0,
                temperatureAlarmLevelSensor1Low: 0,
                temperatureAlarmLevelSensor2High: 0,
                temperatureAlarmLevelSensor2Low: 0,
                temperatureAlarmLevelSensor3High: 0,
                temperatureAlarmLevelSensor3Low: 0,
                humidityAlarmLevelSensor1High: 0,
                humidityAlarmLevelSensor1Low: 0,
                humidityAlarmLevelSensor2High: 0,
                humidityAlarmLevelSensor2Low: 0,
                humidityAlarmLevelSensor3High: 0,
                humidityAlarmLevelSensor3Low: 0,

                receiver: this.smsSettingInfo.receptionTemp.value,
                simCartNumber: this.smsSettingInfo.phoneNumber,

                temperatureHighLimitSmsTimer: 0,
                temperatureLowLimitSmsTimer: 0,
                humidityHighLimitSmsTimer: 0,
                humidityLowLimitSmsTimer: 0,
                powerDisconnectSmsTimer: 0,
                sensorDisconnectSmsTimer: 0,

                smsActive: this.smsSettingInfo.active,
                smsText: this.smsSettingInfo.textSms,
                smsBeatSend: this.smsSettingInfo.puls,
              }
            )
            .then((response) => {
              this.spinnerSmsTemp = false;
              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.addModal = false;
                  (this.alertModal = true),
                    (this.alertModalTitle = "تنظیمات"),
                    (this.alertModalText =
                      "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                    (this.alertModalColor = "success"),
                    (this.alertModalButtonText = "تایید"),
                    this.refreshDeviceSetting("smsTemp");
                } else if (response.data == 2) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 3) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 4) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "پاسخی دریافت نشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                }
                // modal successfuly
              } else {
                // modal unsuccessful edit change
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                (this.alertModalColor = "warning"),
                  (this.alertModalButtonText = "تایید");
              }
            })
            .catch((error) => {
              this.spinnerSmsTemp = false;
              console.log(error);
            });
        } else {
          $(".needs-validationSms > .multiselect__tags").css(
            "border-color",
            "red"
          );
          this.alert = true;
          this.alertText = "خطا!!! لطفا گیرنده پیام را انتخاب نمایید.";
        }
      } else if (whichSetting == "smsHum") {
        this.spinnerSmsHum = true;
        if (
          this.smsSettingInfo.receptionHum.value == "1" ||
          this.smsSettingInfo.receptionHum.value == "2" ||
          this.smsSettingInfo.receptionHum.value == "3" ||
          this.smsSettingInfo.receptionHum.value == "4" ||
          this.smsSettingInfo.receptionHum.value == "5" ||
          this.smsSettingInfo.receptionHum.value == "6"
        ) {
          axios
            .post(
              Values.serverIp +
                "FreezEyeV5DeviceSetting/GetHumiditySensorsAlarmSmsLimit",
              {
                deviceId: this.deviceId,

                // sms
                temperatureAlarmLevelSensor1High: 0,
                temperatureAlarmLevelSensor1Low: 0,
                temperatureAlarmLevelSensor2High: 0,
                temperatureAlarmLevelSensor2Low: 0,
                temperatureAlarmLevelSensor3High: 0,
                temperatureAlarmLevelSensor3Low: 0,
                humidityAlarmLevelSensor1High: 0,
                humidityAlarmLevelSensor1Low: 0,
                humidityAlarmLevelSensor2High: 0,
                humidityAlarmLevelSensor2Low: 0,
                humidityAlarmLevelSensor3High: 0,
                humidityAlarmLevelSensor3Low: 0,

                receiver: this.smsSettingInfo.receptionHum.value,
                simCartNumber: this.smsSettingInfo.phoneNumber,

                temperatureHighLimitSmsTimer: 0,
                temperatureLowLimitSmsTimer: 0,
                humidityHighLimitSmsTimer: 0,
                humidityLowLimitSmsTimer: 0,
                powerDisconnectSmsTimer: 0,
                sensorDisconnectSmsTimer: 0,

                smsActive: this.smsSettingInfo.active,
                smsText: this.smsSettingInfo.textSms,
                smsBeatSend: this.smsSettingInfo.puls,
              }
            )
            .then((response) => {
              this.spinnerSmsHum = false;
              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.addModal = false;
                  (this.alertModal = true),
                    (this.alertModalTitle = "تنظیمات"),
                    (this.alertModalText =
                      "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                    (this.alertModalColor = "success"),
                    (this.alertModalButtonText = "تایید"),
                    this.refreshDeviceSetting("smsHum");
                } else if (response.data == 2) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 3) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 4) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "پاسخی دریافت نشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                }
                // modal successfuly
              } else {
                // modal unsuccessful edit change
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                (this.alertModalColor = "warning"),
                  (this.alertModalButtonText = "تایید");
              }
            })
            .catch((error) => {
              this.spinnerSmsHum = false;
              console.log(error);
            });
        } else {
          $(".needs-validationSms > .multiselect__tags").css(
            "border-color",
            "red"
          );
          this.alert = true;
          this.alertText = "خطا!!! لطفا گیرنده پیام را انتخاب نمایید.";
        }
      } else if (whichSetting == "sensor") {
        this.spinnerSensor = true;
        if (this.indexValueSensor.value == "") {
          $(".needs-validationSensor > .multiselect__tags").css(
            "border-color",
            "red"
          );
          this.alert = true;
          this.alertText = "خطا!!! لطفا شماره سنسور را انتخاب نمایید.";
        } else {
          this.settingValuesSensor = [];
          this.selectedSensors = [];
          for (var i = 0; i < this.fullData.carSensorTypes.length; i++) {
            if (
              this.fullData.carSensorTypes[i].values.length >=
              parseInt(this.indexValueSensor.value)
            ) {
              this.selectedSensors.push({
                name: this.fullData.carSensorTypes[i].sensorTypeName,
                type: this.fullData.carSensorTypes[i].sensorType,
              });

              this.settingValuesSensor.push({
                sensorType: this.fullData.carSensorTypes[i].sensorType,
                validHighLimit: 0,
                validLowLimit: 0,
                alarmHighLimit: 0,
                alarmLowLimit: 0,
                calibration: 0,
              });
            }
          }
          axios
            .post(
              Values.serverIp + "FreezEyeV5DeviceSetting/GetSensorsSetting",
              {
                deviceId: this.deviceId,
                // sensor
                sensorIndex: this.indexValueSensor.value,
                sensorTypeRegister: this.typeValue.value,
                sensorEnable: this.activeSensor,

                sensorValuesList: this.settingValuesSensor,
              }
            )
            .then((response) => {
              this.spinnerSensor = false;
              if (response.status == 200) {
                //console.log(response.data);
                if (response.data == 1) {
                  this.addModal = false;
                  (this.alertModal = true),
                    (this.alertModalTitle = "تنظیمات"),
                    (this.alertModalText =
                      "درخواست تنظیمات با موفقیت ارسال دریافت شد."),
                    (this.alertModalColor = "success"),
                    (this.alertModalButtonText = "تایید"),
                    this.refreshDeviceSetting("sensor");
                } else if (response.data == 2) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 3) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "خطا!!! فرمت دستور صحیح نمی باشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                } else if (response.data == 4) {
                  this.alertModal = true;
                  this.alertModalTitle = "تنظیمات";
                  this.alertModalText = "پاسخی دریافت نشد.";
                  this.alertModalColor = "danger";
                  this.alertModalButtonText = "تایید";
                }
                // modal successfuly
              } else {
                // modal unsuccessful edit change
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                (this.alertModalColor = "warning"),
                  (this.alertModalButtonText = "تایید");
              }
            })
            .catch((error) => {
              this.spinnerSensor = false;
              console.log(error);
            });
        }
      }
    },

    //*********************************************************************set device Setting */
    refreshDeviceSetting(whichSetting) {
      if (whichSetting == "wifi") {
        axios
          .post(
            Values.serverIp +
              "FreezEyeV5DeviceSetting/GetWifiAddressSettingValue",
            {
              //wifi
              deviceId: this.deviceId,
              wifiIpAddress: this.wifi.ipAddress,
              wifiSubnetMask: this.wifi.subnetMask,
              wifiGateway: this.wifi.gateway,
              wifiDns: this.wifi.dns,
              wifiSsid: this.wifi.ssid,
              wifiPassword: this.wifi.password,
              wifiEnable: this.wifi.active,
            }
          )
          .then((response) => {
            if (response.status == 200) {
              //console.log(response.data);

              this.wifi.updateTime =
                response.data.wifiInformationLastUpdateDateTimeJalali;
              this.deviceId = response.data.deviceId;
              this.wifi.ipAddress = response.data.wifiIpAddress;
              this.wifi.subnetMask = response.data.wifiSubnetMask;
              this.wifi.gateway = response.data.wifiGateway;
              this.wifi.dns = response.data.wifiDns;

              // this.addModal = false;
              // (this.alertModal = true),
              //   (this.alertModalTitle = "تنظیمات"),
              //   (this.alertModalText = "دریافت تنظیمات با موفقیت ارسال شد."),
              //   (this.alertModalColor = "success"),
              //   (this.alertModalButtonText = "تایید"),
              //   this.refreshTable();
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (whichSetting == "wifi_ssid") {
        axios
          .post(
            Values.serverIp +
              "FreezEyeV5DeviceSetting/GetWifiConnectionSettingValue",
            {
              //wifi
              deviceId: this.deviceId,
              wifiIpAddress: this.wifi.ipAddress,
              wifiSubnetMask: this.wifi.subnetMask,
              wifiGateway: this.wifi.gateway,
              wifiDns: this.wifi.dns,
              wifiSsid: this.wifi.ssid,
              wifiPassword: this.wifi.password,
              wifiEnable: this.wifi.active,
            }
          )
          .then((response) => {
            if (response.status == 200) {
              //console.log(response.data);

              this.wifi.updateTime =
                response.data.wifiInformationLastUpdateDateTimeJalali;
              this.deviceId = response.data.deviceId;
              this.wifi.ssid = response.data.wifiSsid;
              this.wifi.password = response.data.wifiPassword;
              this.wifi.active = response.data.wifiEnable;
              // this.addModal = false;
              // (this.alertModal = true),
              //   (this.alertModalTitle = "تنظیمات"),
              //   (this.alertModalText = "دریافت تنظیمات با موفقیت ارسال شد."),
              //   (this.alertModalColor = "success"),
              //   (this.alertModalButtonText = "تایید"),
              //   this.refreshTable();
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (whichSetting == "ethernet") {
        axios
          .post(
            Values.serverIp + "FreezEyeV5DeviceSetting/GetEthernetSettingValue",
            {
              deviceId: this.deviceId,

              //ethernet
              ehtrIpAddress: this.ethernet.ipAddress,
              ehtrMask: this.ethernet.subnetMask,
              ehtrGateway: this.ethernet.gateway,
              ehtrDns: this.ethernet.dns,
            }
          )
          .then((response) => {
            if (response.status == 200) {
              //console.log(response.data);
              this.ethernet.updateTime =
                response.data.ethernetInformationLastUpdateDateTimeJalali;
              this.ethernet.ipAddress = response.data.ehtrIpAddress;
              this.ethernet.subnetMask = response.data.ehtrMask;
              this.ethernet.gateway = response.data.ehtrGateway;
              this.ethernet.dns = response.data.ehtrDns;
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (whichSetting == "server") {
        axios
          .post(
            Values.serverIp +
              "FreezEyeV5DeviceSetting/GetWebServiceSettingValue",
            {
              deviceId: this.deviceId,

              //server Ip

              webServiceGprsAddressIp: this.serverInfo.ipAddressGPRS,
              webServiceWifiAddressIp: this.serverInfo.ipAddressWiFi,
              webServiceEthernetAddressIp: this.serverInfo.ipAddressEthernet,
              webServiceUdpPort: 0,
              webBeatPeriodInSeconds: 0,
              systemDebug: this.serverInfo.debugSystem,
              gsmDebug: this.serverInfo.debugGsm,
              wifiDebug: this.serverInfo.debugWifi,
              wifiBeat: this.serverInfo.wifi,
              ethernetBeat: this.serverInfo.ethernet,
              gprsBeat: this.serverInfo.gprs,
            }
          )
          .then((response) => {
            if (response.status == 200) {
              //console.log(response.data);
              this.serverInfo.updateTime =
                response.data.webServiceInformationLastUpdateDateTimeJalali;
              this.serverInfo.ipAddressGPRS =
                response.data.webServiceGprsAddressIp;
              this.serverInfo.ipAddressWiFi =
                response.data.webServiceWifiAddressIp;
              this.serverInfo.ipAddressEthernet =
                response.data.webServiceEthernetAddressIp;

              this.serverInfo.port = response.data.webServiceUdpPort;
              this.serverInfo.timeDistance =
                response.data.webBeatPeriodInSeconds;
              this.serverInfo.debugSystem = response.data.systemDebug;
              this.serverInfo.debugGsm = response.data.gsmDebug;
              this.serverInfo.debugWifi = response.data.wifiDebug;
              this.serverInfo.wifi = response.data.wifiBeat;
              this.serverInfo.ethernet = response.data.ethernetBeat;
              this.serverInfo.gprs = response.data.gprsBeat;
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (whichSetting == "simcard") {
        axios
          .post(
            Values.serverIp + "FreezEyeV5DeviceSetting/GetSimCardSettingValue",
            {
              deviceId: this.deviceId,

              // //simcard
              simCardTypeOperator: this.SimcardOprator.id,
              simCardTypeCreditOrFixed: this.SimcardType.id,
            }
          )
          .then((response) => {
            if (response.status == 200) {
              //console.log(response.data);
              this.simcardUpdateTime =
                response.data.simCardInformationLastUpdateDateTimeJalali;
              this.setSimcardOprator(response.data.simCardTypeOperator);
              this.setSimcardType(response.data.simCardTypeCreditOrFixed);
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (whichSetting == "startDelay") {
        axios
          .post(
            Values.serverIp +
              "FreezEyeV5DeviceSetting/GetRefrigeratorStartupDelayInSecondsSettingValue",
            {
              deviceId: this.deviceId,

              //startDelay
              refrigeratorStartupDelayInSeconds: this.info.startDelay,
            }
          )
          .then((response) => {
            if (response.status == 200) {
              //console.log(response.data);
              this.startDelayUpdateTime =
                response.data.refrigeratorStartupDelayInSecondsLastUpdateDateTimeJalali;
              this.info.startDelay =
                response.data.refrigeratorStartupDelayInSeconds;
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (whichSetting == "serial") {
        axios
          .post(
            Values.serverIp + "FreezEyeV5DeviceSetting/GetSystemIdSettingValue",
            {
              deviceId: this.deviceId,

              //startDelay
              systemId: this.serial.serialNumber,
            }
          )
          .then((response) => {
            if (response.status == 200) {
              console.log(response.data);
              this.serial.serialTime =
                response.data.systemIdLastUpdateDateTimeJalali;
              this.serial.serialNumber = response.data.systemId;
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (whichSetting == "voiceAlarm") {
        axios
          .post(
            Values.serverIp +
              "FreezEyeV5DeviceSetting/GetAlarmTimerSettingValue",
            {
              deviceId: this.deviceId,

              //voice alarm
              alarmDelay: 0,
              alarmDuration: 0,
              temperatureSoundAlarm: this.voiceAlarmInfo.voiceTemp,
              temperatureSmsAlarm: this.voiceAlarmInfo.smsTemp,
              humiditySoundAlarm: this.voiceAlarmInfo.voiceHum,
              humiditySmsAlarm: this.voiceAlarmInfo.smsHum,
            }
          )
          .then((response) => {
            if (response.status == 200) {
              this.voiceAlarmInfo.updateTime =
                response.data.timerAlarmInformationLastUpdateDateTimeJalali;

              this.voiceAlarmInfo.delay = response.data.alarmDelay;
              this.voiceAlarmInfo.length = response.data.alarmDuration;
              this.voiceAlarmInfo.voiceTemp =
                response.data.temperatureSoundAlarm;
              this.voiceAlarmInfo.smsTemp = response.data.temperatureSmsAlarm;
              this.voiceAlarmInfo.voiceHum = response.data.humiditySoundAlarm;
              this.voiceAlarmInfo.smsHum = response.data.humiditySmsAlarm;
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (whichSetting == "puls") {
        axios
          .post(
            Values.serverIp + "FreezEyeV5DeviceSetting/GetBeatSettingValue",
            {
              deviceId: this.deviceId,

              //puls
              firstBeatTime: this.pulsInfo.first,
              secondBeatTime: this.pulsInfo.second,
            }
          )
          .then((response) => {
            if (response.status == 200) {
              this.pulsInfo.updateTime =
                response.data.beatInformationLastUpdateDateTimeJalali;
              this.pulsInfo.first = response.data.firstBeatTime;
              this.pulsInfo.second = response.data.secondBeatTime;
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (whichSetting == "dateTime") {
        axios
          .post(
            Values.serverIp + "FreezEyeV5DeviceSetting/GetDateTimeSettingValue",
            {
              deviceId: this.deviceId,
            }
          )
          .then((response) => {
            if (response.status == 200) {
              this.dateTime.updateTime =
                response.data.dateTimeLastUpdateDateTimeJalali;
              this.dateTime.dateTime = response.data.dateTime;
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              (this.alertModalColor = "warning"),
                (this.alertModalButtonText = "تایید");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (whichSetting == "sms") {
        if (
          this.smsSettingInfo.reception.value == "1" ||
          this.smsSettingInfo.reception.value == "2" ||
          this.smsSettingInfo.reception.value == "3" ||
          this.smsSettingInfo.reception.value == "4" ||
          this.smsSettingInfo.reception.value == "5" ||
          this.smsSettingInfo.reception.value == "6"
        ) {
          axios
            .post(
              Values.serverIp +
                "FreezEyeV5DeviceSetting/GetSmsReceiversSettingValue",
              {
                deviceId: this.deviceId,

                // sms
                temperatureAlarmLevelSensor1High: 0,
                temperatureAlarmLevelSensor1Low: 0,
                temperatureAlarmLevelSensor2High: 0,
                temperatureAlarmLevelSensor2Low: 0,
                temperatureAlarmLevelSensor3High: 0,
                temperatureAlarmLevelSensor3Low: 0,
                humidityAlarmLevelSensor1High: 0,
                humidityAlarmLevelSensor1Low: 0,
                humidityAlarmLevelSensor2High: 0,
                humidityAlarmLevelSensor2Low: 0,
                humidityAlarmLevelSensor3High: 0,
                humidityAlarmLevelSensor3Low: 0,

                receiver: this.smsSettingInfo.reception.value,
                simCartNumber: this.smsSettingInfo.phoneNumber,

                temperatureHighLimitSmsTimer: 0,
                temperatureLowLimitSmsTimer: 0,
                humidityHighLimitSmsTimer: 0,
                humidityLowLimitSmsTimer: 0,
                powerDisconnectSmsTimer: 0,
                sensorDisconnectSmsTimer: 0,

                smsActive: this.smsSettingInfo.active,
                smsText: this.smsSettingInfo.textSms,
                smsBeatSend: this.smsSettingInfo.puls,
              }
            )
            .then((response) => {
              if (response.status == 200) {
                //console.log(response.data);
                this.smsSettingInfo.updateTime =
                  response.data.smsInformationLastUpdateDateTimeJalali;

                // this.settingValues[0].alarmUp =
                //   response.data.temperatureAlarmLevelSensor1High;

                // this.settingValues[0].alarmDown =
                //   response.data.temperatureAlarmLevelSensor1Low;
                // this.settingValues[1].alarmUp =
                //   response.data.temperatureAlarmLevelSensor2High;

                // this.settingValues[1].alarmDown =
                //   response.data.temperatureAlarmLevelSensor2Low;
                // this.settingValues[2].alarmUp =
                //   response.data.temperatureAlarmLevelSensor3High;

                // this.settingValues[2].alarmDown =
                //   response.data.temperatureAlarmLevelSensor3Low;
                // this.settingValues[3].alarmUp =
                //   response.data.humidityAlarmLevelSensor1High;
                // this.settingValues[3].alarmDown =
                //   response.data.humidityAlarmLevelSensor1Low;
                // this.settingValues[4].alarmUp =
                //   response.data.humidityAlarmLevelSensor2High;
                // this.settingValues[4].alarmDown =
                //   response.data.humidityAlarmLevelSensor2Low;
                // this.settingValues[5].alarmUp =
                //   response.data.humidityAlarmLevelSensor3High;
                // this.settingValues[5].alarmDown =
                //   response.data.humidityAlarmLevelSensor3Low;

                this.setRecieption(response.data.receiver, "sms");
                this.smsSettingInfo.phoneNumber = response.data.simCartNumber;

                this.smsSettingInfo.timeMaxTemp =
                  response.data.temperatureHighLimitSmsTimer;
                this.smsSettingInfo.timeMinTemp =
                  response.data.temperatureLowLimitSmsTimer;
                this.smsSettingInfo.timeMaxHum =
                  response.data.humidityHighLimitSmsTimer;
                this.smsSettingInfo.timeMinHum =
                  response.data.humidityLowLimitSmsTimer;
                this.smsSettingInfo.timeDisPower =
                  response.data.powerDisconnectSmsTimer;
                this.smsSettingInfo.timeDisSensor =
                  response.data.sensorDisconnectSmsTimer;

                this.smsSettingInfo.active = response.data.smsActive;
                this.smsSettingInfo.textSms = response.data.smsText;
                this.smsSettingInfo.puls = response.data.smsBeatSend;
              } else {
                // modal unsuccessful edit change
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                (this.alertModalColor = "warning"),
                  (this.alertModalButtonText = "تایید");
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          $(".needs-validationSms > .multiselect__tags").css(
            "border-color",
            "red"
          );
          this.alert = true;
          this.alertText = "خطا!!! لطفا گیرنده پیام را انتخاب نمایید.";
        }
      } else if (whichSetting == "smsTemp") {
        if (
          this.smsSettingInfo.receptionTemp.value == "1" ||
          this.smsSettingInfo.receptionTemp.value == "2" ||
          this.smsSettingInfo.receptionTemp.value == "3" ||
          this.smsSettingInfo.receptionTemp.value == "4" ||
          this.smsSettingInfo.receptionTemp.value == "5" ||
          this.smsSettingInfo.receptionTemp.value == "6"
        ) {
          axios
            .post(
              Values.serverIp +
                "FreezEyeV5DeviceSetting/GetTemperatureSensorsAlarmSmsLimitValue",
              {
                deviceId: this.deviceId,

                // sms
                temperatureAlarmLevelSensor1High: 0,
                temperatureAlarmLevelSensor1Low: 0,
                temperatureAlarmLevelSensor2High: 0,
                temperatureAlarmLevelSensor2Low: 0,
                temperatureAlarmLevelSensor3High: 0,
                temperatureAlarmLevelSensor3Low: 0,
                humidityAlarmLevelSensor1High: 0,
                humidityAlarmLevelSensor1Low: 0,
                humidityAlarmLevelSensor2High: 0,
                humidityAlarmLevelSensor2Low: 0,
                humidityAlarmLevelSensor3High: 0,
                humidityAlarmLevelSensor3Low: 0,

                receiver: this.smsSettingInfo.receptionTemp.value,
                simCartNumber: this.smsSettingInfo.phoneNumber,

                temperatureHighLimitSmsTimer: 0,
                temperatureLowLimitSmsTimer: 0,
                humidityHighLimitSmsTimer: 0,
                humidityLowLimitSmsTimer: 0,
                powerDisconnectSmsTimer: 0,
                sensorDisconnectSmsTimer: 0,

                smsActive: this.smsSettingInfo.active,
                smsText: this.smsSettingInfo.textSms,
                smsBeatSend: this.smsSettingInfo.puls,
              }
            )
            .then((response) => {
              if (response.status == 200) {
                //console.log(response.data);
                this.smsSettingInfo.updateTime =
                  response.data.smsInformationLastUpdateDateTimeJalali;

                this.settingValues[0].alarmUp =
                  response.data.temperatureAlarmLevelSensor1High;

                this.settingValues[0].alarmDown =
                  response.data.temperatureAlarmLevelSensor1Low;
                this.settingValues[1].alarmUp =
                  response.data.temperatureAlarmLevelSensor2High;

                this.settingValues[1].alarmDown =
                  response.data.temperatureAlarmLevelSensor2Low;
                this.settingValues[2].alarmUp =
                  response.data.temperatureAlarmLevelSensor3High;

                this.settingValues[2].alarmDown =
                  response.data.temperatureAlarmLevelSensor3Low;

                // this.settingValues[3].alarmUp =
                //   response.data.humidityAlarmLevelSensor1High;
                // this.settingValues[3].alarmDown =
                //   response.data.humidityAlarmLevelSensor1Low;
                // this.settingValues[4].alarmUp =
                //   response.data.humidityAlarmLevelSensor2High;
                // this.settingValues[4].alarmDown =
                //   response.data.humidityAlarmLevelSensor2Low;
                // this.settingValues[5].alarmUp =
                //   response.data.humidityAlarmLevelSensor3High;
                // this.settingValues[5].alarmDown =
                //   response.data.humidityAlarmLevelSensor3Low;

                this.setRecieption(response.data.receiver, "temp");
                // this.smsSettingInfo.phoneNumber = response.data.simCartNumber;

                // this.smsSettingInfo.timeMaxTemp =
                //   response.data.temperatureHighLimitSmsTimer;
                // this.smsSettingInfo.timeMinTemp =
                //   response.data.temperatureLowLimitSmsTimer;
                // this.smsSettingInfo.timeMaxHum =
                //   response.data.humidityHighLimitSmsTimer;
                // this.smsSettingInfo.timeMinHum =
                //   response.data.humidityLowLimitSmsTimer;
                // this.smsSettingInfo.timeDisPower =
                //   response.data.powerDisconnectSmsTimer;
                // this.smsSettingInfo.timeDisSensor =
                //   response.data.sensorDisconnectSmsTimer;

                // this.smsSettingInfo.active = response.data.smsActive;
                // this.smsSettingInfo.textSms = response.data.smsText;
                // this.smsSettingInfo.puls = response.data.smsBeatSend;
              } else {
                // modal unsuccessful edit change
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                (this.alertModalColor = "warning"),
                  (this.alertModalButtonText = "تایید");
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          $(".needs-validationSms > .multiselect__tags").css(
            "border-color",
            "red"
          );
          this.alert = true;
          this.alertText = "خطا!!! لطفا گیرنده پیام را انتخاب نمایید.";
        }
      } else if (whichSetting == "smsHum") {
        if (
          this.smsSettingInfo.receptionHum.value == "1" ||
          this.smsSettingInfo.receptionHum.value == "2" ||
          this.smsSettingInfo.receptionHum.value == "3" ||
          this.smsSettingInfo.receptionHum.value == "4" ||
          this.smsSettingInfo.receptionHum.value == "5" ||
          this.smsSettingInfo.receptionHum.value == "6"
        ) {
          axios
            .post(
              Values.serverIp +
                "FreezEyeV5DeviceSetting/GetHumiditySensorsAlarmSmsLimitValue",
              {
                deviceId: this.deviceId,

                // sms
                temperatureAlarmLevelSensor1High: 0,
                temperatureAlarmLevelSensor1Low: 0,
                temperatureAlarmLevelSensor2High: 0,
                temperatureAlarmLevelSensor2Low: 0,
                temperatureAlarmLevelSensor3High: 0,
                temperatureAlarmLevelSensor3Low: 0,
                humidityAlarmLevelSensor1High: 0,
                humidityAlarmLevelSensor1Low: 0,
                humidityAlarmLevelSensor2High: 0,
                humidityAlarmLevelSensor2Low: 0,
                humidityAlarmLevelSensor3High: 0,
                humidityAlarmLevelSensor3Low: 0,

                receiver: this.smsSettingInfo.receptionHum.value,
                simCartNumber: this.smsSettingInfo.phoneNumber,

                temperatureHighLimitSmsTimer: 0,
                temperatureLowLimitSmsTimer: 0,
                humidityHighLimitSmsTimer: 0,
                humidityLowLimitSmsTimer: 0,
                powerDisconnectSmsTimer: 0,
                sensorDisconnectSmsTimer: 0,

                smsActive: this.smsSettingInfo.active,
                smsText: this.smsSettingInfo.textSms,
                smsBeatSend: this.smsSettingInfo.puls,
              }
            )
            .then((response) => {
              if (response.status == 200) {
                //console.log(response.data);
                this.smsSettingInfo.updateTime =
                  response.data.smsInformationLastUpdateDateTimeJalali;

                // this.settingValues[0].alarmUp =
                //   response.data.temperatureAlarmLevelSensor1High;

                // this.settingValues[0].alarmDown =
                //   response.data.temperatureAlarmLevelSensor1Low;
                // this.settingValues[1].alarmUp =
                //   response.data.temperatureAlarmLevelSensor2High;

                // this.settingValues[1].alarmDown =
                //   response.data.temperatureAlarmLevelSensor2Low;
                // this.settingValues[2].alarmUp =
                //   response.data.temperatureAlarmLevelSensor3High;

                // this.settingValues[2].alarmDown =
                //   response.data.temperatureAlarmLevelSensor3Low;
                this.settingValues[3].alarmUp =
                  response.data.humidityAlarmLevelSensor1High;
                this.settingValues[3].alarmDown =
                  response.data.humidityAlarmLevelSensor1Low;
                this.settingValues[4].alarmUp =
                  response.data.humidityAlarmLevelSensor2High;
                this.settingValues[4].alarmDown =
                  response.data.humidityAlarmLevelSensor2Low;
                this.settingValues[5].alarmUp =
                  response.data.humidityAlarmLevelSensor3High;
                this.settingValues[5].alarmDown =
                  response.data.humidityAlarmLevelSensor3Low;

                this.setRecieption(response.data.receiver, "hum");
                // this.smsSettingInfo.phoneNumber = response.data.simCartNumber;

                // this.smsSettingInfo.timeMaxTemp =
                //   response.data.temperatureHighLimitSmsTimer;
                // this.smsSettingInfo.timeMinTemp =
                //   response.data.temperatureLowLimitSmsTimer;
                // this.smsSettingInfo.timeMaxHum =
                //   response.data.humidityHighLimitSmsTimer;
                // this.smsSettingInfo.timeMinHum =
                //   response.data.humidityLowLimitSmsTimer;
                // this.smsSettingInfo.timeDisPower =
                //   response.data.powerDisconnectSmsTimer;
                // this.smsSettingInfo.timeDisSensor =
                //   response.data.sensorDisconnectSmsTimer;

                // this.smsSettingInfo.active = response.data.smsActive;
                // this.smsSettingInfo.textSms = response.data.smsText;
                // this.smsSettingInfo.puls = response.data.smsBeatSend;
              } else {
                // modal unsuccessful edit change
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                (this.alertModalColor = "warning"),
                  (this.alertModalButtonText = "تایید");
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          $(".needs-validationSms > .multiselect__tags").css(
            "border-color",
            "red"
          );
          this.alert = true;
          this.alertText = "خطا!!! لطفا گیرنده پیام را انتخاب نمایید.";
        }
      } else if (whichSetting == "sensor") {
        if (this.indexValueSensor.value == "") {
          $(".needs-validationSensor > .multiselect__tags").css(
            "border-color",
            "red"
          );
          this.alert = true;
          this.alertText = "خطا!!! لطفا شماره سنسور را انتخاب نمایید.";
        } else {
          this.settingValuesSensor = [];
          this.selectedSensors = [];
          for (var i = 0; i < this.fullData.carSensorTypes.length; i++) {
            if (
              this.fullData.carSensorTypes[i].values.length >=
              parseInt(this.indexValueSensor.value)
            ) {
              this.selectedSensors.push({
                name: this.fullData.carSensorTypes[i].sensorTypeName,
                type: this.fullData.carSensorTypes[i].sensorType,
              });

              this.settingValuesSensor.push({
                sensorType: this.fullData.carSensorTypes[i].sensorType,
                validHighLimit: 0,
                validLowLimit: 0,
                alarmHighLimit: 0,
                alarmLowLimit: 0,
                calibration: 0,
              });
            }
          }
          axios
            .post(
              Values.serverIp +
                "FreezEyeV5DeviceSetting/GetSensorsSettingValue",
              {
                deviceId: this.deviceId,
                // sensor
                sensorIndex: this.indexValueSensor.value,
                sensorTypeRegister: this.typeValue.value,
                sensorEnable: this.activeSensor,

                sensorValuesList: this.settingValuesSensor,
              }
            )
            .then((response) => {
              if (response.status == 200) {
                //console.log(response.data);
                this.sensorUpdateTime =
                  response.data.sensorInformationLastUpdateDateTimeJalali;
                this.indexValueSensor.value = response.data.sensorIndex;
                this.setSensorType(response.data.sensorTypeRegister);
                this.activeSensor = response.data.sensorEnable;

                this.settingValuesSensor = response.data.sensorValuesList;
              } else {
                // modal unsuccessful edit change
                this.alertModal = true;
                this.alertModalTitle = "خطایی رخ داده";
                this.alertModalText = "خطا!!! لطفا دوباره تلاش فرمایید.";
                (this.alertModalColor = "warning"),
                  (this.alertModalButtonText = "تایید");
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },

    //********************************************************************* delete device */
    deleteDevice() {
      this.alertModal = false;
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "Device/DeleteDevice",
          JSON.stringify(this.deviceId),
          config
        )
        .then((response) => {
          if (response.status == 200 && response.data == "0") {
            (this.alertModal = true),
              (this.alertModalTitle = "حذف"),
              (this.alertModalText = "حذف دستگاه با موفقیت انجام شد"),
              (this.alertModalColor = "success"),
              (this.alertModalButtonText = "تایید"),
              this.refreshTable();
          } else if (response.status == 200 && response.data == "1") {
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText = "خطا در ثبت اطلاعات در سرور.";
            this.alertModalColor = "danger";
            this.alertModalButtonText = "تایید";
          } else if (response.status == 200 && response.data == "2") {
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "این دستگاه قابل حذف نیست زیرا تخصیص داده شده است.";
            this.alertModalColor = "danger";
            this.alertModalButtonText = "تایید";
          } else {
            //console.log("in else"),
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          //console.log("in catch");
          if (response.status != 200) {
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            this.alertModalColor = "danger";
            this.alertModalButtonText = "تایید";
          }
        });
    },

    //********************************************************************* get user selected List */
    getUserSelectedList() {
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "User/GetDualBoxSelectedUserList",
          JSON.stringify(this.usersGroupId),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            this.selectedList = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //********************************************************************* assign Users To Group */
    assignUsersToGroup() {
      axios
        .post(Values.serverIp + "User/AddUsersGroup", {
          UsersGroupId: this.usersGroupId,
          UsersId: this.selectedList,
        })
        .then((response) => {
          if (response.status == 200) {
            this.assignModal = false;

            // modal successfuly
            (this.alertModal = true),
              (this.alertModalTitle = "تغییرات"),
              (this.alertModalText = "تغییرات با موفقیت انجام شد."),
              (this.alertModalColor = "success"),
              (this.alertModalButtonText = "تایید"),
              this.refreshTable();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //********************************************************************* make form to default mode */
    restoreDefault() {
      // make all part to enabled
      $(".form-check, .form-control-file, .form-control").attr(
        "disabled",
        false
      );

      // clear all red borders
      $(".form-control, .needs-validation > .multiselect__tags").removeAttr(
        "style"
      );

      $(".form-control, .needs-validationSms > .multiselect__tags").removeAttr(
        "style"
      );

      $(
        ".form-control, .needs-validationSensor > .multiselect__tags"
      ).removeAttr("style");

      this.disableMultiselect = false;

      //info
      this.info = {
        id: "",
        name: "",
        serial: "",
        status: { label: "", value: 4 },
        description: "",
        ModelValue: [],
        // networkValue: [],
        // defaultNetworkValue: [{ label: "", value: 0 }],
        networkValue: [{ label: "Ethernet", value: 1 }],
        defaultNetworkValue: { label: "Ethernet", value: 1 },
        password: "",
        startDelay: 0,
        simcardNum: "",
        eigthSensor: "8",
        seventhSensor: "7",
        sixthSensor: "6",
        fifthSensor: "5",
        forthSensor: "4",
        thirdSensor: "3",
        secondSensor: "2",
        firstSensor: "1",
        gprsIpAddress: "127.0.0.1",
        wifiIpAddress: "127.0.0.1",
        ethernetIpAddress: "127.0.0.1",
        gprsPortAddress: 3242,
        wifiPortAddress: 3242,
        ethernetPortAddress: 3242,
        FdaWebServiceAddress: "",
        FdaSensorId1: "",
        FdaRoomId: "",
        FdaBranchId: "",
        periodicUpdateTimeValue: [{ label: "غیرفعال", value: 0 }],
        currentKilometer: 0,
        registrationPlate1: "",
        registrationPlate2: "",
        registrationPlate3: "",
        registrationPlate4: "",
        driver: "",
        deviceType: [{ label: "ثابت", value: false }],
        dailyReportSend: [{ label: "فعال", value: true }],

        FdaSensorId1: "1",
        FdaSensorId2: "2",
        FdaSensorId3: "3",
        FdaSensorId4: "4",
        FdaSensorId5: "5",
        FdaSensorId6: "6",
        FdaSensorId7: "7",
        FdaSensorId8: "8",
      };

      this.smsReception = {
        first: "",
        second: "",
        third: "",
        forth: "",
        fifth: "",
        sixth: "",
        updateTime: "---",
      };

      //icon
      (this.selectedIcon = "fa fa-car"),
        // this.info.id = "";
        // this.info.name = "";
        // this.info.serial = "";
        // this.info.status = { label: "", value: "" };
        // this.info.description = "";
        // this.info.ModelValue = [];
        // this.info.networkValue = [];
        // this.info.defaultNetworkValue = [];
        // this.info.periodicUpdateTimeValue = [];

        // this.info.gprsIpAddress = "";
        // this.info.wifiIpAddress = "";
        // this.info.ethernetIpAddress = "";
        // this.info.ethernetPortAddress = "";
        // this.info.gprsPortAddress = "";
        // this.info.wifiPortAddress = "";

        // this.info.password = "";
        // this.selectedParent = "";
        // this.info.startDelay = "";

        // this.info.thirdSensor = "";
        // this.info.secondSensor = "";
        // this.info.firstSensor = "";

        //geo
        (this.markerLatLng = [0, 0]);

      //simcard
      this.simcard.simCardNum = "";
      this.simcard.sendSmsStatus = false;
      this.simcard.simcardDataStatus = false;
      this.SimcardOprator = [];
      this.SimcardType = [];
      this.simcardUpdateTime = "";

      //wifi
      this.wifi.ipAddress = "";
      this.wifi.subnetMask = "";
      this.wifi.gateway = "";
      this.wifi.dns = "";
      this.wifi.ssid = "";
      this.wifi.password = "";
      this.wifi.active = false;
      this.wifi.updateTime = "---";

      //ethernet
      this.ethernet.ipAddress = "";
      this.ethernet.subnetMask = "";
      this.ethernet.gateway = "";
      this.ethernet.dns = "";
      this.ethernet.updateTime = "---";

      //serial Number
      this.serial = { serialTime: "", serialNumber: "" };

      //server Ip
      this.serverInfo.ipAddressGPRS = "";
      this.serverInfo.ipAddressWiFi = "";
      this.serverInfo.ipAddressEthernet = "";
      this.serverInfo.port = "";
      this.serverInfo.timeDistance = "";
      this.serverInfo.debugSystem = false;
      this.serverInfo.debugGsm = false;
      this.serverInfo.debugWifi = false;
      this.serverInfo.wifi = false;
      this.serverInfo.ethernet = false;
      this.serverInfo.gprs = false;
      this.serverInfo.updateTime = "---";

      //voice alarm
      this.voiceAlarmInfo.delay = "";
      this.voiceAlarmInfo.length = "";
      this.voiceAlarmInfo.voiceTemp = false;
      this.voiceAlarmInfo.smsTemp = false;
      this.voiceAlarmInfo.voiceHum = false;
      this.voiceAlarmInfo.smsHum = false;
      this.voiceAlarmInfo.updateTime = "---";

      //puls
      this.pulsInfo.first = "";
      this.pulsInfo.second = "";
      this.pulsInfo.updateTime = "---";

      this.dateTime = { dateTime: "", updateTime: "" };

      // sms
      this.settingValues = [];
      // this.settingValues[0].alarmUp = "";
      // this.settingValues[0].alarmDown = "";
      // this.settingValues[1].alarmUp = "";
      // this.settingValues[1].alarmDown = "";
      // this.settingValues[2].alarmUp = "";
      // this.settingValues[2].alarmDown = "";
      // this.settingValues[3].alarmUp = "";
      // this.settingValues[3].alarmDown = "";
      // this.settingValues[4].alarmUp = "";
      // this.settingValues[4].alarmDown = "";
      // this.settingValues[5].alarmUp = "";
      // this.settingValues[5].alarmDown = "";

      this.smsSettingInfo.reception = {
        value: "1",
        label: "گیرنده اول",
      };
      this.smsSettingInfo.receptionTemp = {
        value: "1",
        label: "گیرنده اول",
      };
      this.smsSettingInfo.receptionHum = {
        value: "1",
        label: "گیرنده اول",
      };
      //this.settingValues = [];
      this.smsSettingInfo.phoneNumber = "";

      this.smsSettingInfo.timeMaxTemp = "";
      this.smsSettingInfo.timeMinTemp = "";
      this.smsSettingInfo.timeMaxHum = "";
      this.smsSettingInfo.timeMinHum = "";
      this.smsSettingInfo.timeDisPower = "";
      this.smsSettingInfo.timeDisSensor = "";
      this.smsSettingInfo.active = false;
      this.smsSettingInfo.textSms = false;
      this.smsSettingInfo.puls = false;
      this.smsSettingInfo.updateTime = "---";

      // sensor
      this.indexValueSensor = { label: "", value: "" };
      this.typeValue = [];
      this.activeSensor = false;
      this.selectedSensors = [];

      this.settingValuesSensor = [];
      this.sensorUpdateTime = "";

      // disable alet
      this.alert = false;
    },

    //********************************************************************* set Device Status Value */
    setDeviceStatusValue(data) {
      for (var i = 0; i < this.StatusList.length; i++) {
        if (this.StatusList[i].value == data) {
          this.info.status.label = this.StatusList[i].label;
          this.info.status.value = this.StatusList[i].value;
        }
      }
    },

    //********************************************************************* set Model Value */
    setModelValue(data) {
      for (var i = 0; i < this.ModelList.length; i++) {
        if (this.ModelList[i].value == data) {
          this.info.ModelValue = this.ModelList[i];
        }
      }
    },

    //********************************************************************* set daily  report Value */
    setDailayReportValue(data) {
      for (var i = 0; i < this.dailyReportSendList.length; i++) {
        if (this.dailyReportSendList[i].value == data) {
          this.info.dailyReportSend = this.dailyReportSendList[i];
          // this.info.dailyReportSend.value = this.dailyReportSendList[i].value;
        }
      }
    },

    //********************************************************************* set Network Value */
    setNetworkValue(data) {
      //console.log(data);
      this.info.networkValue = [];
      //var obj = {};
      for (var i = 0; i < this.networkList.length; i++) {
        if (data.includes(this.networkList[i].value)) {
          // obj["label"] = this.networkList[i].label;
          // obj["value"] = this.networkList[i].value;
          this.info.networkValue.push({
            label: this.networkList[i].label,
            value: this.networkList[i].value,
          });
          //this.info.networkValue = this.networkList[i];
        }
      }
    },

    //********************************************************************* set default Network Value */
    setDefaultNetworkValue(data) {
      for (var i = 0; i < this.networkList.length; i++) {
        if (this.networkList[i].value == data) {
          this.info.defaultNetworkValue.label = this.networkList[i].label;
          this.info.defaultNetworkValue.value = this.networkList[i].value;
        }
      }
    },

    //********************************************************************* set default Network Value */
    setperiodicUpdateTimeValue(data) {
      for (var i = 0; i < this.periodicUpdateTime.length; i++) {
        if (this.periodicUpdateTime[i].value == data) {
          this.info.periodicUpdateTimeValue = this.periodicUpdateTime[i];
        }
      }
    },

    //********************************************************************* set Sensor Index Name */
    setSensorIndexName(data) {
      console.log(data);
      if (data.length == 3) {
        this.info.firstSensor = data[0].sensorName;
        this.info.secondSensor = data[1].sensorName;
        this.info.thirdSensor = data[2].sensorName;
      } else if (data.length == 1) {
        this.info.firstSensor = data[0].sensorName;
      } else if (data.length == 4) {
        this.info.firstSensor = data[0].sensorName;
        this.info.secondSensor = data[1].sensorName;
        this.info.thirdSensor = data[2].sensorName;
        this.info.forthSensor = data[3].sensorName;
      } else if (data.length == 8) {
        this.info.firstSensor = data[0].sensorName;
        this.info.secondSensor = data[1].sensorName;
        this.info.thirdSensor = data[2].sensorName;
        this.info.forthSensor = data[3].sensorName;
        this.info.fifthSensor = data[4].sensorName;
        this.info.sixthSensor = data[5].sensorName;
        this.info.seventhSensor = data[6].sensorName;
        this.info.eigthSensor = data[7].sensorName;
      } else if (data.length == 2) {
        this.info.firstSensor = data[0].sensorName;
        this.info.secondSensor = data[1].sensorName;
      }
    },

    //********************************************************************* set Simcard Oprator */
    setSimcardOprator(data) {
      for (var i = 0; i < this.SimcardOpratorList.length; i++) {
        if (this.SimcardOpratorList[i].id == data) {
          this.SimcardOprator = this.SimcardOpratorList[i];
        }
      }
    },

    //********************************************************************* set Simcard Type */
    setSimcardType(data) {
      for (var i = 0; i < this.SimcardTypeList.length; i++) {
        if (this.SimcardTypeList[i].id == data) {
          this.SimcardType = this.SimcardTypeList[i];
        }
      }
    },

    //********************************************************************* set device Type */
    setDeviceType(data) {
      for (var i = 0; i < this.deviceTypeList.length; i++) {
        if (this.deviceTypeList[i].value == data) {
          this.info.deviceType = this.deviceTypeList[i];
        }
      }
    },

    //********************************************************************* set Recieption Type */
    setRecieption(data, which) {
      for (var i = 0; i < this.receptionList.length; i++) {
        if (this.receptionList[i].id == data) {
          if (which == "sms")
            this.smsSettingInfo.reception = this.receptionList[i];
          else if (which == "temp")
            this.smsSettingInfo.receptionTemp = this.receptionList[i];
          else this.smsSettingInfo.receptionHum = this.receptionList[i];
        }
      }
    },

    //********************************************************************* set Sensor Type */
    setSensorType(data) {
      for (var i = 0; i < this.typeList.length; i++) {
        if (this.typeList[i].value == data) {
          this.typeValue = this.typeList[i];
        }
      }
    },

    //*********************** report page */
    reportPage(data) {
      //router.push({ name: "JointReport", params: { whichReport: data } });

      let routeData = this.$router.resolve({
        name: "JointReport",
        query: { whichReport: data },
      });
      window.open(routeData.href, "_blank");
    },

    //********************************************************************* sensor setting */
    sensorSetting(data) {
      this.selectedSensorList = data.values;
      this.selectedSensorTypeId = data.sensorType;
    },

    //********************************************************************* datatable sensor View action */
    viewActionSensor(data, dataName, date) {
      router.push({
        name: "OnlineChart",
        params: {
          serialNumber: this.deviceId,
          sensorType: this.selectedSensorTypeId,
          sensorIndex: data,
          sensorName: dataName,
          sensorDate: date.substring(0, 10),
        },
      });
      //this.$router.push({ name: 'OnlineChart' })
      //console.log(data);
    },

    //********************************************************************* datatable sensor Edit action */
    settingActionSensor() {
      router.push({
        name: "SensorSetting",
        params: {
          serialNumber: this.SensorList.deviceId,
          // sensorType: this.selectedSensorTypeId,
          // sensorIndex: data,
        },
      });
    },

    //*************************************** create table sensor */
    createTableSensor(data) {
      this.settingValuesSensor = [];
      this.selectedSensors = [];
      for (var i = 0; i < this.fullData.carSensorTypes.length; i++) {
        if (
          this.fullData.carSensorTypes[i].values.length >= parseInt(data.value)
        ) {
          this.selectedSensors.push({
            name: this.fullData.carSensorTypes[i].sensorTypeName,
            type: this.fullData.carSensorTypes[i].sensorType,
          });

          this.settingValuesSensor.push({
            sensorType: this.fullData.carSensorTypes[i].sensorType,
            validHighLimit: "",
            validLowLimit: "",
            alarmHighLimit: "",
            alarmLowLimit: "",
            calibration: "",
          });
        }
      }
      this.refreshDeviceSetting("sensor");
    },
    // ************************************** set index list
    setIndexList(data) {
      this.indexListSensor = [];
      var tempMaxLength = data.carSensorTypes[0].values.length;
      for (var i = 0; i < data.carSensorTypes.length; i++) {
        if (data.carSensorTypes[i].values.length > tempMaxLength)
          tempMaxLength = data.carSensorTypes[i].values.length;
      }
      for (var i = 0; i < tempMaxLength; i++) {
        this.indexListSensor.push({
          label: "سنسور" + data.carSensorTypes[0].values[i].sensorIndexName,
          value: i + 1,
        });
      }
      this.indexValueSensor = this.indexListSensor[0];
      this.autoRefreshSettingValue2();
    },

    //******************************************** auto Refresh Setting Value */
    async autoRefreshSettingValue() {
      // We need to wrap the loop into an async function for this to work

      //console.log("start...");
      while (this.settingModal) {
        this.refreshDeviceSetting("wifi");
        this.refreshDeviceSetting("ethernet");
        this.refreshDeviceSetting("server");
        this.refreshDeviceSetting("simcard");
        this.refreshDeviceSetting("voiceAlarm");
        this.refreshDeviceSetting("puls");
        this.refreshDeviceSetting("dateTime");
        this.refreshDeviceSetting("serial");
        this.refreshDeviceSetting("sms");
        this.refreshDeviceSetting("sensor");
        this.refreshDeviceSetting("startDelay");
        this.refreshDeviceSetting("serial");

        await this.sleep(120000); // then the created Promise can be awaited}}
      }
    },

    //**************second auto */
    autoRefreshSettingValue2() {
      this.refreshDeviceSetting("wifi");
      this.refreshDeviceSetting("ethernet");
      this.refreshDeviceSetting("server");
      this.refreshDeviceSetting("simcard");
      this.refreshDeviceSetting("voiceAlarm");
      this.refreshDeviceSetting("puls");
      this.refreshDeviceSetting("dateTime");
      this.refreshDeviceSetting("serial");

      this.refreshDeviceSetting("sms");
      this.refreshDeviceSetting("sensor");
      this.refreshDeviceSetting("startDelay");
      this.refreshDeviceSetting("serial");
    },

    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    //***************************************************************** */
    setFillter(node) {
      // this.selectedParent = node.model.id;
      console.log(this.devices);

      this.devicesFelltered = this.devices.filter(function (el) {
        return el.organizationIdTree.includes(" " + node.model.id + " ");
        //el.statusId.includes(tempIds)
      });

      this.fillterActive = true;

      //console.log(this.devicesFelltered);
    },
  },
};
</script>

<style lang="css">
/* time picker style (start) */
.clock-picker__input {
  border: 1px solid gainsboro;
}
.clock-picker__input--error,
.clock-picker__input--error.clock-picker__input--has-value {
  color: #f44336;
}
.clock-picker__input--error .clock-picker__input,
.clock-picker__input--error.clock-picker__input--has-value
  .clock-picker__input {
  border-color: #f44336;
}
.clock-picker__input--has-value .clock-picker__input {
  border-color: #bec0c0;
}
.clock-picker__button {
  background: none;
  width: 24px;
  height: 24px;
  display: inline-block;
  border: 0;
  border-radius: 12px;
  line-height: 24px;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: #757575;
  font-weight: 500;
  font-size: 13px;
}
.clock-picker__button:hover {
  background-color: #f5f5f5;
}
.clock-picker__button:active {
  background-color: #ededed;
}
.clock-picker__button:focus {
  background-color: #e8e8e8;
}
.clock-picker__button--active,
.clock-picker__button--active:active,
.clock-picker__button--active:hover,
.clock-picker__button--active:focus {
  background-color: #a48bd1;
  color: #fff;
}
.clock-picker__button[disabled] {
  opacity: 0.4 !important;
  cursor: default;
}
.clock-picker__button[disabled],
.clock-picker__button[disabled]:active,
.clock-picker__button[disabled]:hover,
.clock-picker__button[disabled]:focus {
  background-color: #f5f5f5;
  color: #757575;
}

.clock-picker__dialog {
  display: none;
}
.clock-picker__dialog--active {
  display: block;
}
.clock-picker__dialog-drop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 200;
}
.clock-picker__dialog-body {
  direction: ltr;
  position: fixed;
  top: 50%;
  left: 50%;
  max-width: 100%;
  max-height: 100%;
  overflow: auto;
  width: 320px;
  margin: -235px -160px;
  background-color: #fff;
  z-index: 201;
  transform: scale(1);
  border-radius: 5px;
  overflow: auto;
}
.clock-picker__dialog-header {
  padding: 1.5rem 1.5rem;
  font-size: 2rem;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.clock-picker__dialog-header span:hover,
.clock-picker__dialog-header span:focus {
  cursor: pointer;
}
.clock-picker__dialog-content {
  position: relative;
  width: 100%;
  height: 280px;
  margin-top: 24px;
  margin-bottom: 24px;
}
.clock-picker__dialog-content .clock-picker__hours,
.clock-picker__dialog-content .clock-picker__minutes {
  position: absolute;
}
.clock-picker__dialog-actions {
  direction: rtl;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: row;
  flex-direction: row;
  border-top: 1px solid #f5f5f5;
  padding: 0.5rem;
}
.clock-picker__dialog-action {
  padding: 0 1rem;
  margin: 0;
  background: transparent;
  border: 0;
  -ms-flex: 1;
  flex: 1;
  font-size: 16px;
  font-weight: 500;
  line-height: 32px;
  display: inline-block;
  cursor: pointer;
}
.clock-picker__dialog-action:hover {
  background-color: #f5f5f5;
}
.clock-picker__dialog-action:focus {
  background-color: #ededed;
}
.clock-picker__dialog-action:active {
  background-color: #e6e6e6;
}
.clock-picker__dialog-action[disabled] {
  background-color: #f5f5f5;
  color: #e6e6e6;
}
.clock-picker__dialog-action[disabled]:hover,
.clock-picker__dialog-action[disabled]:focus,
.clock-picker__dialog-action[disabled]:active {
  cursor: not-allowed;
}
.clock-picker__dialog .scale-enter-active,
.clock-picker__dialog .scale-leave-active,
.clock-picker__dialog .fade-enter-active,
.clock-picker__dialog .fade-leave-active {
  transition: all 0.3s ease;
}
.clock-picker__dialog .scale-enter,
.clock-picker__dialog .scale-leave-active {
  opacity: 0;
  transform: scale(0);
}
.clock-picker__dialog .fade-enter,
.clock-picker__dialog .fade-leave-active {
  opacity: 0;
}

.clock-picker__hours {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 280px;
}

.clock-picker__minutes {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 280px;
}

/* add by alireza */
.clock-picker__input {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.25rem;
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

.clock-picker__dialog-action[type="button"] {
  color: #39f !important;
}
.clock-picker__dialog-header {
  background-color: #39f !important;
}
/* time picker style (end) */
</style>

